/* eslint-disable no-useless-concat */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect, useRef} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import {getDetailContract, getPaymentSO, getSODetailContract} from '../../../api/modules/so'
import {createSO, getAccesses} from '../../../api/modules/so'
import {getApproved, getApprovedSearch} from '../../../api/modules/kontrak'
import Country from '../component/DataCountry.json'
import {
  getProvince2,
  getProvince3,
  getTOPAnper,
  getTOPCust,
  getFindocDataTable,
  getFindocDataTableSearch,
  getSloc,
  getIncoterm,
  getSalesArea,
  getPayment,
  getEndUser,
  getSalesOfficeList,
  getAllPaymentList,
  getProductType,
  getProductName,
  getRoute,
} from '../../../api/modules/getdatalist'
import {getCustomer} from '../../../api/modules/findoc'
import {getAllTransport, getPPN, getDetailFileConfig} from '../../../api/modules/master-data/master'
import {
  getCusGrup,
  getAccAssSO,
  getFilterCity,
  getRoleFlagList,
  getConfigLetter,
  getBatasTanggalLetter,
} from '../../../api/modules/master-data/master_2'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import CustomUseEffect from './CustomUseEffect'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import axios from 'axios'
import Pagination from '../component/Pagination'
import {getPlant2} from '../../../api/modules/getdatalist'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import {Spinner} from 'react-bootstrap'
import i18next from 'i18next'
import Select from 'react-select'
import CurrencyInput from 'react-currency-input-field'
import InputGroup from 'react-bootstrap/InputGroup'
import AddRemoveJadwal from '../si/AddRemoveJadwal'
import {MultiSelect} from 'react-multi-select-component'
import {ViewLetter} from '../../../components/Letter/ViewLetter'
import {PopoverText} from '../../../components/Popover/Popover'
import {TableBrowseSIP} from './TableBrowseSIP'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {
  addOrderItem,
  delOrderItem,
  putOrderItem,
  setOrderItem,
  setOrderItems,
  soSelector,
  removeOrderItem,
} from '../../../redux/slices/soSlices'
import {TextInputV2} from '../../../components/TextInputV2'
import {TableBrowseCustomer} from './TableBrowseCustomer'
import {authSelector} from 'src/redux/slices/authSlices'
import {HakAkses} from 'src/components/mikro/getHakAkses'
import {TOrderSubDetail} from 'src/redux/types'
import {RichText} from 'src/components'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {TIncontermCode, disableRouteByIncoterm} from 'src/utils/disableRouteByIncoterm'
import dateformat from 'src/utils/dateformat'
import getCurrentFormattedDate from 'src/utils/Today'
import {getForModule} from 'src/api/modules/configuration/signing'
import Skeleton from 'react-loading-skeleton'
import ReactSelect from 'react-select'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment, handleDownloadBase64 } from 'src/app/helpers/file'

const SOCreate: React.FC = () => {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const {orderItem, orderItems} = useAppSelector(soSelector)
  const {roleId} = useAppSelector(authSelector)
  const [show2, setShow2] = useState(false)
  const [show4, setShow4] = useState(false)
  const [showLetter, setShowLetter] = useState(false)
  const hakAkses = HakAkses()
  const [printoutState, setPrinoutState] = useState(false)
  const navigate = useNavigate()
  const handleShow2 = () => setShow2(true)
  const handleClose4 = () => setShow4(false)
  const handleShow4 = () => setShow4(true)

  const [showBrowseFindoc, setShowBrowseFindoc] = useState(false)

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showApprove, setShowApprove] = useState(false)
  const [accesses, setAccesses] = useState<any>()
  const [pickupDate, setPickupDate] = useState<any>(null)

  //#region
  const [fullKontrak, setFullKontrak] = useState<any[]>([])
  const [orderDetail, setOrderDetail] = useState<any[]>([])
  const [disChanel, setDisChanel] = useState<any[]>([])
  const [materialNum, setMaterialNum] = useState<any[]>([])
  const [detail2, setDetail2] = useState<any[]>([])
  const [detail, setDetail] = useState<any[]>([])
  const [kontrakid, setKontrakID] = useState('')
  const [sektor, setSektor] = useState(0)
  const [quantumSO, setQuantumSO] = useState(0)
  const [transportasi, setTransportasi] = useState('')
  const [transType, setTransType] = useState('')
  const [singleSisaQuantum, setSingleSisaQuantum] = useState(0)
  const [rencana, setRencana] = useState('')
  const [pot, setPot] = useState('')
  const [negaraCode, setNegaraCode] = useState('')
  const [negara, setNegara] = useState('')
  const [provinsi, setProvinsi] = useState('')
  const [provinsi2, setProvinsi2] = useState('')
  const [pay, setPay] = useState('')
  const [ship, setShip] = useState('')
  const [product, setProduct] = useState('')
  const [productCode, setProductCode] = useState('')
  const [spekproduk, setSpekProduk] = useState('')
  const [incoterm, setIncoterm] = useState('')
  const [incoterm2, setIncoterm2] = useState('')
  const [kuantum, setKuantum] = useState<any>()
  const [tempID, setTempID] = useState('')
  const [addedDetail, setAddedDetail] = useState<any[]>([])
  const [index, setIndex] = useState(0)
  const [showEdit, setShowEdit] = useState(false)
  const [showEdit2, setShowEdit2] = useState(false)
  const [showUpload, setShowUpload] = useState(false)
  const [selectedItem, setSelectedItem] = useState<any>({
    product_type_desc: '',
    product_type: '',
    product_spec: '',
    product_name: '',
    incoterm1: {code: ''},
    incoterm2_id: '',
    incoterm2: '',
    request_quantum: '',
    id: '',
    plant: '',
    plant_desc: '',
  })

  const [uploadType, setUploadType] = useState('')
  const [custCode, setCustCode] = useState('')
  const [files, setFiles] = useState({file: null})
  const [shipParticularFiles, setShipParticularFiles] = useState<any>(null)
  const [shipParticularName, setShipParticularName] = useState<any>()
  const [tempfiles, setTempfiles] = useState({file: null})
  const [files2, setFiles2] = useState({file: null})
  const [fileHydro, setFileHydro] = useState<any>(null)
  const [namaHydro, setNamaHydro] = useState<any>()
  const [isUpload, setIsUpload] = useState(false)
  const [fullProvince, setFullProvince] = useState<any>([])
  const [fullProvince2, setFullProvince2] = useState<any>([])
  const [SIPOrder, setSIPOrder] = useState('')
  const [fullPayment, setFullPayment] = useState([])
  const [allFindoc, setAllFindoc] = useState([])
  const [salesorg, setSalesorg] = useState('')
  const [incotermId, setIncotermId] = useState<any>(0)
  const [incotermIdDesc, setIncotermIdDesc] = useState<any>('')
  const [incotermId2, setIncotermId2] = useState('')
  const [incotermId2Desc, setIncotermId2Desc] = useState('')
  const [findoc, setFindoc] = useState('')
  const [roleUser, setRoleUser] = useState('')
  const [top, setTOP] = useState('')
  const [top2, setTOP2] = useState('')
  const [fullTOP, setFullTOP] = useState([])
  const [priceBefore, setPriceBefore] = useState<any>(0)
  const [priceAfter, setPriceAfter] = useState<any>(0)
  const [plantSelect, setPlantSelect] = useState<any>()
  const [plantSelected, setPlantSelected] = useState<any>()
  const [plantNameEn, setPlantNameEn] = useState('')
  const [plantSelectName, setPlantSelectName] = useState<any>()
  const [plantPayload, setPlantPayload] = useState<any[]>([])
  const [plantPayload2, setPlantPayload2] = useState<any[]>([])
  const [fullPlant, setFullPlant] = useState<any>([])
  const [fullRoute, setFullRoute] = useState<any>([])
  const [fullIncoterm, setFullIncoterm] = useState<any>([])
  const [selectedFindoc, setSelectedFindoc] = useState('')
  const [specPayload, setSpecPayload] = useState<any[]>([])
  const [currency, setCurrency] = useState('')
  const [showJadwal, setShowJadwal] = useState(false)
  const [namaPlant, setNamaPlant] = useState('')
  const [idPlant, setIDPlant] = useState('')
  const [routeDesc, setRouteDesc] = useState('')
  const [route, setRoute] = useState('')
  const [routePayload, setRoutePayload] = useState<any>([])
  const [routePayload2, setRoutePayload2] = useState<any>([])

  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerTitle, setCustomerTitle] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [customerPreview, setCustomerPreview] = useState('')

  const [fullSloc, setFullSloc] = useState<any[]>([])
  const [slocDesc, setSlocDesc] = useState('')
  const [sloc, setSloc] = useState('')
  const [assinger, setAssigner] = useState('')
  const [position, setPosition] = useState('')
  const [ppn, setppn] = useState(0)
  const [totalquant, setTotalquant] = useState(0)
  const [city, setCity] = useState<any>('')
  const [city2, setCity2] = useState('')
  const [fullCity, setFullCity] = useState<any>([])
  const [fullCity2, setFullCity2] = useState<any>([])
  const [sektorID, setSektorID] = useState('')
  const [orderSubID, setOrderSubID] = useState(0)
  const [regarding, setRegarding] = useState('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [productNameEn, setProductNameEn] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [assessmentHead, setAssessmentHead] = useState(0)
  const [fullTransport, setFullTransport] = useState<any>([])
  const [transType2, setTransType2] = useState('')
  const [provinsiTujuan, setProvinsiTujuan] = useState<any>('')
  const [provinsiTujuan2, setProvinsiTujuan2] = useState<any>('')
  const [tempDetail, setTempDetail] = useState<any>([])

  const [showDetail, setShowDetail] = useState(false)
  const [enduser, setEnduser] = useState('')
  const [province, setProvince] = useState(0)
  const [sisaQuantum, setSisaQuantum] = useState<any[]>([])
  const [ptype2, setPtype2] = useState('')
  const [ptype, setPtype] = useState<any>('')
  const [punit, setPunit] = useState<any>('')
  const [pname, setPname] = useState('')
  const [pnumber, setPnumber] = useState('')
  const [pspec, setPspec] = useState('')
  const [subprice, setSubprice] = useState<any>(0)
  const [quantum, setQuantum] = useState<any>(0)
  const [note, setNote] = useState('')
  const [pay1, setPay1] = useState('')
  const [pay2, setPay2] = useState('')
  const [enduserDesc, setEnduserDesc] = useState('')
  const [provinceDesc, setProvinceDesc] = useState('')
  const [cityProduct, setCityProduct] = useState<any>('')
  const [cityDesc, setCityDesc] = useState('')
  const [pay1Desc, setPay1Desc] = useState('')
  const [pay2Desc, setPay2Desc] = useState('')
  const [keterangan, setketerangan] = useState('')
  const [isNoEnduser, setIsNoEnduser] = useState(false)
  const [segment, setSegment] = useState<any>('')
  const [segmentDesc, setSegmentDesc] = useState<any>('')
  const [fullProductName, setFullProductName] = useState<any[]>([])
  const [fullEndUser, setFullEndUser] = useState<any[]>([])
  const [fullSegment, setFullSegment] = useState<any[]>([])
  const [showAddProduct, setShowAddProduct] = useState(false)
  const [addedProduct, setAddedProduct] = useState<any[]>([])
  // const [ppn2, setPPN2] = useState<any>(0)
  const [totalPriceProductBefore, setTotalPriceProductBefore] = useState<any>(0)
  const [totalPriceProductAfter, setTotalPriceProductAfter] = useState<any>(0)
  const [totalQuantumProduct, setTotalQuantumProduct] = useState<any>(0)
  const [fullCustomer, setFullCustomer] = useState<any[]>([])
  const [showCustomer, setShowCustomer] = useState(false)
  // const [shipto, setShipTo] = useState(false)
  const [customer, setCustomer] = useState<any>('')
  const [customerID, setCustomerID] = useState<any>('')
  const [shipping, setShipping] = useState<any>(0)
  const [taking, setTaking] = useState(0)
  const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]
  const [daysInMonth, setDaysInMonth] = useState(0)
  const [tempMinggu, setTempMinggu] = useState(0)
  const [tempTanggal, setTempTanggal] = useState(0)
  const [tempBulan, setTempBulan] = useState(0)
  const [tempTahun, setTempTahun] = useState(0)
  const [tempTon, setTempTon] = useState(0)
  const [listYear, setListYear] = useState<any[]>([])
  const [allJadwal, setAllJadwal] = useState<any[]>([])
  const [editedIndex, setEditedIndex] = useState<any>()
  const [tempData, setTempData] = useState({
    schedules: [],
    attachments: [],
  })
  const [day, setDay] = useState<any>(0)
  const [month, setMonth] = useState<any>(0)
  const [year, setYear] = useState<any>(0)
  const [dateNow, setDateNow] = useState('')
  const [showJadwal2, setShowJadwal2] = useState(false)
  const [files3, setFiles3] = useState<any>()
  const [fileHeader, setFileHeader] = useState<any>([])
  const [orderItemFiles, setOrderItemsFiles] = useState<any[]>([])
  const [showUpload3, setShowUpload3] = useState(false)
  const [totalPcs, setTotalPcs] = useState(0)
  const [totalPcsProduct, setTotalPcsProduct] = useState(0)
  const [tipeProduct, setTipeProduct] = useState('')
  const [unitProduct, setUnitProduct] = useState('')
  const [nomorKontrak, setNomorKontrak] = useState<any>('')
  const [leftoverArray, setLeftoverArray] = useState<any>([])
  const [leftoverIndex, setLeftoverIndex] = useState<any>(0)
  const [totalbatas, setTotalBatas] = useState<any>(0)
  const [totalbatasnonst, setTotalBatasNonST] = useState<any>(0)
  const [sisa, setSisa] = useState<any>(0)
  const [sisanost, setSisaNoST] = useState<any>(0)
  const [payloadAttachement, setPayloadAttachment] = useState<any>([])
  const [pph22, setPPH22] = useState<any>(0)
  const [isFileBox, setIsFileBox] = useState(false)
  const [shippingTolerance, setShippingTolerance] = useState('')
  const [shippingToleranceContract, setShippingToleranceContract] = useState('')
  const [kuantumSORilis, setKuantumSoRilis] = useState('')
  const [soNotes, setSoNotes] = useState('')
  const [signingPayload, setSigningPaylod] = useState({
    module: 'SO',
    sector_id: '',
    total_quantum: 0,
    province_id: '',
    city_id: '',
    sales_org_code: '',
    product_type: ''
  })
  //#endregion

  const clearStateJadwal = () => {
    setTempTanggal(0)
    setTempBulan(0)
    setTempTahun(0)
    setTempTon(0)
    setEditedIndex(null)
  }

  const clearInputJadwal = () => {
    const input1 = document.getElementById('jadwalminggu') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('jadwalbulan') as HTMLSelectElement
    input2.selectedIndex = 0
    const input3 = document.getElementById('jadwaltahun') as HTMLSelectElement
    input3.selectedIndex = 0
    const input4 = document.getElementById('jadwalton') as HTMLInputElement
    input4.value = ''
    const input5 = document.getElementById('jadwaltanggal') as HTMLSelectElement
    input5.selectedIndex = 0
  }

  const validasiJadwal = () => {
    if (tempTanggal == 0) return t('Tanggal ke-')
    else if (tempBulan == 0) return t('Bulan ke-')
    else if (tempTahun == 0) return t('Tahun ke-')
    else if (tempTon == 0) return t('Tonnage')
    else return 'nothing'
  }

  useEffect(() => {
    if (tempTahun != 0 && tempBulan != 0) setDaysInMonth(getDaysInMonth(tempTahun, tempBulan))
  }, [tempTahun, tempBulan])

  function getDaysInMonth(year: any, month: any) {
    return new Date(year, month, 0).getDate()
  }

  function loopTanggal(jumlah: any) {
    var indents = []
    for (let i = 0; i < jumlah; i++) {
      indents.push(<option value={i + 1}>{i + 1}</option>)
    }
    return indents
  }

  const handleJadwal = (item: any) => {
    setTempData(item)
    setAllJadwal(item?.schedules)
    if (item?.schedules?.length == undefined) {
      setTaking(0)
    } else {
      setTaking(item?.schedules?.length)
    }

    setShowJadwal2(true)
  }

  const checktaking = () => {
    let temp: any[] = tempData?.schedules
    let tempindex = 0

    if (temp == null) tempindex = 0
    else tempindex = temp.length

    if (tempTahun > year + 1) return 'Tahun tidak boleh melebihi tahun ini'

    if (tempTanggal > getDaysInMonth(tempTahun, tempBulan)) return 'Tanggal melebihi'

    if (tempindex != 0) {
      if (temp[tempindex - 1].year <= tempTahun) {
        if (temp[tempindex - 1].year < tempTahun) {
          if (tempTahun == year) {
            if (tempBulan == month) {
              if (tempTanggal >= day) return 'nothing'
              else return 'Week must be greater than or equal to current week'
            } else if (tempBulan > month) return 'nothing'
            else return 'Month must be greater than or equal to current month'
          } else if (tempTahun > year) return 'nothing'
          else return 'Year must be greater than or equal to current year'
        } else if (temp[tempindex - 1].month <= tempBulan) {
          if (temp[tempindex - 1].month < tempBulan) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else if (temp[tempindex - 1].date < tempTanggal) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else return 'Week must be greater than previous week'
        } else return 'Month must be greater than previous month'
      } else return 'Year must be greater than previous year'
    } else {
      if (tempTahun == year) {
        if (tempBulan == month) {
          if (tempTanggal >= day || day > 28) return 'nothing'
          else return 'Week must be greater than or equal to current week'
        } else if (tempBulan > month) return 'nothing'
        else return 'Month must be greater than or equal to current month'
      } else if (tempTahun > year) return 'nothing'
      else return 'Year must be greater than or equal to current year'
    }
  }

  const sendJadwal = () => {
    let tempoquantum = 0
    allJadwal?.forEach((element) => {
      tempoquantum = tempoquantum + element?.tonnage
    })

    const checkMandatory = validasiJadwal()
    const CheckTaking = checktaking()
    const tempOrder: any[] = [...addedProduct]
    if (CheckTaking == 'nothing') {
      if (checkMandatory == 'nothing') {
        if (tempOrder[index2]?.request_quantum >= tempoquantum + tempTon) {
          let temp: any[] = tempData?.schedules
          let sort = tempData?.schedules?.length
          const tempobject = {
            sort: sort + 1,
            date: tempTanggal,
            month: tempBulan,
            year: tempTahun,
            tonnage: tempTon,
          }
          if (temp == null) {
            const temp2 = []
            temp2.push(tempobject)
            temp = temp2
          } else {
            temp.push(tempobject)
          }
          const temptaking = taking + 1
          setTaking(temptaking)
          tempOrder[index2].schedules = temp
          setAllJadwal(temp)
          setAddedProduct(tempOrder)
          clearInputJadwal()
          clearStateJadwal()
          // setShowJadwal(false)
        } else {
          swal({
            title: t('Melebihi Tonase!'),
            icon: 'error',
          })
        }
      } else {
        swal({
          title: t('isi') + checkMandatory,
          icon: 'error',
        })
      }
    } else {
      swal({
        title: t(CheckTaking),
        icon: 'error',
      })
    }
  }

  const hapusSchedule = (index: any) => {
    const tempOrder: any[] = [...addedProduct]
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        let temp: any[] = tempData?.schedules
        temp.splice(index, 1)
        tempOrder[index2].schedules = temp
        setEditedIndex(null)
        const temptaking = taking - 1
        setTaking(temptaking)
        setAllJadwal(temp)
        setAddedProduct(tempOrder)
        swal({
          closeOnClickOutside: false,
          title: t('deleted successfully'),
          icon: 'success',
        })
      } else return setEditedIndex(null)
    })
  }

  const rubahSchedule = (index: any, tonnage: any, tonlama: any) => {
    let tempoquantum = 0
    allJadwal?.forEach((element) => {
      tempoquantum = tempoquantum + element?.tonnage
    })
    const tempOrder: any[] = [...addedProduct]
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        if (tempTon != 0) {
          if (tempOrder[index2]?.request_quantum >= tempoquantum - tonlama + tempTon) {
            let temp: any[] = tempData?.schedules
            temp[index].tonnage = tonnage
            tempOrder[index2].schedules = temp
            setEditedIndex(null)
            setAllJadwal(temp)
            setAddedProduct(tempOrder)
            swal({
              title: `${t('jadwalBerhasilDiEdit')}`,
              icon: 'success',
            })
          } else {
            swal({
              title: t('Melebihi Tonase!'),
              icon: 'error',
            })
          }
        } else {
          swal({
            title: t('isi') + t('Tonnage'),
            icon: 'error',
          })
        }
      } else return setEditedIndex(null)
    })
  }

  const validasiFile = () => {
    if (files3 == null || files3 == '') return 'File'
    else if (description == '') return 'File Information'
    else return 'nothing'
  }

  const handleUpload2 = async () => {
    const checkvalidasi = validasiFile()
    if (checkvalidasi == 'nothing') {
      let temparray: any[] = []
      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }
      let tempObject = {
        file_r: files,
        name: namaFile,
        description: description,
        file_type: dataType,
        roles: temparray,
        private: isPrivate,
      }
      let tempArray = [...fileHeader]
      tempArray.push(tempObject)
      setFileHeader(tempArray)
      swal({
        title: `${t('document uploaded successfully')}`,
        icon: 'success',
      })
      // setShow1(false)
      removeFileState()
      clearInputUpload()
    } else {
      swal({
        title: t('isi') + checkvalidasi,
        icon: 'error',
      })
    }
  }

  const handleUpload3 = async () => {
    const checkvalidasi = validasiFile()
    if (checkvalidasi == 'nothing') {
      let temparray: any[] = []
      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }
      let tempObject = {
        file_r: files3,
        name: namaFile,
        description: description,
        file_type: dataType,
        roles: temparray,
        private: isPrivate,
      }

      if (uploadType == 'order-item') {
        let tempArray = [...addedProduct]
        let temp: any[] = tempData?.attachments
        if (temp == null) {
          const temp2 = []
          temp2.push(tempObject)
          temp = temp2
        } else {
          temp.push(tempObject)
        }
        // tempArray.push(tempObject);
        tempArray[index2].attachments = temp
        setAddedProduct(tempArray)
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        })
        // setShow1(false)
        clearInputUpload()
        removeFileState()
      } else {
        let tempArray = [...payloadAttachement]
        let temp: any[] = tempArray[index2]
        if (temp == null) {
          const temp2 = []
          temp2.push(tempObject)
          temp = temp2
        } else {
          temp.push(tempObject)
        }
        tempArray[index2] = temp
        setPayloadAttachment(tempArray)
        dispatch(setOrderItem({...orderItem, attachments: tempArray[index2]}))
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        })
        // setShow1(false)
        clearInputUpload()
        removeFileState()
      }
    } else {
      swal({
        title: t('isi') + checkvalidasi,
        icon: 'error',
      })
    }
  }

  const handleDeleteUploadHeader = (
    index: any,
    data: any,
    setData: any,
    type: any,
    datafull: any,
    setdatafull: any
  ) => {
    if (type == 'header') {
      // const tempArray = [...data]
      // console.log(tempArray)
      // tempArray.splice(index, 1)
      // setData(tempArray)
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            const tempArray = [...data]
            tempArray.splice(index, 1)
            setData(tempArray)
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
          }
        })
        .catch((err) => {
          swal({
            title: `${t('Data Failed to Delete')}`,
            icon: 'error',
          })
        })
    } else if (type == 'so-item') {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            const tempArray = [...data]
            const tempfull = datafull
            tempArray?.splice(index, 1)
            tempfull[index2] = tempArray
            setData(tempArray)
            setdatafull(tempfull)
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
          }
        })
        .catch((err) => {
          swal({
            title: `${t('Data Failed to Delete')}`,
            icon: 'error',
          })
        })
    } else {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            const tempArray = [...data]
            const tempfull = datafull
            tempArray?.splice(index, 1)
            tempfull.attachments = tempArray
            setData(tempArray)
            setdatafull(tempfull)
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
          }
        })
        .catch((err) => {
          swal({
            title: `${t('Data Failed to Delete')}`,
            icon: 'error',
          })
        })
    }
  }

  const handleUploadOrderItem = (item: any) => {
    setTempData(item)
    setOrderItemsFiles(item?.attachments)
    setUploadType('order-item')
    setShowUpload3(true)
  }

  const checkMandatory = () => {
    // if ((enduser == '' || enduser == '0') && ptype != '8105') return t('isi') + t('End User')
    if (
      ((sektorID == '1' &&
        ((arrayEnduser.length < 1 && isNoEnduser == false) ||
          (isNoEnduser == true && enduser == ''))) ||
        (sektorID == '3' && enduser == '')) &&
      ptype != '8105'
    )
      return t('isi') + t('End Customer')
    else if (province == 0) return t('isi') + t('Province')
    else if (cityProduct == 0) return t('isi') + t('City')
    else if (pnumber == '') return t('isi') + t('Product Name')
    else if ((subprice == 0 || subprice == undefined) && ptype != '8105')
      return t('isi') + t('Submission Price')
    else if (quantum == 0 || quantum == '') return t('isi') + t('Quantum')
    else if (pay1 == '') return t('isi') + t('Payment 1')
    else if (sektorID == '1' && segment == '') return t('isi') + t('segment')
    else if (shipping < 0) return t('shipping tolerance tidak boleh minus')
    else if (shipping >= 100) return t('Shipping tolerance melebihi 100%')
    else return 'nothing'
  }

  const fieldClearer = (status: any) => {
    if (status > 0) {
      const hargap = document.getElementById('hargap') as HTMLInputElement
      if (hargap != null) hargap!.value = ''
      setSubprice(0)
      const kuantum = document.getElementById('kuantum') as HTMLInputElement
      if (kuantum != null) kuantum!.value = ''
      setQuantum(0)
      const ckbox = document.getElementById('ckbox-ppn') as HTMLInputElement
      if (ckbox != null) ckbox.checked = false
      const shipping = document.getElementById('shipping') as HTMLInputElement
      if (shipping != null) shipping!.value = ''
      setShipping(0)
      if (status > 1) {
        setPname('')
        setPnumber('')
        setFullProductName([])
        if (status > 2) {
          const jenis = document.getElementById('jenis') as HTMLSelectElement
          if (jenis != null) jenis!.selectedIndex = 0
          setPtype('')
          setPtype2('')
          if (status > 3) {
            if (status > 4) {
              setCityProduct(0)
              setCityDesc('')
            }
          }
        }
      }
    } else if (status == 'province') {
      setCityDesc('')
      setCityProduct(0)
    } else if (status == 'tipe') {
      setPname('')
      setPnumber('')
    }
  }

  const getplantproduct = async (mat: any) => {
    await getPlant2(salesorg, disChanel, mat).then((res) => {
      setFullPlant(
        res.data.data.map((item: any) => {
          return {
            value: item.plant + ',' + item.plant_name,
            label: item.plant + '-' + item.plant_name,
          }
        })
      )
    })
  }

  const insertAddOrder = () => {
    const mandatoryCheck = checkMandatory()
    // console.log(mandatoryCheck)
    if (mandatoryCheck == 'nothing') {
      let enduser1: any = []
      let enduser2: any = []
      if (!isNoEnduser) {
        arrayEnduser.forEach((data: any) => {
          enduser1.push(data.value)
          enduser2.push(data.label)
        })
      } else {
        enduser1 = enduserDesc
        enduser2 = enduserDesc
      }
      let tempprice = 0
      if (subprice == '' || isNaN(parseFloat(subprice))) tempprice = 0
      else tempprice = parseFloat(subprice)
      const tempOrder = addedProduct

      let inc1 = fullIncoterm?.find((item: any) => item.label == incoterm)

      const temp = {
        sales_org_code: salesorg,
        produsen: {name: salesorgname},
        sales_org_code_desc: salesorgname,
        incoterm1_id: inc1?.value,
        incoterm1: inc1 ? {
          id: inc1?.value,
          code: inc1?.label} : null,
        incoterm1_desc: inc1?.label,
        incoterm2_id: incoterm2,
        product_type: ptype,
        product_type_desc: ptype2,
        product_name: pname,
        product_spec: pspec,
        request_price: tempprice,
        fixed_price: tempprice,
        request_quantum: parseFloat(quantum),
        fixed_quantum: parseFloat(quantum),
        shipping_tolerance: shipping,
        province_id: province,
        province: {region_name: provinceDesc},
        province_desc: provinceDesc,
        city_id: cityProduct,
        city: {city_name: cityDesc},
        city_desc: cityDesc,
        sector_id: sektorID,
        end_user: sektorID != '1' ? enduserDesc : enduser1.toString(),
        notes: note,
        material_number: pnumber,
        unit: punit,
        segment_code: segment,
        segment_name: segmentDesc,
        payment_note: keterangan,
        plant: '',
        plant_desc: '',
        sloc: '',
        sloc_description: '',
        quantity: parseFloat(quantum),
        route: '',
        route_desc: '',
        schedules: [],
        attachments: [],
        end_user_multiple: sektorID != '1' ? false : !isNoEnduser,
        payment_type_2_desc: pay2Desc,
        payment_type_1_desc: pay1Desc,
        newProduct: true,
        plant_desc_en: null
      }
      tempOrder.push(temp)
      let tempTotal = tempOrder.reduce(
        (a: any, b: any, index: any) =>
          a +
          (sektorID != '3'
            ? b.quantity * b.request_price || 0
            : b.quantity * parseFloat(b.request_price) || 0),
        0
      )
      // let temptotalppn = tempOrder.reduce(
      //   (a: any, b: any, index: any) =>
      //     a +
      //     ((ppn / 100) * (b.quantity * b.request_price) +
      //     b.quantity * b.request_price || 0),
      //   0
      // )
      let temptotalppn = tempOrder.reduce(
        (a: any, b: any, index: any) =>
          a + (b.quantity * (b.request_price + (b.request_price / 100) * ppn) || 0),
        0
      )
      let totalquantum = tempOrder.reduce(
        (a: any, b: any, index: any) => (b.product_type != '8105' ? a + (b.quantity || 0) : a + 0),
        0
      )
      let totalpcs = tempOrder.reduce(
        (a: any, b: any, index: any) => (b.product_type == '8105' ? a + (b.quantity || 0) : a + 0),
        0
      )
      setTotalQuantumProduct(totalquantum)
      setTotalPcsProduct(totalpcs)
      setTotalPriceProductBefore(tempTotal)
      setTotalPriceProductAfter(temptotalppn)
      setAddedProduct(tempOrder)

      const _signingConfig = signingPayload
      _signingConfig.total_quantum = totalquantum + totalquant
      setSigningPaylod(_signingConfig)
      loadSigningConfig()

      setShowAddProduct(false)
    } else {
      swal({
        title: mandatoryCheck,
        icon: 'error',
      })
    }
  }

  const handleCustomer = async () => {
    setCustName('')
    setCustNum('')
    setShowCustomer(true)
    // setLoadingCust(true)
    // await getCustomer(salesorg, disChanel, '', '').then((res: any) => {
    //   setFullCustomer(res.data.data.data)
    //   setNumberURL3(res.data.data.links)
    // })
    // setLoadingCust(falsde)
  }

  const [custNum, setCustNum] = useState<any>('')
  const [custName, setCustName] = useState<any>('')

  const paginateNumber3 = async (number: any) => {
    const res = await axios.get(
      `${number}&sales_org_code=&customer_code=${custNum}&name=${custName}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setFullCustomer(res.data.data.data)
    setNumberURL3(res.data.data.links)
  }

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getCustomer(salesorg, disChanel, custName, custNum).then((res: any) => {
        setFullCustomer(res.data.data.data)
        setNumberURL3(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [custName, custNum])

  // CustomUseEffect(() => {
  //   setCustomer('')
  //   setCustName('')
  //   setCustNum('')
  //   setCustomer('')
  // }, [shipto])

  const handleTambahProduct = async () => {
    clearState()
    setShowAddProduct(true)
    await getEndUser('').then((res) => {
      // console.log(res.data, ' end user')
      setFullEndUser(res.data.data)
    })

    await getCusGrup().then((res) => {
      setFullSegment(res.data.data)
    })

    await getProductType('').then((res) => {
      setFullProductType(res.data.data)
    })
  }

  const [disableCKBOX, setDisableCKBOX] = useState(false)
  const separateValue4 = (value: any, state: any, desc: any) => {
    const temp = value.split('~#~')
    state(temp[0])
    desc(temp[1])
    if (temp[0] != 0) setDisableCKBOX(true)
    else setDisableCKBOX(false)

    // console.log(temp[0], temp[1])
  }

  CustomUseEffect(() => {
    const productNameData = async () => {
      await getProductName('', disChanel, ptype, salesorg, sektorID).then((res) => {
        let temp: any[] = []
        // eslint-disable-next-line array-callback-return
        res.data.data.map((item: any) => {
          if (item.material_number != 0)
            temp.push({
              value: item.material_number + '_' + item.material_description,
              label: parseInt(item.material_number) + ' - ' +item.material_description,
              unit: item.unit,
              truevalue: parseInt(item.material_number),
            })
        })
        setFullProductName(temp)
      })
    }
    productNameData()
  }, [ptype])

  CustomUseEffect(() => {
    const getFUllSalesOffice = async () => {
      await getFilterCity(province)
        .then((res) => {
          setLoading(true)
          setFullCity2(
            res.data.data.map((item: any) => {
              return {
                value: item.id + ',' + item.value,
                label: item.value,
              }
            })
          )
        })
        .finally(() => setLoading(false))
    }

    getFUllSalesOffice()
  }, [province])

  const [tooltip, setTooltip] = useState('Open')
  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum(temp)
  }

  const [leftoverquantum, setLeftoverQuantum] = useState<any>(0)
  const [salesorgname, setSalesOrgName] = useState('')
  const [imgHeader, setImgHeader] = useState<any>()
  const [imgFooter, setImgFooter] = useState<any>()

  const getSubContract = async (id: any) => {
    clearall()
    if (id !== null) {
      handleClose4()
    }

    await getSODetailContract(id, localStorage.getItem('credential')).then(async (response) => {
      const _data = response.data.data
      const osd = response.data.data.order_sub_details
      setSalesorg(response.data.data.sales_org_code)
      getImg(response.data.data.sales_org_code)
      setSalesOrgName(response.data.data.anper.name)
      setCustomerCode(response.data.data.customer.customer_code)
      if (response.data.data.customer.customer_code.charAt(0) == '2') setAssessmentHead(2)
      else setAssessmentHead(0)
      setCustomer(
        response.data.data.customer_ship?.title == null
          ? response.data.data.customer_ship?.name
          : response.data.data.customer_ship?.title + ' ' + response.data.data.customer_ship?.name
      )
      setCustomerID(response.data.data.customer_ship?.customer_code)
      setLeftoverArray(response.data.data.left_quantum_osd)
      setPay1(response.data.data.order_sub_details[0].payment_type_1)
      setPay2(response.data.data.order_sub_details[0].payment_type_2)
      setPay1Desc(response.data.data.order_sub_details[0].payment_type_1_desc)
      setPay2Desc(response.data.data.order_sub_details[0].payment_type_2_desc)
      setDisChanel(response.data?.data?.sip_order?.pengajuan_order?.distribution_channel)
      setOrderDetail(osd)
      setDetail2(osd)
      setDetail(osd)
      const tempSisaQuantum: any[] = []
      osd.forEach((element: any) => {
        tempSisaQuantum.push({id: element.id, quantum: element.left_over_quantum})
      })
      setSisaQuantum(tempSisaQuantum)
      setRegarding(response.data.data.perihal)
      setProvinsi(response.data.data.sales_office_detail?.id)
      setProvinsi2(response.data.data.sales_office_detail?.region_name)
      setCity(response.data.data.sales_group_detail?.id)
      setCity2(response.data.data.sales_group_detail?.city_name)
      // console.log(response.data.data.customer_id)
      setCustCode(response.data.data.customer_id)
      setSIPOrder(response.data.data.sip_order_id)
      setIncotermId(response.data.data.incoterm1_id)
      setIncotermIdDesc(response.data.data.incoterm1?.code)
      setIncotermId2(response.data.data.incoterm2_id)
      setIncotermId2Desc(response.data.data.incoterm2_id)
      setAssigner(response.data.data.assigner_name)
      setPosition(response.data.data.assigner_position)
      setCustomerName(response.data.data.customer.name)
      setCustomerTitle(response.data.data.customer.title)
      setCustomerAddress(response.data.data.customer.address)
      setCustomerPreview(response.data.data.customer)
      setNomorKontrak(response.data.data.contract_number)
      setPPH22(response.data.data.pph22)
      setppn(osd[0].ppn)
      setNoExport(response.data.data.no_izin_export)
      setNegara(response.data.data.country_destination)
      setNegaraCode(response.data.data.country_destination_code)
      setProvinsiTujuan(response.data.data.province ? '00' + response.data.data.province : '')
      setProvinsiTujuan2(response.data.data.province_desc ? response.data.data.province_desc : '')
      setSektorID(response.data.data.sector_id)
      setCustPICName(response.data.data.customer_pic_name)
      setCustPICPosition(response.data.data.customer_pic_position)
      setNamaPenandatanganFinance(response.data.data.financial_assigner_name)
      setPosisiPenandatanganFinance(response.data.data.financial_assigner_position)
      setTOS(response.data.data.terms_and_conditions)
      setAttn(response.data.data.customer_attn)
      setPenutup(response.data.data.text_penutup)
      setTextKeterangan(response.data.data.keterangan)
      setNoExport(response.data.data.no_izin_export)

      setPickupDate(response.data.data.validity_date_to)
      setCustGroup(response.data.data.order_sub_details?.[0]?.segment_code)

      if (response.data.data.sector_id === 3) setCurrency('USD')
      else setCurrency('IDR')

      let _configSigning = signingPayload
      _configSigning.sector_id = _data.sector_id
      _configSigning.province_id = _data.sales_office_detail?.id
      _configSigning.city_id = _data.sales_group_detail?.id
      _configSigning.sales_org_code = _data.sales_org_code
      setSigningPaylod(_configSigning)
      loadSigningConfig()

      dispatch(setOrderItems([]))
    })
  }

  const getImg = async (sales: any) => {
    getDetailFileConfig(sales, 'kop-header').then((res) => {
      setImgHeader(res.data.data)
    })
    getDetailFileConfig(sales, 'kop-footer').then((res) => {
      setImgFooter(res.data.data)
    })
  }

  const handleLefoverObject = (idosd: any, quantity: any) => {
    let temp = leftoverArray.findIndex((item: any) => item.id == idosd)
    setLeftoverIndex(temp)
    setTotalBatas(parseFloat(leftoverArray[temp].left_over_quantum) + parseFloat(quantity))
    setTotalBatasNonST(
      parseFloat(leftoverArray[temp].left_over_quantum_no_st) + parseFloat(quantity)
    )
    setSisa(parseFloat(leftoverArray[temp].left_over_quantum))
    setSisaNoST(parseFloat(leftoverArray[temp].left_over_quantum_no_st))
  }

  const handleOpenn = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('a')) {
      icon?.classList.remove('a')
      icon?.classList.add('b')
    } else {
      icon?.classList.remove('b')
      icon?.classList.add('a')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    if (fold) {
      fold.classList.toggle('foldd-open')
    }
  }

  const [addTextLanguage, setAddTextLanguage] = useState('id')
  const [sailingDate, setSailingDate] = useState<any>('')
  const [custPICName, setCustPICName] = useState('')
  const [custPICPosition, setCustPICPosition] = useState('')
  const [namaPenandatanganFinance, setNamaPenandatanganFinance] = useState('')
  const [posisiPenandatanganFinance, setPosisiPenandatanganFinance] = useState('')
  const [portLoading, setPortLoading] = useState<any>('')
  const [textBAST, setTextBAST] = useState<any>('')
  const [textBASTEn, setTextBASTEn] = useState<any>('')
  const [salesDivision, setSalesDivision] = useState<any>('')
  const [picSalesDivision, setPicSalesDivision] = useState<any>('')
  const [transportMedia, setTransportMedia] = useState<any>('')
  const [transportMediaInfo, setTransportMediaInfo] = useState<any>('')
  const [TOS, setTOS] = useState<any>('')
  const [TOSEn, setTOSEn] = useState<any>('')
  const [TOSsi, setTOSsi] = useState<any>('')
  const [TOSsiEn, setTOSsiEn] = useState<any>('')
  const [attn, setAttn] = useState<any>('')
  const [attnEn, setAttnEn] = useState<any>('')
  const [penutup, setPenutup] = useState<any>('')
  const [penutupEn, setPenutupEn] = useState<any>('')
  const [ETA, setETA] = useState<any>('')
  const [textKeterangan, setTextKeterangan] = useState<any>('')
  const [textKeteranganEn, setTextKeteranganEn] = useState<any>('')
  const [referensi, setReferensi] = useState<any>('')
  const [referensiEn, setReferensiEn] = useState<any>('')
  const [shippingInstruction, setShippingInstruction] = useState<any>('')
  const [invoice, setInvoice] = useState<any>('')
  const [invoiceEn, setInvoiceEn] = useState<any>('')
  const [paySAP, setPaySAP] = useState<any>('')
  const [arrayEnduser, setEnduserArray] = useState([])
  const [noExport, setNoExport] = useState('')
  const [noExport_, setNoExport_] = useState('')
  const [sailingDate_, setSailingDate_] = useState<any>('')
  const [custPICName_, setCustPICName_] = useState('')
  const [custPICPosition_, setCustPICPosition_] = useState('')
  const [portLoading_, setPortLoading_] = useState<any>('')
  const [textBAST_, setTextBAST_] = useState<any>('')
  const [salesDivision_, setSalesDivision_] = useState<any>('')
  const [picSalesDivision_, setPicSalesDivision_] = useState<any>('')
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [TOS_, setTOS_] = useState<any>('')
  const [TOSsi_, setTOSsi_] = useState<any>('')
  const [attn_, setAttn_] = useState<any>('')
  const [penutup_, setPenutup_] = useState<any>('')
  const [ETA_, setETA_] = useState<any>('')
  const [textKeterangan_, setTextKeterangan_] = useState<any>('')
  const [referensi_, setReferensi_] = useState<any>('')
  const [shippingInstruction_, setShippingInstruction_] = useState<any>('')
  const [invoice_, setInvoice_] = useState<any>('')

  const [showAdditional, setShowAdditional] = useState(false)

  const handleSaveAdditionalText = (id: any, state: any, value: any) => {
    state(value)
    let close = document.getElementById('target' + id) as HTMLInputElement
    // console.log(close)
    close?.classList.remove('foldd-open')
    close?.classList.add('fold')
    swal({
      title: `${t('alert-Berhasil') + ' ' + t('order-tambah') + ' ' + t(id)}`,
      icon: 'success',
    })
  }

  CustomUseEffect(() => {
    const getFUllSalesOffice = async () => {
      await getFilterCity(provinsi).then((res) => {
        setFullCity(
          res.data.data.map((item: any) => {
            return {
              value: item.id,
              label: item.value,
            }
          })
        )
      })
    }

    getFUllSalesOffice()
  }, [provinsi])

  CustomUseEffect(() => {
    const getAllProvince = async () => {
      await getProvince2(salesorg, disChanel).then((res) => {
        setFullProvince(
          res.data.data.map((item: any) => {
            return {
              value: parseInt(item.sales_office),
              label: item.description,
            }
          })
        )
      })
    }
    getAllProvince()
  }, [salesorg, disChanel, kontrakid])

  CustomUseEffect(() => {
    if (roleUser == 'null' || roleUser == null) {
      const getAllPayment = async () => {
        await getPaymentSO(SIPOrder).then((res) => {
          setFullPayment(res.data.data)
        })
      }
      getAllPayment()
    } else {
      const getAllPayment = async () => {
        await getAllPaymentList().then((res) => {
          setFullPayment(res.data.data)
        })
      }
      getAllPayment()
    }
  }, [SIPOrder])

  const handlebrowsefindoc = async () => {
    setShowBrowseFindoc(true)
    setLoadingFindoc(true)
    await getFindocDataTable(custCode, salesorg, incotermId, incotermId2, currency, 1).then((res) => {
      setAllFindoc(res.data.data.data)
    })
    setLoadingFindoc(false)
  }

  CustomUseEffect(() => {
    const getAllFindoc = async () => {
      await getFindocDataTable(custCode, salesorg, incotermId, incotermId2, currency, 1).then(
        (res) => {
          setAllFindoc(res.data.data.data)
        }
      )
    }

    getAllFindoc()
  }, [custCode])

  const separator = (value: any, state1: any, state2: any, state3: any, state4: any) => {
    const temp = value.split('~#~')
    state1(temp[0])
    state2(temp[1])
    state3(temp[2])
    state4(temp[3])
  }

  const hitTOP = async () => {
    if (roleUser == null || roleUser == 'null') {
      await getTOPCust(custCode).then((res) => {
        setFullTOP(res.data.data)
      })
    } else {
      await getTOPAnper().then((res) => {
        setFullTOP(res.data.data)
      })
    }
  }

  CustomUseEffect(() => {
    const materialNumber = orderItem?.material_number || parseInt(selectedItem.material_number)
    const getPlantLoc = () => {
      getSloc(idPlant, '', materialNumber, '', '').then((res) => {
        setFullSloc(
          res.data.data.map((item: any) => {
            return {
              value: item.sloc + ',' + item.sloc_description,
              label: item.sloc + '-' + item.sloc_description,
            }
          })
        )
      })
    }
    getPlantLoc()
  }, [idPlant])

  const getroutedata = async (salesorg: any) => {
    await getRoute(salesorg).then((res) => {
      setFullRoute(
        res.data.data.map((item: any) => {
          return {
            value: item.route + ',' + item.route_desc,
            label: item.route + '-' + item.route_desc,
          }
        })
      )
    })
  }

  const [totalKuantumAdd, setTotalKuantumAdd] = useState<any>(0)

  const fillDetail = async (id: any, id2: any) => {
    setLoading(true)
    setIDSector(detail[id].sector_id)
    setTipeProduct(detail[id].product_type)
    setUnitProduct(detail[id].unit)
    setLeftoverQuantum(detail[id].left_over_quantum)
    setPtype(detail[id].product_type_desc)
    setPunit(detail[id].unit)
    setTotalKuantumAdd(sumSimilar(addedkuantum, id2, 0, 'add'))
    setPlantSelect(detail[id].plant + ', ' + detail[id].plant_desc)
    setPlantSelected(detail[id].plant + '-' + detail[id].plant_desc)
    setPlantSelectName(detail[id].plant_desc)
    setMaterialNum(detail[id].material_number.slice(-7))
    setProduct(detail[id].product_name)
    setProductCode(detail[id].product_type)
    setSpekProduk(detail[id].product_spec)
    setIncoterm(detail[id].incoterm1?.code)
    setIncoterm2(detail[id].incoterm2 || detail[id].incoterm2_id)
    setPlantNameEn(detail[id].plant_desc_en)
    setProductNameEn(detail[id].material_desc_en)

    await getPlant2(salesorg, disChanel, detail[id].material_number).then((res) => {
      setFullPlant(
        res.data.data.map((item: any) => {
          return {
            value: item.plant + ',' + item.plant_name,
            label: item.plant + '-' + item.plant_name,
          }
        })
      )
    })

    await getRoute(salesorg).then((res) => {
      setFullRoute(
        res.data.data.map((item: any) => {
          return {
            value: item.route + ',' + item.route_desc,
            label: item.route + '-' + item.route_desc,
          }
        })
      )
    })

    let postPlantName: any = []
    postPlantName.push(detail[id].plant_desc)
    // console.log(postPlantName)
    let postPlantCode: any = []
    postPlantCode.push(detail[id].plant)
    setIDPlant(detail[id].plant)
    setNamaPlant(detail[id].plant_desc)
    setSloc(detail[id].sloc)
    setSlocDesc(detail[id].sloc_description)
    setShippingTolerance(detail[id]?.shipping_tolerance)
    setKuantumSoRilis(detail[id]?.so_qty_realized)
    setShippingToleranceContract(detail[id]?.shipping_tolerance_contract)

    const orderSubDetail = detail[id] as TOrderSubDetail

    dispatch(
      setOrderItem({
        ...orderItem,
        id: orderSubDetail.id,
        sales_org_code: orderSubDetail.sales_org_code,
        incoterm1_id: orderSubDetail.incoterm1_id,
        incoterm2: orderSubDetail.incoterm2?.code,
        product_type: orderSubDetail.product_type,
        product_type_desc: orderSubDetail.product_type_desc,
        product_name: orderSubDetail.product_name,
        product_spec: orderSubDetail.product_spec,
        request_price: orderSubDetail.request_price,
        request_quantum: orderSubDetail.request_quantum?.toString() ?? '',
        province_id: orderSubDetail.province_id,
        city_id: orderSubDetail.city_id,
        sector_id: orderSubDetail.sector_id,
        end_user: orderSubDetail.end_user,
        end_user_multiple: orderSubDetail.end_user_multiple,
        notes: orderSubDetail.notes as string,
        material_number: orderSubDetail.material_number,
        unit: orderSubDetail.unit,
        segment_code: (orderSubDetail?.segment_code as string) ?? '',
        segment_name: (orderSubDetail?.segment_name as string) ?? '',
        plant: orderSubDetail.plant,
        plant_desc: orderSubDetail.plant_desc,
        sloc: orderSubDetail.sloc,
        sloc_description: orderSubDetail.sloc_description,
        shipping_tolerance: orderSubDetail?.shipping_tolerance ?? '',
        shipping_tolerance_contract: orderSubDetail?.shipping_tolerance_contract ?? '',
        quantum_contract: orderSubDetail?.quantum_contract ?? '',
        price_contract: orderSubDetail?.price_contract ?? '',
        route: '',
        route_desc: '',
        attachments: [],
        schedules: [],
        shipping_tolerance_so: '0'
      })
    )

    setLoading(false)
  }

  const [index2, setIndex2] = useState(0)
  const [addedkuantum, setAddedKuantum] = useState<any[]>([])
  const [slocPayload, setSlocPayload] = useState<any[]>([])
  const [slocPayload2, setSlocPayload2] = useState<any[]>([])
  const [incotermPayload, setIncotermPayload] = useState<any[]>([])
  const [plantEnPayload, setPlantEnPayload] = useState<any[]>([])
  const [incoterm2Payload, setIncoterm2Payload] = useState<any[]>([])

  const sumSimilar = (func1: any, id: any, add: any, type: any) => {
    let temp = 0
    func1.forEach((data: any) => {
      if (data.index == id) temp = temp + data.kuantum
    })
    if (type == 'add') temp = temp + add
    if (temp == 0) {
      return add
    } else {
      return temp
    }
  }

  const totalBatasQuantum = (quantum: any, tolerance: any) => {
    const result = parseFloat(quantum) + (parseFloat(quantum) * tolerance) / 100
    return result
  }

  const addSelectedDetail = () => {
    // console.log(totalBatasQuantum(orderItem?.quantum_contract, orderItem?.shipping_tolerance_contract))
    const regex = /FRA|CFR|CIF|CPT|CIP|DAT|DAP|DDP|DAF|DDU|DES|DEQ/g
    // if (addedkuantum.reduce((a, b) => a + b, 0) + parseInt(kuantum) <= detail[index].fixed_quantum) {

    if (isSalesOrSuperAdmin && route == '' && incoterm?.match(regex)) {
      swal({
        title: t('Route tidak boleh kosong'),
        icon: 'error',
      })
    } else {
      if (parseFloat(kuantum) <= sisaQuantum[index].quantum) {
        const tempArray: any[] = addedDetail
        const tempArray2: any[] = [...addedkuantum]
        const tempArray3: string[] = [...plantPayload]
        const tempArray4: string[] = [...plantPayload2]
        const tempArray5: string[] = [...slocPayload]
        const temparray6: string[] = [...slocPayload2]
        const tempArray7: string[] = [...specPayload]
        const tempArray8: string[] = [...routePayload]
        const tempArray9: string[] = [...routePayload2]
        const tempArray10: any[] = [...payloadAttachement]

        const tempArray21: any[] = [...incotermPayload]
        const tempArray22: any[] = [...incoterm2Payload]
        const tempArray23: any[] = [...plantEnPayload]
        // setQuantnID([...quandanid, {item_ids:detail[index].id, quantities:kuantum}])
        // detail[index].request_quantum = parseInt(kuantum)
        let inc1 = fullIncoterm.find((item: any) => item.label == incoterm)
        tempArray.push({
          ...detail[index],
          incoterm1_id: inc1?.value,
          incoterm1: inc1 ? {
            id: inc1.value,
            code: inc1.label,
          } : null,
          incoterm2_id: incoterm2,
          incoterm2: null,
        })
        tempArray2.push({kuantum: parseFloat(kuantum), index: tempID})

        tempArray3.push(idPlant)
        tempArray4.push(namaPlant)
        tempArray5.push(sloc)
        temparray6.push(slocDesc)
        tempArray7.push(spekproduk)
        tempArray8.push(route)
        tempArray9.push(routeDesc)
        tempArray10.push([])

        tempArray21.push(inc1?.value)
        tempArray22.push(incoterm2)
        tempArray23.push(plantNameEn)

        setAddedDetail(tempArray)
        setAddedKuantum(tempArray2)
        setPlantPayload(tempArray3)
        setPlantPayload2(tempArray4)
        setSlocPayload(tempArray5)
        setSlocPayload2(temparray6)
        setSpecPayload(tempArray7)
        setRoutePayload(tempArray8)
        setRoutePayload2(tempArray9)
        setPayloadAttachment(tempArray10)

        setIncotermPayload(tempArray21)
        setIncoterm2Payload(tempArray22)
        setPlantEnPayload(tempArray23)

        let tempindex = leftoverArray.findIndex((item: any) => item.id == tempID)
        let tempSisaQuantum: any = sisaQuantum
        tempSisaQuantum[index].quantum = tempSisaQuantum[index].quantum - parseFloat(kuantum)
        setSisaQuantum(tempSisaQuantum)

        let totalPrice = tempArray.reduce(
          (a: any, b: any, index: any) =>
            a + (tempArray2[index]?.kuantum * parseFloat(b.price_contract) || 0),
          0
        )
        setPriceBefore(totalPrice)
        // let totalPricePpn = tempArray.reduce(
        //   (a: any, b: any, index: any) =>
        //     a +
        //     ((b.ppn / 100) * (tempArray2[index]?.kuantum * b.fixed_price) +
        //       tempArray2[index]?.kuantum * b.fixed_price || 0),
        //   0
        // )
        let totalPricePpn = tempArray.reduce(
          (a: any, b: any, index: any) =>
            a +
            (tempArray2[index]?.kuantum *
              (parseFloat(b.price_contract) + (parseFloat(b.price_contract) / 100) * b.ppn) || 0),
          0
        )
        setPriceAfter(totalPricePpn)
        let totalquantum = tempArray.reduce(
          (a: any, b: any, index: any) =>
            b.product_type != '8105' ? a + (tempArray2[index]?.kuantum || 0) : a + 0,
          0
        )
        let totalpcs = tempArray.reduce(
          (a: any, b: any, index: any) =>
            b.product_type == '8105' ? a + (tempArray2[index]?.kuantum || 0) : a + 0,
          0
        )
        setTotalquant(totalquantum)
        setTotalPcs(totalpcs)

        const _signingConfig = signingPayload
        _signingConfig.total_quantum = totalquantum + totalQuantumProduct
        _signingConfig.product_type = tempArray[0].product_type
        setSigningPaylod(_signingConfig)
        loadSigningConfig()

        dispatch(addOrderItem(orderItem))
        dispatch(setOrderItem(null))

        setPlantSelected('')
        setSloc('')
        setSlocDesc('')
        // console.log(detail, 'attayd etail')
        setTotalKuantumAdd(0)
        setLeftoverQuantum(0)
        setSpekProduk('')
        setMaterialNum([])
        setRoute('')
        setRouteDesc('')
        setShow2(false)
      } else {
        if (kuantum == 0 || isNaN(kuantum)) {
          swal({
            title: t('Kuantum tidak boleh kosong!'),
            icon: 'error',
          })
        } else {
          swal({
            title: t('Melebihi quantum yang di setujui!'),
            icon: 'error',
          })
        }
      }
    }
  }

  const editSelectedDetail = (id: any) => {
    const pos = addedDetail.map((e) => e.id).indexOf(id)
    const {quantum_contract} = selectedItem
    // if (
    //   totalBatasQuantum(orderItem?.quantum_contract, orderItem?.shipping_tolerance_contract) >=
    //   sumSimilar(addedkuantum, tempID, parseFloat(kuantum), 'edit')
    // )
    if (parseFloat(kuantum) <= singleSisaQuantum + addedkuantum[index2].kuantum) {
      const temparray0: any[] = [...addedDetail]

      const temparray: any[] = addedkuantum
      const tempArray3: string[] = [...plantPayload]
      const tempArray4: string[] = [...plantPayload2]
      const tempArray5: string[] = [...slocPayload]
      const temparray6: string[] = [...slocPayload2]
      const temparray7: string[] = [...specPayload]
      const tempArray8: string[] = [...routePayload]
      const tempArray9: string[] = [...routePayload2]

      const tempArray21: string[] = [...incotermPayload]
      const tempArray22: string[] = [...incoterm2Payload]
      const tempArray23: string[] = [...plantEnPayload]
      // console.log(id)
      let tempSisaQuantum: any = sisaQuantum
      tempSisaQuantum[index].quantum = tempSisaQuantum[index].quantum + addedkuantum[index2].kuantum
      tempSisaQuantum[index].quantum = tempSisaQuantum[index].quantum - parseFloat(kuantum)
      setSisaQuantum(tempSisaQuantum)

      let inc1 = fullIncoterm.find((item: any) => item.label == incoterm)
      temparray[id].kuantum = parseFloat(kuantum)
      let _tempItem = {...temparray0[id]}
      _tempItem.incoterm1 = inc1 ? {
        id: inc1.value,
        code: inc1.label,
      } : null
      _tempItem.incoterm1_id = inc1?.value
      _tempItem.incoterm2_id = incoterm2
      _tempItem.incoterm2 =  null
      _tempItem.shipping_tolerance_so =  shipping
      _tempItem.notes =  note
      temparray0[id] = _tempItem
      
      tempArray3[id] = idPlant
      tempArray4[id] = namaPlant
      tempArray5[id] = sloc
      temparray6[id] = slocDesc
      temparray7[id] = spekproduk
      tempArray8[id] = route
      tempArray9[id] = routeDesc
      tempArray21[id] = inc1?.value
      tempArray22[id] = incoterm2
      tempArray23[id] = plantNameEn

      setAddedDetail(temparray0)
      setAddedKuantum(temparray)
      setPlantPayload(tempArray3)
      setPlantPayload2(tempArray4)
      setSlocPayload(tempArray5)
      setSlocPayload2(temparray6)
      setSpecPayload(temparray7)
      setRoutePayload(tempArray8)
      setRoutePayload2(tempArray9)
      setIncotermPayload(tempArray21)
      setIncoterm2Payload(tempArray22)
      setPlantEnPayload(tempArray23)
      setTotalBatas(0)
      setTotalBatasNonST(0)
      setLeftoverIndex(0)
      let totalPrice = addedDetail.reduce(
        (a: any, b: any, index: any) =>
          a + (temparray[index]?.kuantum * parseFloat(b.price_contract) || 0),
        0
      )
      setPriceBefore(totalPrice)
      // let totalPricePpn = addedDetail.reduce(
      //   (a: any, b: any, index: any) =>
      //     a +
      //     ((b.ppn / 100) * (temparray[index]?.kuantum * b.fixed_price) +
      //       temparray[index]?.kuantum * b.fixed_price || 0),
      //   0
      // )
      let totalPricePpn = addedDetail.reduce(
        (a: any, b: any, index: any) =>
          a +
          (temparray[index]?.kuantum *
            (parseFloat(b.price_contract) + (parseFloat(b.price_contract) / 100) * b.ppn) || 0),
        0
      )
      let totalquantum = addedDetail.reduce(
        (a: any, b: any, index: any) =>
          b.product_type != '8105' ? a + (temparray[index]?.kuantum || 0) : a + 0,
        0
      )
      let totalpcs = addedDetail.reduce(
        (a: any, b: any, index: any) =>
          b.product_type == '8105' ? a + (temparray[index]?.kuantum || 0) : a + 0,
        0
      )

      const _signingConfig = signingPayload
      _signingConfig.total_quantum = totalquantum + totalQuantumProduct
      setSigningPaylod(_signingConfig)
      loadSigningConfig()

      swal({
        title: `${t('dataBerhasilDiedit')}`,
        icon: 'success',
      })
      setSpekProduk('')
      setPlantSelected('')
      setSloc('')
      setSlocDesc('')
      setTotalKuantumAdd(0)
      setLeftoverQuantum(0)
      setTotalPcs(totalpcs)
      setTotalquant(totalquantum)
      setPriceAfter(totalPricePpn)
      setShowEdit(false)
    } else {
      if (kuantum == 0 || isNaN(kuantum)) {
        swal({
          title: t('Kuantum tidak boleh kosong!'),
          icon: 'error',
        })
      } else {
        swal({
          title: t('Melebihi quantum yang di setujui!'),
          icon: 'error',
        })
      }
    }
  }

  const clearState = () => {
    setDisableCKBOX(false)
    setEnduser('')
    setEnduserDesc('')
    setIDSector(0)
    setProvince(0)
    setCityProduct(0)
    setPtype('')
    setPtype2('')
    setFullProductName([])
    setPname('')
    setPnumber('')
    setPspec('')
    setSegment('')
    setSegmentDesc('')
    setSubprice(0)
    setQuantum(0)
    setketerangan('')
    setNote('')
  }

  const editSelectedDetailProduct = (index: any) => {
    let inc1 = fullIncoterm.find((item: any) => item.label == incoterm)

    const temparray: any[] = addedProduct
    temparray[index].incoterm1_id = inc1?.value
    temparray[index].incoterm2 = null
    temparray[index].incoterm2_id = incoterm2
    temparray[index].incoterm1_desc = inc1?.label
    temparray[index].incoterm1 = inc1 ? {
      id: inc1?.value,
      code: inc1?.label,
    } : null
    temparray[index].request_quantum = parseFloat(kuantum)
    temparray[index].quantity = parseFloat(kuantum)
    temparray[index].product_name = pname
    temparray[index].material_number = pnumber
    temparray[index].product_spec = spekproduk
    temparray[index].plant = idPlant
    temparray[index].plant_desc = namaPlant
    temparray[index].sloc = sloc
    temparray[index].sloc_description = slocDesc
    temparray[index].route = route
    temparray[index].route_desc = routeDesc
    temparray[index].plant_desc_en = plantNameEn
    
    setAddedProduct(temparray)
    let totalPrice = temparray.reduce(
      (a: any, b: any, index: any) => a + (b.quantity * b.request_price || 0),
      0
    )
    setTotalPriceProductBefore(totalPrice)
    // let totalPricePpn = temparray.reduce(
    //   (a: any, b: any, index: any) =>
    //     a +
    //     ((ppn / 100) * (b.quantity * b.request_price) + (b.quantity * b.request_price) || 0),
    //   0
    // )
    let totalPricePpn = temparray.reduce(
      (a: any, b: any, index: any) =>
        a + (b.quantity * (b.request_price + (b.request_price / 100) * ppn) || 0),
      0
    )
    let totalquantum = temparray.reduce(
      (a: any, b: any, index: any) => (b.product_type != '8105' ? a + (b.quantity || 0) : a + 0),
      0
    )
    let totalpcs = temparray.reduce(
      (a: any, b: any, index: any) => (b.product_type == '8105' ? a + (b.quantity || 0) : a + 0),
      0
    )

    const _signingConfig = signingPayload
    _signingConfig.total_quantum = totalquantum + totalquant
    setSigningPaylod(_signingConfig)
    loadSigningConfig()

    swal({
      title: `${t('dataBerhasilDiedit')}`,
      icon: 'success',
    })
    
    setSpekProduk('')
    setPlantSelected('')
    setSloc('')
    setSlocDesc('')
    setTotalPcsProduct(totalpcs)
    setTotalQuantumProduct(totalquantum)
    setTotalPriceProductAfter(totalPricePpn)
    setShowEdit2(false)
  }

  const clearall = () => {
    setCustomerCode('')
    setIncotermId(0)
    setIncoterm('')
    setIncotermId2('')
    setIncotermId2Desc('')
    const inco2 = document.getElementById('inco2') as HTMLInputElement
    if (inco2 != null) inco2.defaultValue = ''
    setNegara('')
    const selectNegara = document.getElementById('negara') as HTMLSelectElement
    if (selectNegara != null) selectNegara.selectedIndex = 0
    setProvinsi2('')
    setFullCust([])
    setTransportasi('')
    const angkutan = document.getElementById('angkutan') as HTMLInputElement
    if (angkutan != null) angkutan.value = ''
    setRencana('')
    const plan = document.getElementById('plan') as HTMLInputElement
    if (plan != null) plan.value = ''
    setAssigner('')
    setPay('')
    setPaySAP('')
    const payment = document.getElementById('payment') as HTMLSelectElement
    if (payment != null) payment.selectedIndex = 0
    setSelectedFindoc('')
    setFindoc('')
    setTOP('')
    setTOP2('')
    setFullTOP([])
    setCustomerAddress('')
    setCustomerName('')
    setFiles2({file: null})
    const btn2 = document.getElementById('btnupload2') as HTMLInputElement
    if (btn2 != null) btn2.disabled = false
    setCity2('')
    setCity('')
    setFullCity([])
    setCustAssing('')
    setFullAssign([])
    setProvinsi('')
    setTransType('')
    setTransType2('')
    setCustomer('')
    setCustomerID('')
    setCustGroup('')
    const ttrans = document.getElementById('ttrans') as HTMLSelectElement
    if (ttrans != null) ttrans.selectedIndex = 0
    setPot('')
    const port = document.getElementById('port') as HTMLInputElement
    if (port != null) port.value = ''
    setPosition('')

    setPlantSelect('')

    setShip('')
    setFiles({file: null})
    const btn = document.getElementById('btnupload') as HTMLInputElement
    if (btn != null) btn.disabled = false

    const getCust = async () => {
      const res = await getCusGrup(sektorID)
      setFullCust(
        res.data.data.map((item: any) => {
          return {
            value: item.code,
            label: item.name,
          }
        })
      )
    }
    setAddedDetail([])
    setAddedProduct([])
    setPriceAfter(0)
    setTotalPriceProductAfter(0)
    setPriceBefore(0)
    setTotalPriceProductBefore(0)
    setTotalquant(0)
    setTotalPcs(0)
    setTotalQuantumProduct(0)
    setTotalPcsProduct(0)
    setAddedKuantum([])
    setSlocPayload([])
    setSlocPayload2([])
    setRoutePayload([])
    setRoutePayload2([])
    setPayloadAttachment([])
    setIncotermPayload([])
    setIncoterm2Payload([])
    getCust()
  }

  CustomUseEffect(() => {
    const getCust = async () => {
      const res = await getCusGrup(sektorID)
      setFullCust(
        res.data.data.map((item: any) => {
          return {
            value: item.code,
            label: item.name,
          }
        })
      )
    }
    getCust()
  }, [sektorID])

  const removeSubOrder = (index: any, tempid: any, quant: any) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        const temparray: any = [...addedkuantum]
        const tempArray2: any = [...addedDetail]
        const tempArray3: string[] = [...plantPayload]
        const tempArray4: string[] = [...plantPayload2]
        const tempArray5: string[] = [...slocPayload]
        const temparray6: string[] = [...slocPayload2]
        const temparray7: string[] = [...routePayload]
        const temparray8: string[] = [...routePayload2]
        const temparray9: any[] = [...payloadAttachement]
        const temparray10: any[] = [...specPayload]
        const temparray21: any[] = [...incotermPayload]
        const temparray22: any[] = [...incoterm2Payload]
        const temparray23: any[] = [...plantEnPayload]
        temparray.splice(index, 1)
        tempArray2.splice(index, 1)
        tempArray3.splice(index, 1)
        tempArray4.splice(index, 1)
        tempArray5.splice(index, 1)
        temparray6.splice(index, 1)
        temparray7.splice(index, 1)
        temparray8.splice(index, 1)
        temparray9.splice(index, 1)
        temparray10.splice(index, 1)
        temparray21.splice(index, 1)
        temparray22.splice(index, 1)
        temparray23.splice(index, 1)

        let tempindex = leftoverArray.findIndex((item: any) => item.id == tempid)
        let tempBatas: any = []
        tempBatas = leftoverArray
        tempBatas[tempindex].left_over_quantum =
          tempBatas[tempindex].left_over_quantum + parseFloat(quant)
        tempBatas[tempindex].left_over_quantum_no_st =
          tempBatas[tempindex].left_over_quantum_no_st + parseFloat(quant)

        let totalPrice = addedDetail.reduce(
          (a: any, b: any, index: any) =>
            a + (temparray[index]?.kuantum * parseFloat(b.price_contract) || 0),
          0
        )
        setPriceBefore(totalPrice)
        // let totalPricePpn = addedDetail.reduce(
        //   (a: any, b: any, index: any) =>
        //     a +
        //     ((b.ppn / 100) * (temparray[index]?.kuantum * b.fixed_price) +
        //       temparray[index]?.kuantum * b.fixed_price || 0),
        //   0
        // )
        let totalPricePpn = addedDetail.reduce(
          (a: any, b: any, index: any) =>
            a +
            (temparray[index]?.kuantum *
              (parseFloat(b.price_contract) + (parseFloat(b.price_contract) / 100) * b.ppn) || 0),
          0
        )
        let totalquantum = addedDetail.reduce(
          (a: any, b: any, index: any) =>
            b.product_type != '8105' ? a + (temparray[index]?.kuantum || 0) : a + 0,
          0
        )
        let totalpcs = addedDetail.reduce(
          (a: any, b: any, index: any) =>
            b.product_type == '8105' ? a + (temparray[index]?.kuantum || 0) : a + 0,
          0
        )
        setTotalPcs(totalpcs)
        setTotalquant(totalquantum)
        setPriceAfter(totalPricePpn)

        if (tempArray2.length < 1) {
          setSAPNun('')
          setKontrakID('')
          clearall()
        } else {
          setAddedKuantum(temparray)
          setAddedDetail(tempArray2)
          setPlantPayload(tempArray3)
          setPlantPayload2(tempArray4)
          setSlocPayload(tempArray5)
          setSlocPayload2(temparray6)
          setRoutePayload(temparray7)
          setRoutePayload2(temparray8)
          setPayloadAttachment(temparray9)
          setSpecPayload(temparray10)
          setIncotermPayload(temparray21)
          setIncoterm2Payload(temparray22)
          setPlantEnPayload(temparray23)
        }

        const _signingConfig = signingPayload
        _signingConfig.total_quantum = totalquantum + totalQuantumProduct
        setSigningPaylod(_signingConfig)
        loadSigningConfig()

        dispatch(removeOrderItem(index))

        let temp = 0
        swal({
          title: `${t('Item SO deleted successfully')}`,
          icon: 'success',
        })
      }
    })
  }

  const removeProduct = (index: any) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        const temparray: any = [...addedProduct]
        temparray.splice(index, 1)
        let totalPrice = temparray.reduce(
          (a: any, b: any, index: any) => a + (b.quantity * b.request_price || 0),
          0
        )
        // let totalPricePpn = temparray.reduce(
        //   (a: any, b: any, index: any) =>
        //     a +
        //     ((ppn / 100) * (b.quantity * b.request_price) + (b.quantity * b.request_price) || 0),
        //   0
        // )
        let totalPricePpn = temparray.reduce(
          (a: any, b: any, index: any) =>
            a + (b.quantity * (b.request_price + (b.request_price / 100) * ppn) || 0),
          0
        )
        let totalquantum = temparray.reduce(
          (a: any, b: any, index: any) =>
            b.product_type != '8105' ? a + (b.quantity || 0) : a + 0,
          0
        )
        let totalpcs = temparray.reduce(
          (a: any, b: any, index: any) =>
            b.product_type == '8105' ? a + (b.quantity || 0) : a + 0,
          0
        )
        setTotalPcsProduct(totalpcs)
        setTotalQuantumProduct(totalquantum)
        setTotalPriceProductBefore(totalPrice)
        setTotalPriceProductAfter(totalPricePpn)
        setAddedProduct(temparray)
        swal({
          title: `${t('Item SO deleted successfully')}`,
          icon: 'success',
        })

        const _signingConfig = signingPayload
        _signingConfig.total_quantum = totalquantum + totalquant
        setSigningPaylod(_signingConfig)
        loadSigningConfig()
      }
    })
  }

  CustomUseEffect(() => {
    setFindoc('')
    setSelectedFindoc('')
    setTOP('')
    setTOP2('')
  }, [incotermId, incotermId2])

  const [isexceed, setIsExceed] = useState(false)

  const handleFile3 = (e: any) => {
    setIsExceed(false)
    if (e.target.files[0]?.size / 1024 / 1024 <= 20) getBase64(e.target.files[0])
    else {
      setIsExceed(true)
      const inputfile = document.getElementById('upload') as HTMLBaseElement
      e.target.value = null
    }
  }

  const getBase64 = (file: any) => {
    // console.log(file.name)
    var reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      if (uploadType === 'hydro') {
        setFiles2({file: file})
        setFileHydro(reader.result)
        setNamaHydro(file.name)
      } else if (uploadType === 'ship') {
        setFiles({file: file})
        setShipParticularFiles(reader.result)
        setShipParticularName(file.name)
      } else {
        setFiles3(reader.result)
        setNamaFile(file.name)
      }
    }
    reader.onerror = function (error) {
      alert('Error: ' + error)
    }
  }

  const [showUpload2, setShowUpload2] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [subOrderID, setSubOrderID] = useState('')

  const ambilAttachment = async (id: any) => {
    setIsExceed(false)
    await getFile('order-item', id, localStorage.getItem('credential')!).then((res) => {
      handleShowAttachment(res.data.data)
      setShowUpload2(true)
    })
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (accesses?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    if (input1 != null) input1.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    if (input2 != null) input2.value = ''
    const input3 = document.getElementById('uploadketerangan2') as HTMLInputElement
    if (input3 != null) input3.value = ''
    const input4 = document.getElementById('upload2') as HTMLInputElement
    if (input4 != null) input4.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
  }

  const removeFileState = () => {
    setFiles({file: null})
    setNamaFile('')
    setDescription('')
    setDataType('')
    setIsPrivate(false)
    setTempRole([])
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(subOrderID)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', subOrderID)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)
    if (sektorID != '2') {
      formdata.append('unique_number', nomorKontrak)
      formdata.append('unique_flag', 'new_contract_osd')
    }
    // console.log(formdata)
    await create('order-item', formdata)
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${t('document uploaded successfully')}`,
            icon: 'success',
          })
          ambilAttachment(subOrderID)
          removeFileState()
          clearInputUpload()
        } else {
          swal({
            title: t(res.data.message),
            icon: 'error',
          })
        }
      })
      .catch(function (error) {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const closeupload = () => {
    const btn2 = document.getElementById('btnupload2') as HTMLInputElement
    const btn = document.getElementById('btnupload') as HTMLInputElement
    getBase64(tempfiles.file)

    //if (files2.file != null) if (btn2 != null) btn2.disabled = true

    // if (files.file != null) if (btn != null) btn.disabled = true
    swal({
      title: `${t('document uploaded successfully')}`,
      icon: 'success',
    }).then(() => setShowUpload(false))
  }

  const create2 = async () => {
    // const split = plantSelect.split(', ')
    try{
    setBtnLoading(true)
    let tempID: string[] = []
    let tempquan: string[] = []
    let tempspec: string[] = []
    addedDetail.forEach((element) => {
      tempID.push(element.id)
    })
    addedkuantum.forEach((element) => {
      tempquan.push(element.kuantum)
    })
    const orderitemArray: any[] = []

    addedProduct.forEach((data: any, _index: any) => {
      orderitemArray.push(data)
      data?.attachments.forEach((data2: any, _index2: any) => {
        if (data?.attachments?.length > -1) {
          const temp = data2?.file_r.split(',')
          if (temp[1] != undefined) orderitemArray[_index]!.attachments[_index2]!.file_r = temp[1]
        }
      })
    })

    const orderitemArray2: any[] = []

    payloadAttachement.forEach((data: any, _index: any) => {
      let _orderItem: any[] = []
      data?.forEach((data2: any, _index2: any) => {

        let _orderItem2: any = {
          ...data2
        };
        if (data?.length > -1) {
          const temp = data2?.file_r.split(',')
          if (temp[1] != undefined) {
            _orderItem2.file_r = temp[1]
          }
        }

        _orderItem.push(_orderItem2);
      })
      orderitemArray2.push(_orderItem)
    })

    let file = files.file
    let file2 = files2.file
    let payloadNewItem: any[] = []
    addedProduct.forEach((item: any) => {
      payloadNewItem.push({
        sales_org_code: item.sales_org_code,
        incoterm1_id: item.incoterm1_id,
        incoterm2_id: item.incoterm2_id,
        product_type: item.product_type,
        product_type_desc: item.product_type_desc,
        product_name: item.product_name,
        product_spec: item.product_spec,
        request_price: item.request_price,
        request_quantum: item.request_quantum,
        shipping_tolerance: item.shipping_tolerance,
        province_id: parseInt(item.province_id),
        city_id: parseInt(item.city_id),
        sector_id: item.sector_id,
        end_user: item.end_user,
        notes: item.notes,
        material_number: item.material_number,
        unit: item.unit,
        segment_code: item.segment_code,
        segment_name: item.segment_name,
        plant: item.plant,
        plant_desc: item.plant_desc,
        sloc: item.sloc,
        sloc_description: item.sloc_description,
        route: item.route,
        route_desc: item.route_desc,
        attachments: item.attachments,
        schedules: item.schedules,
        end_user_multiple: item.end_user_multiple,
        shipping_tolerance_contract: item.shipping_tolerance_contract,
        plant_desc_en: item.plant_desc_en,
      })
    })
    let formdata = new FormData()
    if (customerID == undefined) formdata.append('customer_ship_to', '')
    else formdata.append('customer_ship_to', customerID!)
    formdata.append('attachment_items', JSON.stringify(orderitemArray2)!)
    formdata.append('contract_id', kontrakid!)
    formdata.append('new_items', JSON.stringify(payloadNewItem))
    formdata.append('lang', i18next.language!)
    formdata.append('moda_angkut_name', transportasi!)
    formdata.append('moda_angkut_type', transType!)
    formdata.append('moda_angkut_type_en', transType2!)
    if (file2 != null) formdata.append('hydro_static_table_r', file2!)
    if (file != null) formdata.append('ship_particular_r', file!)
    if (sektorID == '1') {
      formdata.append('province', provinsiTujuan!)
      formdata.append('province_desc', provinsiTujuan2)
    }
    formdata.append('stowage_plan', rencana!)
    formdata.append('port_of_discharge', pot!)
    formdata.append('country_destination', negara || '')
    formdata.append('country_code', negaraCode || '')
    formdata.append('payment_type', pay!)
    formdata.append('item_ids', JSON.stringify(tempID!))
    formdata.append('quantities', JSON.stringify(tempquan!))
    formdata.append('product_specs', JSON.stringify(specPayload.map((item) => item ?? '')))
    formdata.append('customer_id', custCode)
    formdata.append('top', top!)
    formdata.append('findoc_id', findoc!)
    formdata.append('routes', JSON.stringify(routePayload))
    formdata.append('route_descs', JSON.stringify(routePayload2))
    formdata.append('plants', JSON.stringify(plantPayload))
    formdata.append('plants_desc', JSON.stringify(plantPayload2))
    formdata.append('slocs', JSON.stringify(slocPayload))
    formdata.append('slocs_description', JSON.stringify(slocPayload2))

    formdata.append('incoterm1_ids', JSON.stringify(incotermPayload))
    formdata.append('incoterms2', JSON.stringify(incoterm2Payload))
    formdata.append('plants_desc_en', JSON.stringify(plantEnPayload))

    if (incotermId == 0) formdata.append('incoterm1_id', '')
    else formdata.append('incoterm1_id', String(incotermId))
    formdata.append('incoterm2', incotermId2!)
    formdata.append('sales_group', city!)
    formdata.append('sales_office', provinsi!)
    if (custGroup == null || custGroup == 'null') formdata.append('customer_account_group', '')
    else formdata.append('customer_account_group', custGroup!)
    formdata.append('account_assignment_group', custAssign!)
    formdata.append('credentials', localStorage.getItem('credential')!)
    if (roleUser != null && roleUser != 'null') {
      formdata.append('created_by', roleUser!)
      formdata.append('assigner_name', assinger)
      formdata.append('assigner_position', position)
    } else {
      formdata.append('created_by', 'customer')
    }

    if (custPICName != '') formdata.append('customer_pic_name', custPICName! || '')
    if (custPICPosition != '') formdata.append('customer_pic_position', custPICPosition! || '')
    if (namaPenandatanganFinance != '')
      formdata.append('financial_assigner_name', namaPenandatanganFinance! || '')
    if (posisiPenandatanganFinance != '')
      formdata.append('financial_assigner_position', posisiPenandatanganFinance! || '')
    if (sailingDate != '') formdata.append('sailing_date', sailingDate! || '')
    if (portLoading != '') formdata.append('port_of_loading', portLoading! || '')
    if (textBAST != '') formdata.append('additional_text_bast', textBAST! || '')
    if (textBASTEn != '') formdata.append('additional_text_bast_en', textBASTEn! || '')
    if (salesDivision != '') formdata.append('sales_division', salesDivision! || '')
    if (picSalesDivision != '') formdata.append('pic_sales_division', picSalesDivision! || '')
    // if(transportMedia != '') formdata.append('transportation_media', transportMedia!)
    // if(transportMediaInfo != '') formdata.append('transportation_media_info', transportMediaInfo!)
    if (TOS != '') formdata.append('terms_and_conditions', TOS! || '')
    if (TOSEn != '') formdata.append('terms_and_conditions_en', TOS! || '')
    if (TOSsi != '') formdata.append('terms_and_conditions_si', TOSsiEn! || '')
    if (TOSsiEn != '') formdata.append('terms_and_conditions_si_en', TOSsiEn! || '')
    if (attn != '') formdata.append('customer_attn', attn! || '')
    if (attnEn != '') formdata.append('customer_attn_en', attnEn! || '')
    if (penutup != '') formdata.append('text_penutup', penutup! || '')
    if (penutupEn != '') formdata.append('text_penutup_en', penutupEn! || '')
    if (textKeterangan != '') formdata.append('keterangan', textKeterangan! || '')
    if (textKeteranganEn != '') formdata.append('keterangan_en', textKeteranganEn! || '')
    if (referensi != '') formdata.append('referensi', referensi! || '')
    if (referensiEn != '') formdata.append('referensi_en', referensiEn! || '')
    if (shippingInstruction != '')
      formdata.append('tanggal_shipping_instruction', shippingInstruction! || '')
    if (invoice != '') formdata.append('invoice_notes', invoice! || '')
    if (invoiceEn != '') formdata.append('invoice_notes_en', invoiceEn! || '')
    if (ETA != '') formdata.append('eta_moda_angkut', ETA! || '')
    if (noExport != '') formdata.append('no_izin_export', noExport! || '')

    const shipping_tolerance_so = orderItems.map((item) => item.shipping_tolerance_so || 0)
    formdata.append('shipping_tolerance', `[${shipping_tolerance_so.join(', ')}]`)

    await createSO(formdata)
      .then((response) => {
        swal({
          title: `${t('SO berhasil dibuat')}`,
          icon: 'success',
        }).then(() => navigate('/management/so'))
      })
      .catch((error) => {
        if(error.response.data?.message?.message){
          if (
            error.response.data.message.message.match(
              /League\\Flysystem\\Filesystem::delete\(\): Argument/g
            )
          ) {
            swal({
              title: t('Error-pengirimanKhusus'),
              icon: 'error',
            })
          } else if (error.response.data.message.message.match(/This contract not have item/g)) {
            swal({
              title: t('This contract not have item').replace(
                '#ID',
                error.response.data.message.data.id
              ),
              icon: 'error',
            })
          } else if (error.response.data.message.message.match(/Failed, all quantity have been/g)) {
            swal({
              title: t('Failed, all quantity have been').replace(
                '#ID',
                error.response.data.message.data.id
              ),
              icon: 'error',
            })
          } else if (
            error.response.data.message.message.match(/Failed, Quantity cannot be left over/g)
          ) {
            swal({
              title: t('Failed, Quantity cannot be left over').replace(
                '#ID',
                error.response.data.message.data.id
              ),
              icon: 'error',
            })
          } else if (error.response.data.message.message.match(/Failed, stock not available/g)) {
            swal({
              title: t('Failed, stock not available')
                .replace('#ID', error.response.data.message.data.id)
                .replace('#PLANT', error.response.data.message.data.plant_desc)
                .replace('PLANT', t('PLANT')),
              icon: 'error',
            })
          } else {
            swal({
              title: `${t(error.response.data.message.message)}`,
              icon: 'error',
            })
          }
        }else{
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        }

        setBtnLoading(false)
      })
      .finally(() => {
        setBtnLoading(false)
      })
    }catch(e: any){
      setBtnLoading(false)
      swal({
        title: e.message,
        icon: 'error',
      })
      console.log(e)
    }
  }

  const separator2 = (value: any, func1: any, func2: any) => {
    const temp = value.split(',')
    func1(temp[0])
    func2(temp[1])
  }

  const separator3 = (value: any, func1: any, func2: any) => {
    const temp = value.split('_')
    func1(temp[0])
    func2(temp[1])
  }

  const [fullCust, setFullCust] = useState<any>([])
  const [fullAssign, setFullAssign] = useState<any>([])
  const [custGroup, setCustGroup] = useState('')
  const [custAssign, setCustAssing] = useState('')
  const [roleFlag, setRoleFlag] = useState('')

  useEffect(() => {
    setRoleFlag(localStorage.getItem('role-flag')!)
    const getApprovedData = async () => {
      setLoadingSIP(true)
      await getApproved(localStorage.getItem('credential')).then((res) => {
        setFullKontrak(res.data.data.data)
      })
      setLoadingSIP(false)
      await getIncoterm().then((res) => {
        let temparray: any[] = [{value: '0;', label: t('Pilih-incoterm')}]
        res.data.data.forEach((item: any) => {
          temparray.push({value: item.id, label: item.code})
        })
        setFullIncoterm(temparray)
      })
    }
    const getCust = async () => {
      const res = await getCusGrup(sektorID)
      setFullCust(
        res.data.data.map((item: any) => {
          return {
            value: item.code,
            label: item.name,
          }
        })
      )
    }

    // const getAcc = async () => {
    //   const res = await getAccAssSO()
    //   console.log(res.data.data)
    //   setFullAssign(
    //     res.data.data.map((item: any) => {
    //       return {
    //         value: item.code,
    //         label: item.name,
    //       }
    //     })
    //   )
    // }

    // getAcc()

    const getTransport = async () => {
      const res = await getAllTransport()
      setFullTransport(res.data.data)
    }
    getTransport()
    getCust()

    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getType = async () => {
      const res = await getProductType(localStorage.getItem('credential'))
      // console.log(res.data.data)
      setFullProductType(res.data.data)
    }

    const getprov = async () => {
      await getProvince3().then((res) => {
        setFullProvince2(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_office + ',' + item.controlling_area,
              label: item.controlling_area,
            }
          })
        )
      })
    }
    // const getPPNValue = async () => {
    //   await getPPN().then((res) => {
    //     setPPN2(res.data.data.data[0].ppn)
    //   })
    // }
    // getPPNValue()

    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDay(today.getDate())
    setMonth(today.getMonth() + 1)
    setYear(today.getFullYear())
    setDateNow(dd + '-' + mm + '-' + yyyy)
    setDaysInMonth(getDaysInMonth(today.getFullYear(), today.getMonth() + 1))

    const handleYear = () => {
      let year = []
      const aYearFromNow = new Date()
      year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear())).getFullYear())
      for (let i = 0; i < 2; i++) {
        year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1)).getFullYear())
      }
      setListYear(year)
    }

    const getAccessMenu = async () => {
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    handleYear()
    getAccessMenu()
    getprov()
    getType()
    role()
    getApprovedData()
    getAllRoleList()
  }, [])

  const [custassingchanged, setcustassingchanged] = useState(0)

  CustomUseEffect(() => {
    const getAcc = async () => {
      const res = await getAccAssSO(assessmentHead, custGroup)
      setFullAssign(
        res.data.data.map((item: any) => {
          if (item.customer_head == assessmentHead)
            setCustAssing(item.account_assignment_group_code)
          setcustassingchanged(custassingchanged + 1)
          return {
            value: item.account_assignment_group.code,
            label: item.account_assignment_group.name,
          }
        })
      )
    }
    if (fullCust.length >= 1) getAcc()
  }, [custGroup])

  const separateValue2 = (state: any, value: any) => {
    const temp = value
    state(parseInt(temp))
  }

  const [numberURL, setNumberURL] = useState([])
  const [numberURL2, setNumberURL2] = useState([])
  const [numberURL3, setNumberURL3] = useState([])
  const [SAPNum, setSAPNun] = useState<any>('')

  const paginateNumber = async (number: any) => {
    const contract_number = filter?.contract_number ?? ''
    const customer_name = filter?.customer_name ?? ''
    const sector_id = filter?.sector_id ?? ''
    const sap_number = filter?.sap_number ?? ''

    const res = await axios.get(
      `${number}&credentials=${localStorage.getItem(
        'credential'
      )}&contract_number=${contract_number}&customer_name=${customer_name}&sector_id=${sector_id}&sap_number=${sap_number}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setFullKontrak(res.data.data.data)
    setNumberURL(res.data.data.links)
  }

  const paginateNumber2 = async (number: any) => {
    const res = await axios.get(
      `${number}&customer_code=${custCode}&status=5&sales_org_code=${salesorg}&incoterm_id=${incotermId}&incoterm2_id=${incotermId2}&findoc_desc=${findesc}&num_findoc=${finext}&currency=${currency}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    setAllFindoc(res.data.data.data)
    setNumberURL2(res.data.data.links)
  }

  const [fullProductType, setFullProductType] = useState([])

  const {browseContractFilter: filter} = useAppSelector(soSelector)

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getApprovedSearch(
        localStorage.getItem('credential'),
        filter?.contract_number ?? '',
        filter?.customer_name ?? '',
        filter?.sector_id ?? '',
        filter?.sap_number ?? '',
        filter?.product_type ?? ''
      ).then((res: any) => {
        setFullKontrak(res.data.data.data)
        setNumberURL(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [filter])

  const [findesc, setFindesc] = useState('')
  const [finext, setfinext] = useState('')

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getFindocDataTableSearch(
        custCode,
        salesorg,
        incotermId,
        incotermId2,
        findesc,
        finext,
        currency
      ).then((res: any) => {
        setAllFindoc(res.data.data.data)
        setNumberURL2(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [findesc, finext, currency])
  //#endregion

  const [language, setLanguage] = useState<any>()

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  CustomUseEffect(() => {
    let tempArray: any[] = []
    addedkuantum.forEach((item) => {
      tempArray.push(item.kuantum)
    })
    if (addedDetail.length < 1) {
    } else if (addedDetail.length == 1) {
      if (sektorID == '3') setCustGroup('Z4')
      else setCustGroup(addedDetail[0].segment_code)
    } else if (addedDetail.length > 1) {
      if (sektorID == '3') setCustGroup('Z4')
      else {
        let highestIndex = addedkuantum.indexOf(
          addedkuantum.find((element) => element.kuantum == Math.max(...tempArray))
        )
        setCustGroup(addedDetail[highestIndex].segment_code)
      }
    }
  }, [addedkuantum])

  const [totalafterppn, setTotalAfterPPN] = useState<any>(0)

  useEffect(() => {
    if (priceBefore + totalPriceProductBefore >= 10000000) {
      setTotalAfterPPN(
        priceAfter +
          totalPriceProductAfter -
          ((priceBefore + totalPriceProductBefore) * parseFloat(pph22)) / 100
      )
    } else {
      if (sektorID != '3')
        setTotalAfterPPN(parseFloat(priceAfter) + parseFloat(totalPriceProductAfter))
      else setTotalAfterPPN(parseFloat(priceAfter) + parseFloat(totalPriceProductAfter))
    }
  }, [priceBefore, totalPriceProductBefore])

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const [letterData, setletterData] = useState<any>({})
  const [isPreviewLoading, setIsPreviewLoading] = useState(false)

  const handleShowPreview = async () => {
    setIsPreviewLoading(true)
    let temp: any[] = []
    let tempquantum = addedkuantum
    let tempspec = specPayload
    let templant = plantPayload2
    if (addedDetail.length > 0) {
      addedDetail.forEach((element) => {
        temp.push(element)
      })
    }
    if (addedProduct.length > 0) {
      addedProduct.forEach((element) => {
        temp.push(element)
        tempquantum.push({kuantum: element.request_quantum, index: 0})
        tempspec.push(element.product_spec)
        templant.push(element.plant_desc)
      })
    }
    const tempaccessdata = JSON.parse(localStorage.getItem('accesses')!)
    let tempsales = ''
    let tempConfig = ''
    let tempTanggal = pickupDate
    if (salesorg != null && salesorg != undefined) tempsales = salesorg
    else tempsales = ''

    if(sektorID == '2'){
      try{
        await getBatasTanggalLetter(totalquant + totalQuantumProduct, tempsales, i18next.language, sektorID).then(
          (res) => {
            tempTanggal = res.data.data
          }
        )
      }catch(e){
        console.log(e)
      }
    }
    await getConfigLetter(tempsales, 'sales-order').then((res) => {
      if (language === 'en') tempConfig = res.data.data.english?.content
      else tempConfig = res.data.data.indonesia?.content
      
      setletterData({
        lang: i18next.language,
        // customer: customerName ? (customerTitle ?? "") + ' ' + customerName : '',
        customer: [
          customerTitle,
          customerName
        ].join(" "),
        configletter: tempConfig,
        address: customerAddress ? customerAddress : '',
        customerAddress: customerPreview || '',
        shippingTolerance_so: orderItems,
        namaAnper: isSalesOrSuperAdmin ? (tempaccessdata?.name ? tempaccessdata.name : '') : '',
        customerAttn: i18next.language == 'id' ? attn : (attnEn || (attn || '')),
        subItem: temp ? temp : '',
        payloadSpec: tempspec ? tempspec : '',
        payloadQuantum: tempquantum,
        payloadPlant: templant ? templant : '',
        payloadPlantEn: plantEnPayload ? plantEnPayload : '',
        typeTransport: i18next.language == 'id' ? transType : transType2,
        transport: transportasi ? transportasi : '',
        etaTransport: ETA ? ETA : '',
        port: pot ? pot : '',
        portLoading: portLoading ? portLoading : '',
        sektor: sektorID ? sektorID : '',
        kontrakNum: SAPNum ? SAPNum : '',
        sailing: sailingDate ? sailingDate : '',
        bast: i18next.language == 'id' ? textBAST : (textBASTEn || (textBAST || '')),
        sales: salesDivision ? salesDivision : '',
        picSales: picSalesDivision ? picSalesDivision : '',
        term: i18next.language == 'id' ? TOS : (TOSEn || (TOS || '')),
        termSi: i18next.language == 'id' ? TOSsi : (TOSsiEn || (TOSsi || '')),
        ref: i18next.language == 'id' ? referensi : (referensiEn || (referensi || '')),
        tanggalShip: shippingInstruction ? shippingInstruction : '',
        inv: i18next.language == 'id' ? invoice : (invoiceEn || (invoice || '')),
        textPenutup: i18next.language == 'id' ? penutup : (penutupEn || (penutup || '')),
        keterangan: i18next.language == 'id' ? textKeterangan : (textKeteranganEn || (textKeterangan || '')),
        footerCon: '',
        contractNumber: kontrakid ? kontrakid : '',
        signername: assinger ? assinger : '',
        singerposition: position ? position : '',
        cusName: custPICName ? custPICName : '',
        cusPosition: custPICPosition ? custPICPosition : '',
        custgroup: custGroup ? custGroup : '',
        batasTanggal: tempTanggal,
        salesorgname: salesorgname ? salesorgname : '',
        sotype: 'create',
        imgHeader: imgHeader ? imgHeader?.url_file : '',
        imgFooter: imgFooter ? imgFooter?.url_file : '',
        incoterm1: fullIncoterm?.find((item: any) => item.value == incotermId)?.label,
        incoterm2: incotermId2,
      })
      setShowLetter(true)
    })
    setIsPreviewLoading(false)
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  function handleShowRoleNameFromState(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length)
        temp = temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label
      else
        temp =
          temp + fullRole[fullRole.findIndex((item: any) => item.value == element)].label + ', '
    })
    return temp
  }

  const loadSigningConfig = async () => {
    if(!signingPayload.province_id || !signingPayload.city_id) return

    setBtnLoading(true)

    const res = await getForModule(signingPayload)
      .then((res: any) => {
        const resp = res.data.data
        if (resp) {
          if (!namaPenandatanganFinance) {
            setNamaPenandatanganFinance(resp.signer_name)
          }
          if (!posisiPenandatanganFinance) {
            setPosisiPenandatanganFinance(resp.signer_position)
          }
        }
      })
      .catch((err: any) => {
        swal({
          title: `${t(err.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const [loadingSIP, setLoadingSIP] = useState(false);
  const [loadingCust, setLoadingCust] = useState(false);
  const [loadingFindoc, setLoadingFindoc] = useState(false);
  const isSalesOrSuperAdmin = ['salesAnper', 'admin'].includes(roleUser)

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('page create so')}</PageTitle>
      <div className='card'>
        {/* begin::Header */}

        <div className='card-body'>
          <Row>
            <Col md={6}>
              <div className='w-100'>
                <Row>
                  <Col md={5}>
                    <p className='fs-4 mt-2'>{t('kontrak-nomor')} SAP</p>
                  </Col>
                  <Col md={7}>
                    <div className='d-flex'>
                      <Form.Control
                        type='text'
                        size='sm'
                        className='me-1'
                        disabled
                        placeholder={t('kontrak-nomor') + ' SAP'}
                        value={SAPNum}
                      />
                      <Button
                        className='btn btn-primary d-flex justify-content-center align-items-center'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('Browse')}
                        onClick={handleShow4}
                      >
                        <KTSVG path='/media/icons/duotune/browse.svg' className='svg-icon-3 ms-2' />
                      </Button>
                      <Modal
                        show={show4}
                        onHide={handleClose4}
                        centered
                        backdrop='static'
                        keyboard={false}
                        size='lg'
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{t('Browse')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <TableBrowseSIP
                            loading={loadingSIP}
                            contractList={fullKontrak}
                            tooltip={tooltip}
                            paginateNumber={paginateNumber}
                            numberURL={numberURL}
                            onRowExpand={handleOpen}
                            onSelectedContract={(item) => {
                              setKontrakID(item.id)
                              getSubContract(item.id)
                              setSAPNun(item.sap_number)
                              setSektor(item.sector_id)
                            }}
                          />
                        </Modal.Body>
                      </Modal>
                    </div>

                    {/* <Form.Select
                      aria-label='Default select example'
                      size='sm'
                      disabled={isSelected}
                      onChange={(e: any) => {
                        getSubContract(e.target.value)
                        setIsSelected(true)
                        setKontrakID(e.target.value)
                      }}
                    >
                      <option selected>{t("pilih")} menu</option>
                      {fullKontrak.map((item: any) => {
                        return <option value={item.id}>{item.contract_number}</option>
                      })}
                    </Form.Select> */}
                  </Col>
                </Row>
                <Row className='mt-3'>
                  <Col md={5}>
                    <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Control
                      type='text'
                      value={customerCode}
                      placeholder={t('Customer Number')}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                {sektor == 2 || isSalesOrSuperAdmin ? (
                  <>
                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>Incoterm</p>
                      </Col>
                      <Col md={7}>
                        <Select
                          id='incoterm1'
                          key={incotermId + fullIncoterm}
                          placeholder={t('pilih') + ' Incoterm'}
                          onChange={(e: any) => separateValue2(setIncotermId, e.value)}
                          options={fullIncoterm}
                          defaultValue={
                            fullIncoterm[
                              fullIncoterm.findIndex((item: any) => item.value == incotermId)
                            ]
                          }
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )}

                <Row className='mt-3'>
                  <Col md={5}>
                    <p className='fs-4 mt-2'>{t('negara')}</p>
                  </Col>
                  <Col md={7}>
                    <Form.Select
                      aria-label='Default select example'
                      size='sm'
                      id='negara'
                      onChange={(e: any) => {
                        let _split = e.target.value?.split("~#~")
                        setNegaraCode(_split[0])
                        setNegara(_split[1])
                        setProvinsiTujuan('')
                        setProvinsiTujuan2('')
                      }}
                    >
                      <option selected value=''>
                        {t('Pilih-country')}
                      </option>
                      {Country.dataCountry.map((item: any, index: number) => {
                        return (
                          <option
                            key={item?.name ?? index}
                            selected={item.name == negara ? true : false}
                            value={[
                              item.code,
                              item.name
                            ].join("~#~")}
                          >
                            {item.name}
                          </option>
                        )
                      })}
                    </Form.Select>
                  </Col>
                </Row>
                {sektor == 2 || isSalesOrSuperAdmin ? (
                  <>
                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>Sales Office</p>
                      </Col>
                      <Col md={7}>
                        <Select
                          id='provinsi'
                          placeholder={t('pilih')}
                          onChange={(e: any) => setProvinsi(e?.value)}
                          key={fullProvince + provinsi}
                          defaultValue={
                            fullProvince[
                              fullProvince.findIndex((item: any) => item.value === provinsi)
                            ]
                          }
                          options={fullProvince}
                        />
                        {/* <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={provinsi2}
                              disabled
                            /> */}
                      </Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )}
                {sektor == 2 || isSalesOrSuperAdmin ? (
                  <>
                    <Row className='mt-3 align-items-center'>
                      <Col lg={5}>
                        <p className='fs-4'>
                          {t('Customer Account Group')}
                          {/* <span className='text-danger'>*</span> */}
                        </p>
                      </Col>
                      <Col lg={7}>
                        <Select
                          key={addedkuantum + fullCust + custGroup}
                          placeholder={t('pilih') + ' ' + t('Customer Account Group')}
                          defaultValue={
                            fullCust[fullCust.findIndex((item: any) => item.value == custGroup)]
                          }
                          onChange={(e: any) => setCustGroup(e?.value)}
                          options={fullCust}
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )}

                <Row className='mt-3'>
                  <Col md={5}>
                    <p className='fs-4 mt-2'>
                      {t('so-jenisAngkut')}
                      <span className='text-danger'>*</span>
                    </p>
                  </Col>
                  <Col md={7}>
                    {/* <Form.Control
                        aria-label='Default select example'
                        size='sm'
                        id='ttrans'
                        placeholder={t('so-jenisAngkut')}
                        onChange={(e: any) => setTransType(e.target.value)}
                      /> */}
                    <Form.Select
                      aria-label='Default select example'
                      size='sm'
                      id='ttrans'
                      placeholder={t('so-jenisAngkut')}
                      onChange={(e: any) => separator2(e.target.value, setTransType, setTransType2)}
                    >
                      <option selected value='~#~'>
                        {t('pilih')} {t('so-jenisAngkut')}
                      </option>
                      {fullTransport.map((item: any) => {
                        return (
                          <>
                            <option value={item.name_id + ',' + item.name_en}>
                              {i18next.language == 'en' ? item.name_en : item.name_id}
                            </option>
                          </>
                        )
                      })}
                    </Form.Select>
                  </Col>
                </Row>

                {sektor == 2 || isSalesOrSuperAdmin ? (
                  <>
                    <Row className='mt-3'>
                      <Col md={5}>
                        <p className='fs-4 mt-2'>{t('Assigner Name')}</p>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          size='sm'
                          id='assname'
                          placeholder={t('Assigner Name')}
                          defaultValue={assinger}
                          onChange={(e: any) => setAssigner(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  ''
                )}

                {transType != 'Truk' && (
                  <Row className='mt-3'>
                    <Col md={5}>
                      <p className='fs-4 mt-2'>{t('so-rencana')}</p>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        placeholder={t('so-rencana')}
                        id='plan'
                        size='sm'
                        onChange={(e: any) => setRencana(e.target.value)}
                      />
                    </Col>
                  </Row>
                )}

                <Row className='mt-3'>
                  <Col md={5}>
                    <p className='fs-4 mt-2'>
                      {t('so-jenisP')}
                      <span className='text-danger'>*</span>
                    </p>
                  </Col>
                  <Col md={7}>
                    <Form.Select
                      aria-label='Default select example'
                      size='sm'
                      id='payment'
                      onChange={(e: any) => {
                        const temp = e.target.value.split(',')
                        setPay(temp[0])
                        setPaySAP(temp[1])
                        setFindoc('')
                        if (temp[1] == 'P') {
                          hitTOP()
                        }
                      }}
                    >
                      <option value={''} selected>
                        {t('Pilih-payment')}
                      </option>
                      {fullPayment.map((item: any) => {
                        if (roleUser == null || roleUser == 'null') {
                          return (
                            <option value={item.code + ',' + item.code_sap}>
                              {sektorID == '3' ? item.payment_desc : item.payment_desc_id}
                            </option>
                          )
                        } else {
                          return (
                            <option value={item.code + ',' + item.code_sap}>
                              {sektorID == '3' ? item.payment_desc : item.payment_desc_id}
                            </option>
                          )
                        }
                      })}
                    </Form.Select>
                  </Col>
                </Row>

                {paySAP == 'M' || paySAP == 'DF' ? (
                  <Row className='mt-3'>
                    <Col md={5}>
                      <p className='fs-4 mt-2'>{t('add')} Findoc</p>
                    </Col>
                    <Col md={7}>
                      <div className='d-flex'>
                        <Form.Control className='me-1' disabled value={selectedFindoc} size='sm' />
                        <Button
                          className='btn btn-primary d-flex justify-content-center align-items-center'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Browse')}
                          onClick={() => handlebrowsefindoc()}
                        >
                          <KTSVG
                            path='/media/icons/duotune/browse.svg'
                            className='svg-icon-3 ms-2'
                          />
                        </Button>
                        <Modal
                          show={showBrowseFindoc}
                          onHide={() => setShowBrowseFindoc(false)}
                          centered
                          backdrop='static'
                          keyboard={false}
                          size='lg'
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>{t('Browse')}</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className='table-responsive bdr'>
                              <table className='table'>
                                <thead>
                                  <tr className='w-100 align-items-center'>
                                    <th className='text-center p-4'></th>
                                    <th className='text-center'>{t('No Findoc SAP')}</th>
                                    <th className='text-center'>
                                      {t('Ext Findoc Number')}
                                    </th>
                                    <th className='text-center'>
                                      {t('SKPP/Letco number/SO')}
                                    </th>
                                    <th className='text-center'>{t('Nilai Findoc')}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr className='w-100 align-items-center'>
                                    <td className='text-center p-4' style={{height: 51}}>
                                      <div className='text-transparent'>-</div>
                                    </td>
                                    <td className='text-center pm-0'>
                                      <TextInputV2
                                        placeholder={t('No Findoc SAP')}
                                        // style={{ padding: '8px 0', border: 0 }}
                                        // value={filter?.customer_code ?? ''}
                                        // onChange={({ target }) =>
                                        //   dispatch(setCustomerFilter({ ...filter, customer_code: target.value }))
                                        // }
                                      />
                                    </td>
                                    <td className='text-center pm-0'>
                                      <TextInputV2
                                        placeholder={t('Ext Findoc Number')}
                                        // style={{ padding: '8px 0', border: 0 }}
                                        // value={filter?.name ?? ''}
                                        // onChange={({ target }) =>
                                        //   dispatch(setCustomerFilter({ ...filter, name: target.value }))
                                        // }
                                      />
                                    </td>
                                    <td className='text-center pm-0'>
                                      <TextInputV2
                                        placeholder={t('SKPP/Letco number/SO')}
                                        // style={{ padding: '8px 0', border: 0 }}
                                        // value={filter?.name ?? ''}
                                        // onChange={({ target }) =>
                                        //   dispatch(setCustomerFilter({ ...filter, name: target.value }))
                                        // }
                                      />
                                    </td>
                                    <td className='text-center pm-0'>
                                      <TextInputV2
                                        placeholder={t('Nilai Findoc')}
                                        // style={{ padding: '8px 0', border: 0 }}
                                        // value={filter?.name ?? ''}
                                        // onChange={({ target }) =>
                                        //   dispatch(setCustomerFilter({ ...filter, name: target.value }))
                                        // }
                                      />
                                    </td>
                                  </tr>
                                  { loadingFindoc && 
                                  <tr className='w-100 align-items-center'>
                                    <th className='text-center p-4'>
                                    <Skeleton width={'80%'} height={30}/>
                                    </th>
                                    <th className='text-center'>
                                    <Skeleton width={'80%'} height={30}/>
                                    </th>
                                    <th className='text-center'>
                                    <Skeleton width={'80%'} height={30}/>
                                    </th>
                                    <th className='text-center'>
                                    <Skeleton width={'80%'} height={30}/>
                                    </th>
                                    <th className='text-center'>
                                    <Skeleton width={'80%'} height={30}/>
                                    </th>
                                  </tr> }
                                  {!loadingFindoc && !allFindoc.length && <tr className='w-100 align-items-center'>
                                      <td colSpan={5} className='text-center w-100'>No Data</td>
                                    </tr>}
                                  {(!loadingFindoc && allFindoc.length > 0) && (
                                    <>
                                      {allFindoc.map((item: any, index: any) => {
                                        return (
                                          <tr
                                            key={item?.id ?? index}
                                            className={`w-100 align-items-center ${
                                              index % 2 === 0 && 'bg-secondary'
                                            }`}
                                          >
                                            <td className='text-center'>
                                              <Form.Check
                                                reverse
                                                type='checkbox'
                                                className='m-4'
                                                id={
                                                  item.id +
                                                  '~#~' +
                                                  item.top +
                                                  '~#~' +
                                                  item.top +
                                                  '~#~' +
                                                  item.num_findoc
                                                }
                                                onChange={(e: any) => {
                                                  separator(
                                                    e.target.id,
                                                    setFindoc,
                                                    setTOP,
                                                    setTOP2,
                                                    setSelectedFindoc
                                                  )
                                                  setShowBrowseFindoc(false)
                                                }}
                                              />
                                            </td>
                                            <td className='text-center'>
                                              <span className='d-block' style={{padding: '.08rem 0'}}>
                                                {item.sap_number}
                                              </span>
                                            </td>
                                            <td className='text-center'>
                                              <span className='d-block' style={{padding: '.08rem 0'}}>
                                                {item.num_findoc}
                                              </span>
                                            </td>
                                            <td className='text-center'>
                                              <span className='d-block' style={{padding: '.08rem 0'}}>
                                                {item.no_skpp}
                                              </span>
                                            </td>
                                            <td className='text-center'>
                                              <span className='d-block' style={{padding: '.08rem 0'}}>
                                                {item.nilai}
                                              </span>
                                            </td>
                                          </tr>
                                        )
                                      })}
                                    </>
                                  )}
                                </tbody>
                              </table>
                              { allFindoc.length > 0 && 
                              <div className='my-5'>
                                <Pagination paginate={paginateNumber2} test={numberURL2} />
                              </div> }
                            </div>
                          </Modal.Body>
                        </Modal>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  ''
                )}

                {paySAP == 'M' || paySAP == 'DF' ? (
                  <Row className='mt-3'>
                    <Col md={5}>
                      <p className='fs-4 mt-2'>TOP</p>
                    </Col>
                    <Col md={7}>
                      <Form.Select aria-label='Default select example' size='sm' disabled>
                        <option selected disabled hidden>
                          {top2.slice(1, 100)} {t('Days')}
                        </option>
                      </Form.Select>
                    </Col>
                  </Row>
                ) : (
                  ''
                )}

                {paySAP == 'P' && (
                  <Row className='mt-3'>
                    <Col md={5}>
                      <p className='fs-4 mt-2'>TOP</p>
                    </Col>
                    <Col md={7}>
                      <Form.Select
                        aria-label='Default select example'
                        size='sm'
                        onChange={(e: any) => setTOP(e.target.value)}
                      >
                        <option selected value=''></option>
                        {fullTOP.map((item: any) => {
                          return (
                            <>
                              {item.code != 'Z0LC' ? (
                                <option value={item.code}>
                                  {item.code?.slice(1, 100)} {t('Days')}
                                </option>
                              ) : (
                                <option value={item.code}>Letter of Credit TOP</option>
                              )}
                            </>
                          )
                        })}
                      </Form.Select>
                    </Col>
                  </Row>
                )}

                {/* <Row className='mt-3' hidden={isSalesOrSuperAdmin ? false : true}>
                        <Col md={5}>
                          <p className='fs-4 mt-2'>{t('Ship To')}</p>
                        </Col>
                        <Col md={7} className='d-flex justify-content-end'>
                        <Form.Check
                          reverse
                          className='mt-2 mb-2'
                          type='checkbox'
                          id='ckbox-ship'
                          onClick={() => setShipTo(!shipto)}
                        />
                        </Col>
                        </Row> */}

                <Row className='mt-2' hidden={isSalesOrSuperAdmin ? false : true}>
                  <Col md={5}>
                    <p className='fs-4 mt-2'>{t('Ship To')}</p>
                  </Col>
                  <Col md={7}>
                    <div className='d-flex' style={{width: '100%'}}>
                      <Form.Control
                        type='text'
                        size='sm'
                        className='w-100'
                        disabled
                        // placeholder={approveState ? 'Search' + ' ' + t('Customer') : ''}
                        placeholder={t('Ship To')}
                        value={customer}
                        style={{width: '70%'}}
                      />
                      <Button
                        className='btn btn-primary d-flex justify-content-center align-items-center ms-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('telusuri')}
                        onClick={() => handleCustomer()}
                      >
                        <KTSVG path='/media/icons/duotune/browse.svg' className='svg-icon-3 ms-2' />
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Row
                  className='mt-2'
                  hidden={roleUser == 'null' && customerID != 0 && customer != null ? false : true}
                >
                  <Col md={5}>
                    <p className='fs-4 mt-2'>{t('Ship To')}</p>
                  </Col>
                  <Col md={7}>
                    <div className='d-flex' style={{width: '100%'}}>
                      <Form.Control
                        type='text'
                        size='sm'
                        className='w-100'
                        disabled
                        // placeholder={approveState ? 'Search' + ' ' + t('Customer') : ''}
                        placeholder={t('Ship To')}
                        value={customer}
                        style={{width: '70%'}}
                      />
                    </div>
                  </Col>
                </Row>
              </div>

              <Modal
                show={showCustomer}
                onHide={() => setShowCustomer(false)}
                centered
                backdrop='static'
                keyboard={false}
                size='lg'
              >
                <Modal.Header closeButton>
                  <Modal.Title>{t('Browse')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <TableBrowseCustomer
                    onSelectedCustomer={(item) => {
                      setCustomer(!item.title ? item.name : `${item.title} ${item.name}`)
                      setCustomerID(item.customer_code)
                      setShowCustomer(false)
                    }}
                  />
                </Modal.Body>
              </Modal>
            </Col>

            <Col md={6}>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Address')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    as='textarea'
                    value={customerAddress}
                    placeholder={t('Address')}
                    disabled
                    size='sm'
                    style={{height: '40px'}}
                  />
                </Col>
              </Row>

              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='text'
                    value={customerName}
                    placeholder={t('Customer Name')}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>

              {sektor == 2 || isSalesOrSuperAdmin ? (
                <>
                  <Row className='mt-3'>
                    <Col md={5}>
                      <p className='fs-4 mt-2'>
                        Incoterm 2{/* <span className='text-danger'>*</span> */}
                      </p>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        aria-label='Default select example'
                        size='sm'
                        id='inco2'
                        defaultValue={incotermId2}
                        placeholder='Incoterm 2'
                        onChange={(e: any) => setIncotermId2(e.target.value)}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              <Row className='mt-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('provinsi-tujuan')}</p>
                </Col>
                <Col md={7}>
                  <Select
                    onChange={(e: any) =>
                      separator2(e.value, setProvinsiTujuan, setProvinsiTujuan2)
                    }
                    id='provinsitujuan'
                    placeholder={t('pilih')}
                    defaultValue={
                      fullProvince2[
                        fullProvince2.findIndex((item: any) => item.label === provinsiTujuan2)
                      ]
                    }
                    key={negara}
                    options={sektorID == '1' && negara == 'Indonesia' ? fullProvince2 : []}
                  />
                </Col>
              </Row>

              {sektor == 2 || isSalesOrSuperAdmin ? (
                <>
                  <Row className='mt-3'>
                    <Col md={5}>
                      <p className='fs-4 mt-2'>Sales Group</p>
                    </Col>
                    <Col md={7}>
                      <Select
                        onChange={(e: any) => setCity(e?.value)}
                        key={fullCity}
                        placeholder={t('pilih')}
                        defaultValue={
                          fullCity[fullCity.findIndex((item: any) => item.value === city)]
                        }
                        options={fullCity}
                      />
                      {/* <Form.Control
                            aria-label='Default select example'
                            size='sm'
                            value={city2}
                            disabled
                          /> */}
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}

              {sektor == 2 || isSalesOrSuperAdmin ? (
                <>
                  <Row className='mt-3 align-items-center'>
                    <Col lg={5}>
                      <p className='fs-4'>
                        {t('Account Assignment group')}
                        {/* <span className='text-danger'>*</span> */}
                      </p>
                    </Col>
                    <Col lg={7}>
                      <Select
                        key={fullAssign + custGroup + custassingchanged}
                        placeholder={t('pilih') + ' ' + t('Account Assignment group')}
                        defaultValue={
                          fullAssign[fullAssign.findIndex((item: any) => item.value === custAssign)]
                        }
                        onChange={(e: any) => setCustAssing(e?.value)}
                        options={fullAssign}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}

              <Row className='mt-3 align-items-center'>
                <Col md={5}>
                  <p className='fs-4'>
                    {t('so-namaAngkut')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    aria-label='Default select example'
                    size='sm'
                    id='angkutan'
                    placeholder={t('so-namaAngkut')}
                    onChange={(e: any) => setTransportasi(e.target.value)}
                  />
                </Col>
              </Row>

              {sektor == 2 || isSalesOrSuperAdmin ? (
                <>
                  <Row className='mt-3'>
                    <Col md={5}>
                      <p className='fs-4 mt-2'>{t('Assigner Position')}</p>
                    </Col>
                    <Col md={7}>
                      <Form.Control
                        id='asspos'
                        size='sm'
                        placeholder={t('Assigner Position')}
                        defaultValue={position}
                        onChange={(e: any) => setPosition(e.target.value)}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                ''
              )}

              <Row className='mt-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Tujuan')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    type='text'
                    id='port'
                    placeholder={t('Tujuan')}
                    size='sm'
                    onChange={(e: any) => setPot(e.target.value)}
                  />
                </Col>
              </Row>

              {transType === 'Kapal' && (
                <Row className='mt-3'>
                  <Col md={5}>
                    <p className='fs-4 mt-2'>{t('so-hydro')}</p>
                  </Col>
                  <Col md={7}>
                    <Button
                      variant='primary'
                      id='btnupload2'
                      onClick={() => {
                        setUploadType('hydro')
                        setShowUpload(true)
                        setIsExceed(false)
                      }}
                    >
                      {t('order-lampiranUpload')}
                    </Button>
                  </Col>
                </Row>
              )}

              {transType === 'Kapal' && (
                <Row className='mt-3'>
                  <Col md={5}>
                    <p className='fs-4 mt-2'>{t('so-ship')}</p>
                  </Col>
                  <Col md={7}>
                    <Button
                      variant='primary'
                      id='btnupload'
                      onClick={() => {
                        setUploadType('ship')
                        setShowUpload(true)
                        setIsExceed(false)
                      }}
                    >
                      {t('order-lampiranUpload')}
                    </Button>
                    <Modal
                      show={showUpload}
                      onHide={() => {
                        setFiles3(null)
                        setNamaFile('')
                        setUploadType('')
                        setShowUpload(false)
                      }}
                      backdrop='static'
                      keyboard={false}
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          {uploadType == 'hydro' ? t('so-hydro') : t('so-ship')}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Col sm={3} className='mt-4'>
                            <h6>{t('order-fileUnggah')}</h6>
                          </Col>
                          <Col sm={9}>
                            <div className='d-flex'>
                              <InputFile
                                  setFileName={(_: string) => {}}
                                  setFiles={setTempfiles}
                                  isBase64={false}
                              />
                              {uploadType === 'hydro' ? (
                                <button
                                  onClick={() => {
                                    handleDownloadBase64(fileHydro)
                                  }}
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('unduh')}
                                  hidden={fileHydro === null ? true : false}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrow-down-square-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    handleDownloadBase64(shipParticularFiles)
                                  }}
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('unduh')}
                                  hidden={shipParticularFiles === null ? true : false}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrow-down-square-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              )}
                            </div>
                          </Col>
                          <Button
                            variant='primary'
                            className='w-100 mt-5'
                            onClick={() => closeupload()}
                          >
                            {t('order-kirim')}
                          </Button>
                        </Row>
                      </Modal.Body>
                    </Modal>
                  </Col>
                </Row>
              )}

              {/* <Row className='mt-3' hidden={isSalesOrSuperAdmin ? false : true}>
                    <Col lg={5}>
                      <p className='fs-4 mt-2'>
                        {t('nomorIzinExport')}
                        <span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col lg={7}>
                      <Form.Control
                        type='text'
                        key={SAPNum}
                        onChange={(e: any) => setNoExport(e.target.value)}
                        defaultValue={noExport}
                        placeholder={t('nomorIzinExport')}
                        size='sm'
                      />
                    </Col>
                  </Row> */}
            </Col>
          </Row>

          <hr />

          {kontrakid != '' && (
            <div className='my-2 d-flex'>
              <Button
                className='btn btn-primary me-2'
                onClick={() => {
                  setProduct('')
                  setProductCode('')
                  setSpekProduk('')
                  setIncoterm('')
                  setSloc('')
                  setSlocDesc('')
                  setLeftoverQuantum(0)
                  setTotalKuantumAdd(0)
                  setPtype('')
                  handleShow2()
                }}
              >
                {t('+tambah') + ' SO'}
              </Button>
              <Button
                hidden={isSalesOrSuperAdmin ? false : true}
                className='btn btn-primary me-2'
                onClick={() => handleTambahProduct()}
              >
                {t('+tambah product')}
              </Button>

              <Button
                className='btn btn-primary'
                hidden={isSalesOrSuperAdmin ? false : true}
                onClick={() => setShowAdditional(true)}
              >
                {t('addtional')} {t('text')}
              </Button>
              <Modal
                show={showAdditional}
                onHide={() => setShowAdditional(false)}
                centered
                backdrop='static'
                keyboard={false}
                scrollable
                size='lg'
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {t('addtional')} {t('text')}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex justify-content-end mb-3">
                    <div style={{maxWidth: 140}} className='btn-lang d-flex'>
                      <button
                        className={'d-flex align-items-center me-1 '+ (addTextLanguage == 'id' ? 'active' : '')}
                        onClick={()=> setAddTextLanguage('id')}
                      >
                        <h6 className='ms-1'>Ind</h6>
                      </button>
                      <button
                        className={'d-flex align-items-center me-1 '+ (addTextLanguage == 'en' ? 'active' : '')}
                        onClick={()=> setAddTextLanguage('en')}
                      >
                        <h6 className='ms-1'>Eng</h6>
                      </button>
                    </div>
                  </div>


                  { addTextLanguage == 'id' && <div>
                    <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'customer pic name'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('customer pic name')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'customer pic name'}>
                      <Form.Control
                        className='mt-3'
                        as='textarea'
                        //maxLength={132}
                        aria-label='Default select example'
                        onChange={(e: any) => setCustPICName(e.target.value)}
                        placeholder={t('customer pic name')}
                        defaultValue={custPICName}
                      />
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer pic name', setCustPICName, custPICName_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'customer pic position'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('customer pic position')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'customer pic position'}>
                      <RichText
                        containerClassName='mt-4'
                        content={custPICPosition}
                        onUpdate={({editor}) => setCustPICPosition(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer pic position', setCustPICPosition, custPICPosition_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'nama tanda tangan'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('nama penandatangan keuangan')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'nama tanda tangan'}>
                      <Form.Control
                        className='mt-3'
                        as='textarea'
                        aria-label='Default select example'
                        onChange={(e: any) => setNamaPenandatanganFinance(e.target.value)}
                        placeholder={t('nama penandatangan keuangan')}
                        defaultValue={namaPenandatanganFinance}
                      />
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'posisi tanda tangan'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('posisi penandatangan keuangan')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'posisi tanda tangan'}>
                      <Form.Control
                        className='mt-3'
                        as='textarea'
                        aria-label='Default select example'
                        onChange={(e: any) => setPosisiPenandatanganFinance(e.target.value)}
                        placeholder={t('posisi penandatangan keuangan')}
                        defaultValue={posisiPenandatanganFinance}
                      />
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'sailing date'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('sailing date')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'sailing date'}>
                      <Form.Control
                        className='mt-3'
                        type='date'
                        aria-label='Default select example'
                        onChange={(e: any) => setSailingDate(e.target.value)}
                        placeholder={t('sailing date')}
                        defaultValue={sailingDate}
                      />
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('sailing date', setSailingDate, sailingDate_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'port of discharge'}
                        onClick={handleOpenn}
                      >
                        <div className="text-light">{t('port of discharge')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'port of discharge'}>
                      <Form.Control
                        className='mt-3'
                        as='textarea'
                        //maxLength={132}
                        aria-label='Default select example'
                        onChange={(e: any) => setPortDischarge(e.target.value)}
                        placeholder={t('port of discharge')}
                        defaultValue={portDischarge}
                      />
                      <div className="d-flex justify-content-end">
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('port of discharge', setPortDischarge, portDischarge)}>{t('Save')}</button>
                      </div>
                    </div>
                  </Form.Group> */}

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'port of loading'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('port of loading')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'port of loading'}>
                      <RichText
                        containerClassName='mt-4'
                        content={portLoading}
                        onUpdate={({editor}) => setPortLoading(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('port of loading', setPortLoading, portLoading_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'additional text bast'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('additional text bast')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'additional text bast'}>
                      <RichText
                        containerClassName='mt-4'
                        content={textBAST}
                        onUpdate={({editor}) => setTextBAST(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('additional text bast', setTextBAST, textBAST_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'sales division'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('sales division')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'sales division'}>
                      <RichText
                        containerClassName='mt-4'
                        content={salesDivision}
                        onUpdate={({editor}) => setSalesDivision(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('sales division', setSalesDivision, salesDivision_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'pic sales division'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('pic sales division')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'pic sales division'}>
                      <RichText
                        containerClassName='mt-4'
                        content={picSalesDivision}
                        onUpdate={({editor}) => setPicSalesDivision(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('pic sales division', setPicSalesDivision, picSalesDivision_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'transportation media'}
                        onClick={handleOpenn}
                      >
                        <div className="text-light">{t('transportation media')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'transportation media'}>
                      <Form.Control
                        className='mt-3'
                        as='textarea'
                        //maxLength={132}
                        aria-label='Default select example'
                        onChange={(e: any) => setTransportMedia_(e.target.value)}
                        placeholder={t('transportation media')}
                        defaultValue={transportMedia}
                      />
                      <div className="d-flex justify-content-end">
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('transportation media', setTransportMedia, transportMedia_)}>{t('Save')}</button>
                      </div>
                    </div>
                  </Form.Group> */}

                  {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'transportation media info'}
                        onClick={handleOpenn}
                      >
                        <div className="text-light">{t('transportation media info')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'transportation media info'}>
                      <Form.Control
                        className='mt-3'
                        as='textarea'
                        //maxLength={132}
                        aria-label='Default select example'
                        onChange={(e: any) => setTransportMediaInfo_(e.target.value)}
                        placeholder={t('transportation media info')}
                        defaultValue={transportMediaInfo}
                      />
                      <div className="d-flex justify-content-end">
                        <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('transportation media info', setTransportMediaInfo, transportMediaInfo_)}>{t('Save')}</button>
                      </div>
                    </div>
                  </Form.Group> */}

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'term and condition'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('terms_and_conditions')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'term and condition'}>
                      <RichText
                        containerClassName='mt-4'
                        content={TOS}
                        onUpdate={({editor}) => setTOS(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition', setTOS, TOS_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'term and condition si'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('terms_and_conditions')} SI</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'term and condition si'}>
                      <RichText
                        containerClassName='mt-4'
                        content={TOSsi}
                        onUpdate={({editor}) => setTOSsi(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition si', setTOSsi, TOSsi_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'customer attn'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('customer attn')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'customer attn'}>
                      <RichText
                        containerClassName='mt-4'
                        content={attn}
                        onUpdate={({editor}) => setAttn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer attn', setAttn, attn_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'text penutup'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('text penutup')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'text penutup'}>
                      <RichText
                        containerClassName='mt-4'
                        content={penutup}
                        onUpdate={({editor}) => setPenutup(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('text penutup', setPenutup, penutup_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'eta moda angkut'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('eta moda angkut')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'eta moda angkut'}>
                      <Form.Control
                        className='mt-3'
                        type='date'
                        aria-label='Default select example'
                        onChange={(e: any) => setETA(e.target.value)}
                        placeholder={t('eta moda angkut')}
                        defaultValue={ETA}
                      />
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('eta moda angkut', setETA, ETA_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'Keterangan'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('Keterangan')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'Keterangan'}>
                      <RichText
                        containerClassName='mt-4'
                        content={textKeterangan}
                        onUpdate={({editor}) => setTextKeterangan(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>

                      {/* <Form.Control
                        className='mt-3'
                        as='textarea'
                        //maxLength={132}
                        aria-label='Default select example'
                        onChange={(e: any) => setTextKeterangan(e.target.value)}
                        placeholder={t('Keterangan')}
                        defaultValue={textKeterangan}
                      /> */}
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('Keterangan', setTextKeterangan, textKeterangan_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'referensi'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('referensi')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'referensi'}>
                      <RichText
                        containerClassName='mt-4'
                        content={referensi}
                        onUpdate={({editor}) => setReferensi(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('referensi', setReferensi, referensi_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'tanggal shipping instruction'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('tanggal shipping instruction')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'tanggal shipping instruction'}>
                      <Form.Control
                        className='mt-3'
                        type='date'
                        aria-label='Default select example'
                        onChange={(e: any) => setShippingInstruction(e.target.value)}
                        placeholder={t('tanggal shipping instruction')}
                        defaultValue={shippingInstruction}
                      />
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('tanggal shipping instruction', setShippingInstruction, shippingInstruction_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'invoice note'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('invoice note')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'invoice note'}>
                      <RichText
                        containerClassName='mt-4'
                        content={invoice}
                        onUpdate={({editor}) => setInvoice(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('invoice note', setInvoice, invoice_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'nomor export'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('nomorIzinExport')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'nomor export'}>
                      <RichText
                        containerClassName='mt-4'
                        content={noExport}
                        onUpdate={({editor}) => setNoExport(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('nomor export', setNoExport, noExport_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />
                  </div>}
                  { addTextLanguage == 'en' && <div>
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'additional text bast'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('additional text bast')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'additional text bast'}>
                      <RichText
                        containerClassName='mt-4'
                        content={textBASTEn}
                        onUpdate={({editor}) => setTextBASTEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('additional text bast', setTextBAST, textBAST_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'term and condition'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('terms_and_conditions')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'term and condition'}>
                      <RichText
                        containerClassName='mt-4'
                        content={TOSEn}
                        onUpdate={({editor}) => setTOSEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition', setTOS, TOS_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'term and condition si'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('terms_and_conditions')} SI</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'term and condition si'}>
                      <RichText
                        containerClassName='mt-4'
                        content={TOSsiEn}
                        onUpdate={({editor}) => setTOSsiEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('term and condition si', setTOSsi, TOSsi_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'customer attn'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('customer attn')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'customer attn'}>
                      <RichText
                        containerClassName='mt-4'
                        content={attnEn}
                        onUpdate={({editor}) => setAttnEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('customer attn', setAttn, attn_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'text penutup'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('text penutup')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'text penutup'}>
                      <RichText
                        containerClassName='mt-4'
                        content={penutupEn}
                        onUpdate={({editor}) => setPenutupEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('text penutup', setPenutup, penutup_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'Keterangan'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('Keterangan')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'Keterangan'}>
                      <RichText
                        containerClassName='mt-4'
                        content={textKeteranganEn}
                        onUpdate={({editor}) => setTextKeteranganEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>

                      {/* <Form.Control
                        className='mt-3'
                        as='textarea'
                        //maxLength={132}
                        aria-label='Default select example'
                        onChange={(e: any) => setTextKeterangan(e.target.value)}
                        placeholder={t('Keterangan')}
                        defaultValue={textKeterangan}
                      /> */}
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('Keterangan', setTextKeterangan, textKeterangan_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'referensi'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('referensi')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'referensi'}>
                      <RichText
                        containerClassName='mt-4'
                        content={referensiEn}
                        onUpdate={({editor}) => setReferensiEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('referensi', setReferensi, referensi_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />

                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <div className='d-flex align-items-center'>
                      <button
                        className='a btn btn-primary w-100'
                        data-target={'target' + 'invoice note'}
                        onClick={(e: any) => handleOpenn(e)}
                      >
                        <div className='text-light'>{t('invoice note')}</div>
                      </button>
                    </div>
                    <div className='fold' id={'target' + 'invoice note'}>
                      <RichText
                        containerClassName='mt-4'
                        content={invoiceEn}
                        onUpdate={({editor}) => setInvoiceEn(editor.getHTML())}
                      >
                        <div style={{display: 'none'}}>&nbsp;</div>
                      </RichText>
                      {/* <div className="d-flex justify-content-end">
                            <button className='btn btn-primary mt-3' onClick={() => handleSaveAdditionalText('invoice note', setInvoice, invoice_)}>{t('Save')}</button>
                          </div> */}
                    </div>
                  </Form.Group>
                  <hr />
                  </div>}

                </Modal.Body>
              </Modal>

              <Button
                onClick={handleShowPreview}
                className='btn btn-primary fw-semibold d-flex align-items-center ms-2'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title={t('preview')}
                disabled={isPreviewLoading}
              >
                {isPreviewLoading ? <Spinner animation='border' size='sm' /> : t('preview')}
              </Button>
              <Modal
                show={showLetter}
                onHide={() => setShowLetter(false)}
                size='xl'
                backdrop='static'
                keyboard={false}
                scrollable
              >
                <Modal.Header closeButton>
                  <Modal.Title>{t('preview')}</Modal.Title>
                </Modal.Header>
                <Modal.Body key={letterData}>
                  <ViewLetter data={letterData} type='so' />
                </Modal.Body>
              </Modal>
            </div>
          )}

          <div className='table-responsive bdr'>
            {/* Table Head */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                  <th className='td-150 text-center'>Sales Org</th>
                  <th className='td-250 text-center'>{t('kontrak-incoterm')}</th>
                  <th className='td-250 text-center'>{t('kontrak-aksi')}</th>
                  {sektorID == '1' ? <th className='td-150 text-center'>{t('segment')}</th> : ''}
                  <th className='td-250 text-center'>{t('sub-order-endUser')}</th>
                  <th className='td-250 text-center'>{t('Sektor')}</th>
                  <th className='td-150 text-center'>{t('kontrak-jenis')}</th>
                  <th className='td-150 text-center'>{t('Product Code')}</th>
                  <th className='td-250 text-center'>{t('kontrak-nama')}</th>
                  <th className='td-250 text-center'>{t('kontrak-spek')}</th>
                  <th className='td-150 text-center'>{t('kontrak-kuantum')}</th>
                  {/* <th className='td-150 text-center'>{t('sub-order-kuantumD')}</th>
                      {sektorID != 2 ? (<th className='td-order-6 text-center'>{t("Shipping Tolerance")}</th>) : ''}
                      <th className='td-150 text-center'>{t('quantumsisa')}</th> */}
                  <th className='td-order-6 text-center'>{t('Price')}</th>
                  <th className='td-150 text-center'>{t('kontrak-hargaPPN')}</th>
                  <th className='td-100 text-center'>PPN</th>
                  <th className='td-150 text-center'>{t('kontrak-hargaSPPN')}</th>
                  <th className='td-250 text-center'>{t('Plant')}</th>
                  {roleUser === 'salesAnper' ? (
                    <>
                      <th className='td-250 text-center'>{t('Route')}</th>
                    </>
                  ) : (
                    <></>
                  )}
                </tr>
              </thead>
              <tbody>
                {addedDetail.map((item: any, _index: number) => (
                  <tr key={'so' + _index} className='d-flex jusify-content-center w-100 align-items-center'>
                      <td className='td-150 d-flex justify-content-center align-items-center column'>
                        <div className='fs-6 d-flex text-center'>{item.produsen?.name}</div>
                      </td>
                      {item.sector?.id == 2 ? (
                        <>
                          {item.incoterm2 == null ? (
                            <td className='td-250 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                <PopoverText
                                  content={item.incoterm1?.code + '-' + item.incoterm2_id}
                                  index={_index}
                                  className='desc-slicee'
                                />
                              </span>
                            </td>
                          ) : (
                            <td className='td-250 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                <PopoverText
                                  content={item.incoterm1?.code + '-' + item.incoterm2?.code}
                                  index={_index}
                                  className='desc-slicee'
                                />
                              </span>
                            </td>
                          )}
                        </>
                      ) : (
                        <>
                          {item.incoterm2 == null ? (
                            <td className='td-250 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                <PopoverText
                                  content={
                                    item.incoterm1?.code +
                                    (item.incoterm2_id == null || item.incoterm2_id == '0'
                                      ? ''
                                      : '-' + item.incoterm2_id)
                                  }
                                  index={_index}
                                  className='desc-slicee'
                                />
                              </span>
                            </td>
                          ) : (
                            <td className='td-250 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                <PopoverText
                                  content={item.incoterm1?.code + '-' + item.incoterm2?.code}
                                  index={_index}
                                  className='desc-slicee'
                                />
                              </span>
                            </td>
                          )}
                        </>
                      )}
                      <td
                        className='td-250 d-flex justify-content-center column'
                        style={{padding: '1.09rem 0'}}
                      >
                      <button
                          onClick={() => {
                            setTempDetail(item)
                            setQuantumSO(addedkuantum[_index]?.kuantum)
                            setShowDetail(true)
                            dispatch(setOrderItem(item))
                          }}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title='Detail'
                        >
                        <KTSVG
                          path='/media/icons/duotune/file-text-fill.svg'
                          className='svg-icon-3'
                        />
                      </button>
                      <button
                        onClick={() => {
                          getplantproduct(item.material_number)
                          setKuantum(addedkuantum[_index]?.kuantum)
                          // setLeftoverQuantum(item.left_over_quantum_no_st)
                          handleLefoverObject(item.id, addedkuantum[_index]?.kuantum)
                          setPtype(item.product_type)
                          setPunit(item.unit)
                          setPtype2(item.product_type_desc)
                          setSingleSisaQuantum(
                            sisaQuantum[
                              sisaQuantum.findIndex((element: any) => element.id === item.id)
                            ]?.quantum
                          )
                          setIDSector(item.sector_id)
                          setSpekProduk(specPayload[_index])
                          setTempID(item.id)
                          setSelectedItem(item)
                          setIndex2(_index)
                          setNamaPlant(plantPayload2[_index])
                          setIDPlant(plantPayload[_index])
                          setSloc(slocPayload[_index])
                          setSlocDesc(slocPayload2[_index])
                          setRouteDesc(routePayload2[_index])
                          setRoute(routePayload[_index])
                          setKuantumSoRilis(item?.so_qty_realized)
                          setIncoterm(item.incoterm1.code)
                          setShippingToleranceContract(
                            orderItems[_index]?.shipping_tolerance_contract
                          )
                          setShipping(item?.shipping_tolerance_so)
                          setNote(item?.notes)
                          setPlantNameEn(plantEnPayload[_index])
                          setShowEdit(true)
                          dispatch(setOrderItem(orderItems[_index]))
                        }}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('ubah')}
                      >
                        <KTSVG
                          // pencil
                          path='/media/icons/duotune/pencil-fill.svg'
                          className='svg-icon-3'
                        />
                      </button>

                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('order-lampiran')}
                          onClick={() => {
                            setIDSector(item.sector_id)
                            setProvinceName(item.province?.region_name)
                            setCityName(item.city?.city_name)
                            setProductName(item.product_name)
                            formattingTon(item.fixed_quantum)
                            setIsFileBox(true)
                            // setSubOrderID(item.id)
                            // ambilAttachment(item.id)
                            setOrderItemsFiles(payloadAttachement[_index])
                            setIndex2(_index)
                            setUploadType('so-item')
                            setShowUpload3(true)
                          }}
                        >
                          <KTSVG
                            path='/media/icons/duotune/archive-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        {regarding == 'PO001' ? (
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('Jadwal')}
                            onClick={() => {
                              setIDSector(item.sector_id)
                              setProvinceName(item.province?.region_name)
                              setCityName(item.city?.city_name)
                              setProductName(item.product_name)
                              formattingTon(item.fixed_quantum)
                              setOrderSubID(
                                item?.order_sub_item_id == null ? item?.id : item?.order_sub_item_id
                              )
                              setTipeProduct(item.product_type)
                              setShowJadwal(true)
                            }}
                          >
                            <KTSVG
                              path='/media/icons/duotune/calendar-check-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        ) : (
                          ''
                        )}
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Hapus')}
                          onClick={() =>
                            removeSubOrder(_index, item.id, addedkuantum[_index]?.kuantum)
                          }
                        >
                          <KTSVG path='/media/icons/duotune/trash-fill.svg' className='svg-icon-3' />
                        </button>
                      </td>
                      {sektorID == '1' && (
                        <td className='td-150 text-center column'>
                          <span className='d-block fs-6 py-3'>{t(item.segment_name)}</span>
                        </td>
                      )}
                      <td className='td-250 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          <PopoverText
                            content={
                              item?.end_user_detail?.name ? item.end_user_detail?.name : item.end_user
                            }
                            index={_index}
                            className='desc-slicee'
                          />
                        </span>
                      </td>
                      <td className='td-250 text-center column'>
                        <span className='d-block fs-6 py-3'>{t(item.sector?.name)}</span>
                      </td>
                      <td className='td-150 text-center column'>
                        <span className='d-block fs-6 py-3'>{item.product_type_desc}</span>
                      </td>
                      <td className='td-150 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          {parseInt(item.material_number) == 0 ? '' : item.material_number?.slice(-7)}
                        </span>
                      </td>
                      <td className='td-250 text-center column'>
                        <span className='d-block fs-6 py-3'>{item.product_name}</span>
                      </td>
                      <td className='td-250 d-flex justify-content-center align-items-center text-center column'>
                        <span className='d-block fs-6'>
                          {specPayload[_index] ? (
                            <PopoverText
                              content={specPayload[_index]}
                              index={_index}
                              className='desc-slicee'
                            />
                          ) : (
                            <label className='opacity-0'>-</label>
                          )}
                        </span>
                      </td>
                      <td className='td-150 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          {i18next.language === 'en'
                            ? addedkuantum[_index]?.kuantum?.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            : addedkuantum[_index]?.kuantum?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })}{' '}
                          {item.product_type == '8105' ? 'EA' : item.sector_id === 3 ? 'MT' : 'Ton'}
                        </span>
                      </td>
                      {/* <td className='td-order-6 text-center column'>
                            {i18next.language === 'en'
                              ? item?.fixed_quantum?.toLocaleString('en', {maximumFractionDigits: 4})
                              : item?.fixed_quantum?.toLocaleString('id', {maximumFractionDigits: 4})} Ton
                          </td>
                          {sektorID != 2 ? (
                            <td className='td-order-6 text-center column'>
                            {i18next.language === 'en'
                              ? item?.shipping_tolerance?.toLocaleString('en', {maximumFractionDigits: 4})
                              : item?.shipping_tolerance?.toLocaleString('id', {maximumFractionDigits: 4})}%
                          </td>
                          ) : ''}
                          <td className='td-150 text-center column'>
                            {i18next.language === 'en'
                              ? (item.fixed_quantum - totalquant).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : (item.fixed_quantum - totalquant).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}{' '}
                            Ton
                          </td> */}
                      {item.product_type == '8105' ? (
                        <td className='td-order-6 text-center column opacity-0'>-</td>
                      ) : (
                        <td className='td-order-6 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {item.sector_id == 3 ? 'USD' : 'Rp'}
                            {i18next.language === 'en'
                              ? item.price_contract?.toLocaleString('en', {maximumFractionDigits: 4})
                              : item.price_contract?.toLocaleString('id', {maximumFractionDigits: 4})}
                            /
                            {item.product_type == '8105'
                              ? 'EA'
                              : item.sector_id == 3
                              ? 'MT'
                              : item.sector_id === 3
                              ? 'MT'
                              : 'Ton'}
                          </span>
                        </td>
                      )}
                      {item.product_type == '8105' ? (
                        <td className='td-150 text-center column opacity-0'>-</td>
                      ) : (
                        <td className='td-150 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {item.sector_id == 3 ? 'USD' : 'Rp'}
                            {i18next.language === 'en'
                              ? (addedkuantum[_index]?.kuantum * item.price_contract).toLocaleString(
                                  'en'
                                )
                              : (addedkuantum[_index]?.kuantum * item.price_contract).toLocaleString(
                                  'id'
                                )}
                          </span>
                        </td>
                      )}
                      {item.product_type == '8105' ? (
                        <td className='td-100 text-center column opacity-0'>-</td>
                      ) : (
                        <td className='td-100 text-center column'>
                          <span className='d-block fs-6 py-3'>{item.ppn}%</span>
                        </td>
                      )}
                      {item.product_type == '8105' ? (
                        <td className='td-150 text-center column opacity-0'>-</td>
                      ) : (
                        <td className='td-150 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {item.sector_id == 3 ? 'USD' : 'Rp'}
                            {i18next.language === 'en'
                              ? (
                                  (item.ppn / 100) *
                                    (addedkuantum[_index]?.kuantum * item.price_contract) +
                                  addedkuantum[_index]?.kuantum * item.price_contract
                                ).toLocaleString('en', {maximumFractionDigits: 4})
                              : (
                                  (item.ppn / 100) *
                                    (addedkuantum[_index]?.kuantum * item.price_contract) +
                                  addedkuantum[_index]?.kuantum * item.price_contract
                                ).toLocaleString('id', {maximumFractionDigits: 4})}
                          </span>
                        </td>
                      )}
                      <td className='td-250 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          {plantPayload2[_index]}
                          <label className='opacity-0'>-</label>
                        </span>
                      </td>
                      {isSalesOrSuperAdmin && (
                        <>
                          <td className='td-250 text-center column'>
                            <span className='d-block fs-6 py-3'>
                              {routePayload2[_index] ? (
                                <PopoverText
                                  content={routePayload2[_index]}
                                  index={_index}
                                  placement='bottom'
                                  className='desc-slicee'
                                />
                              ) : (
                                <label className='opacity-0'>-</label>
                              )}
                            </span>
                          </td>
                        </>
                      )}
                    </tr>
                ))}
                {addedProduct.map((item: any, _index: number) => (
                    <tr key={'item-' + _index} className='d-flex jusify-content-center w-100 align-items-center'>
                      <td className='td-150 text-center column'>
                        <span className='d-block fs-6 py-3'>{item.sales_org_code_desc} {item.incoterm1_desc}</span>
                      </td>
                      <td className='td-250 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          <PopoverText
                            content={[
                              item.incoterm1_desc,
                              item.incoterm2_id
                            ].join('-')}
                            index={_index}
                            className='desc-slicee'
                          />
                        </span>
                      </td>
                      <td
                        className='td-250 d-flex justify-content-center column'
                        style={{padding: '1.09rem 0'}}
                      >
                        <button
                          onClick={() => {
                            setTempDetail(item)
                            setQuantumSO(item.quantity)
                            setShowDetail(true)
                          }}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title='Detail'
                        >
                          <KTSVG
                            path='/media/icons/duotune/file-text-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        <a
                          onClick={() => {
                            setIDSector(item.sector_id)
                            getplantproduct(item.material_number)
                            getroutedata(item.sales_org_code)
                            setKuantum(item.quantity)
                            setPtype(item.product_type)
                            setPtype2(item.product_type_desc)
                            setSpekProduk(item.product_spec)
                            setSelectedItem(item)
                            setIndex2(_index)
                            setNamaPlant(item.plant_desc)
                            setIDPlant(item.plant)
                            setSloc(item.sloc)
                            setRoute(item.route)
                            setRouteDesc(item.route_desc)
                            setSlocDesc(item.sloc_description)
                            setPlantNameEn(item.plant_desc_en)
                            setShowEdit2(true)
                            setIncoterm(item.incoterm1.code)
                          }}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('ubah')}
                        >
                          <KTSVG
                            // pencil
                            path='/media/icons/duotune/pencil-fill.svg'
                            className='svg-icon-3'
                          />
                        </a>
                        <button
                          onClick={() => {
                            setIDSector(item.sector_id)
                            setProvinceName(item.province?.region_name)
                            setCityName(item.city?.city_name)
                            setProductName(item.product_name)
                            formattingTon(item.fixed_quantum)
                            setIsFileBox(true)
                            setIndex2(_index)
                            removeFileState()
                            handleUploadOrderItem(item)
                          }}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('order-lampiran')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/archive-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('tambah_jadwal')}
                          onClick={() => {
                            formattingTon(item.request_quantum)
                            setProvinceName(item.province_desc)
                            setCityName(item.city_desc)
                            setProductName(item.product_name)
                            setTipeProduct(item.product_type)
                            setIndex2(_index)
                            handleJadwal(item)
                            setUnitProduct(item.unit)
                            setShowJadwal(true)
                          }}
                        >
                          <KTSVG
                            path='/media/icons/duotune/calendar-check-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Hapus')}
                          onClick={() => removeProduct(_index)}
                        >
                          <KTSVG path='/media/icons/duotune/trash-fill.svg' className='svg-icon-3' />
                        </button>
                      </td>
                      {sektorID == '1' && (
                        <td className='td-150 text-center column'>
                          <span className='d-block fs-6 py-3'>{t(item.segment_name)}</span>
                        </td>
                      )}
                      <td className='td-250 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          <PopoverText
                            content={
                              item?.end_user_detail?.name ? item.end_user_detail?.name : item.end_user
                            }
                            index={_index}
                            className='desc-slicee'
                          />
                        </span>
                      </td>
                      <td className='td-250 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          {item.sector_id == 1
                            ? t('Domestik Korperasi')
                            : item.sector_id == 3
                            ? t('Export')
                            : ''}
                        </span>
                      </td>
                      <td className='td-150 text-center column'>
                        <span className='d-block fs-6 py-3'>{item.product_type_desc}</span>
                      </td>
                      <td className='td-150 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          {parseInt(item.material_number) == 0 ? (
                            <label className='opacity-0'>-</label>
                          ) : (
                            item.material_number?.slice(-7)
                          )}
                        </span>
                      </td>
                      <td className='td-250 text-center column'>
                        <span className='d-block fs-6 py-3'>{item.product_name}</span>
                      </td>
                      <td className='td-250 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          {item.product_spec ? (
                            <PopoverText
                              content={item.product_spec}
                              index={_index}
                              className='desc-slicee'
                            />
                          ) : (
                            <label className='opacity-0'>-</label>
                          )}
                        </span>
                      </td>
                      <td className='td-150 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          {i18next.language === 'en'
                            ? item.quantity?.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            : item.quantity?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })}{' '}
                          {item.product_type == '8105'
                            ? item.unit
                            : item.sector_id == 3
                            ? 'MT'
                            : item.sector_id === 3
                            ? 'MT'
                            : 'Ton'}
                        </span>
                      </td>
                      {item.product_type == '8105' ? (
                        <td className='td-order-6 text-center column'></td>
                      ) : (
                        <td className='td-order-6 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {item.sector_id == 1 ? 'Rp' : 'USD'}
                            {i18next.language === 'en'
                              ? parseFloat(item.request_price)?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : parseFloat(item.request_price)?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })}
                            /
                            {item.product_type == '8105'
                              ? 'EA'
                              : item.sector_id == 3
                              ? 'MT'
                              : item.sector_id === 3
                              ? 'MT'
                              : 'Ton'}
                          </span>
                        </td>
                      )}
                      {item.product_type == '8105' ? (
                        <td className='td-150 text-center column'></td>
                      ) : (
                        <td className='td-150 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {item.sector_id == 1 ? 'Rp' : 'USD'}
                            {i18next.language === 'en'
                              ? (item.quantity * item.request_price).toLocaleString('en')
                              : (item.quantity * item.request_price).toLocaleString('id')}
                          </span>
                        </td>
                      )}
                      {item.product_type == '8105' ? (
                        <td className='td-100 text-center column'></td>
                      ) : (
                        <td className='td-100 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {item.request_price == 0 ? 0 : ppn}%
                          </span>
                        </td>
                      )}
                      {item.product_type == '8105' ? (
                        <td className='td-150 text-center column'></td>
                      ) : (
                        <td className='td-150 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {item.sector_id == 1 ? 'Rp' : 'USD'}
                            {i18next.language === 'en'
                              ? (
                                  (ppn / 100) * (item.quantity * item.request_price) +
                                  item.quantity * item.request_price
                                ).toLocaleString('en', {maximumFractionDigits: 4})
                              : (
                                  (ppn / 100) * (item.quantity * item.request_price) +
                                  item.quantity * item.request_price
                                ).toLocaleString('id', {maximumFractionDigits: 4})}
                          </span>
                        </td>
                      )}
                      <td className='td-250 text-center column'>
                        <span className='d-block fs-6 py-3'>
                          <label className='opacity-0'>-</label>
                          {item.plant_desc}
                        </span>
                      </td>
                      {isSalesOrSuperAdmin && (
                        <td className='td-250 text-center column'>
                          <span className='d-block fs-6 py-3'>
                            {item.route_desc ? (
                              <PopoverText
                                content={item.route_desc}
                                index={_index}
                                placement='bottom'
                                className='desc-slicee'
                              />
                            ) : (
                              <label className='opacity-0'>-</label>
                            )}
                          </span>
                        </td>
                      )}
                    </tr>
                ))}
              </tbody>
            </table>

            {/* End Table Head */}
          </div>

          {priceBefore != 0 || totalPriceProductBefore != 0 ? (
            <div className='w-50 mt-5'>
              <Row className='mt-3'>
                <Col md={5}>
                  <p className='fs-4 mt-3'>Total {t('Kuantum')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    aria-label='Default example'
                    key={totalquant + totalQuantumProduct}
                    value={
                      (i18next.language === 'en'
                        ? (totalquant + totalQuantumProduct)?.toLocaleString('en', {
                            maximumFractionDigits: 4,
                          })
                        : (totalquant + totalQuantumProduct)?.toLocaleString('id', {
                            maximumFractionDigits: 4,
                          })) + ' Ton'
                    }
                    disabled
                  />
                </Col>
              </Row>
              <Row className='mt-3' hidden={totalPcs == 0 && totalPcsProduct == 0 ? true : false}>
                <Col md={5}>
                  <p className='fs-4 mt-3'>Total {t('sack')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    aria-label='Default example'
                    key={totalPcs + totalPcsProduct}
                    value={
                      (i18next.language === 'en'
                        ? (totalPcs + totalPcsProduct)?.toLocaleString('en', {
                            maximumFractionDigits: 4,
                          })
                        : (totalPcs + totalPcsProduct)?.toLocaleString('id', {
                            maximumFractionDigits: 4,
                          })) + ' EA'
                    }
                    disabled
                  />
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col md={5}>
                  <p className='fs-4 mt-3'>Total {t('Exclude')} PPN</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    aria-label='Default example'
                    key={priceBefore + totalPriceProductBefore}
                    value={
                      sektorID == '1'
                        ? 'Rp' +
                          (i18next.language === 'en'
                            ? (
                                Math.round(priceBefore) + Math.round(totalPriceProductBefore)
                              )?.toLocaleString('en', {maximumFractionDigits: 4})
                            : (
                                Math.round(priceBefore) + Math.round(totalPriceProductBefore)
                              )?.toLocaleString('id', {maximumFractionDigits: 4}))
                        : 'USD' +
                          (i18next.language === 'en'
                            ? (priceBefore + totalPriceProductBefore)?.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            : (priceBefore + totalPriceProductBefore)?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }))
                    }
                    disabled
                  />
                </Col>
              </Row>
              {/* <Row className='mt-3'>
                    <Col md={5}>
                      <p className='fs-4 mt-3'>PPN</p>
                    </Col>
                    <Col md={7}>
                      <Form.Control aria-label='Default example' value={ppn + '%'} disabled />
                    </Col>
                  </Row> */}
            </div>
          ) : (
            <></>
          )}

          {totalafterppn != 0 ? (
            <div className='w-50'>
              <Row className='mt-3'>
                <Col md={5}>
                  <p className='fs-4 mt-3'>Total {t('Include')} PPN</p>
                </Col>
                <Col md={7}>
                  <Form.Control
                    key={totalafterppn}
                    aria-label='Default example'
                    value={
                      sektorID == '1'
                        ? 'Rp' +
                          (i18next.language === 'en'
                            ? Math.round(totalafterppn)?.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            : Math.round(totalafterppn)?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              }))
                        : 'USD' +
                          (i18next.language === 'en'
                            ? totalafterppn?.toLocaleString('en', {maximumFractionDigits: 4})
                            : totalafterppn?.toLocaleString('id', {maximumFractionDigits: 4}))
                    }
                    disabled
                  />
                </Col>
              </Row>
            </div>
          ) : (
            <></>
          )}

          {printoutState != false && (
            <>
              <div className='d-flex justify-content-end mt-5'>
                <Button variant='primary' type='submit'>
                  {t('submit')}
                </Button>
              </div>
            </>
          )}
          <div className='d-flex justify-content-end' style={{marginTop: '1.5rem'}}>
            <Link to={'/management/so'}>
              <Button className='btn btn-secondary me-2'>{t('cancel')}</Button>
            </Link>
            {kontrakid != '' ? (
              <Button
                className='btn btn-primary'
                onClick={() => setShowApprove(true)}
                disabled={btnLoading}
              >
                {t('buat')}
              </Button>
            ) : (
              ''
            )}

            <Modal
              show={show2}
              onHide={() => {
                setShow2(false)
                setKuantum(0)
              }}
              backdrop='static'
              keyboard={false}
              centered
              size='lg'
              scrollable
            >
              <Modal.Header closeButton>
                <Modal.Title>{t('Tambah-SO')}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>ID Sub SO</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Select
                      size='sm'
                      aria-label='Default select example'
                      onChange={(e: any) => {
                        const temp = e.target.value.split('~#~')
                        fillDetail(temp[0], temp[1])
                        setIndex(parseInt(temp[0]))
                        setTempID(temp[1])
                      }}
                    >
                      <option selected>{t('pilih')} ID Sub SO</option>
                      {detail2.map((item, _index) => (
                        <option key={item?.id ?? _index} value={_index + '~#~' + item.id}>
                          {`${item.id} - ${item.product_name} - ${item.fixed_quantum} ton`}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>

                {isSalesOrSuperAdmin && (
                  <>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('Route')}</Form.Label>
                      </Col>
                      <Col md={8}>
                        <Select
                          isDisabled={disableRouteByIncoterm(incoterm as TIncontermCode)}
                          key={tempID + fullRoute}
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            separator2(e.value, setRoute, setRouteDesc)
                            const value = e.value.split(/,/g)
                            dispatch(
                              setOrderItem({
                                ...orderItem,
                                route: value[0],
                                route_desc: value[1],
                              })
                            )
                          }}
                          options={fullRoute}
                        />
                      </Col>
                    </Row>
                  </>
                )}

                {/* <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>Incoterm</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      aria-label='Default select example'
                      value={incoterm ? incoterm + '-' + incoterm2 : ''}
                      disabled
                    />
                  </Col>
                </Row> */}

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>Incoterm</Form.Label>
                  </Col>
                  <Col md={8}>
                    <ReactSelect
                      placeholder={t('pilih')}
                      value={fullIncoterm.filter((item: any) => item.label == incoterm)}
                      options={fullIncoterm}
                      onChange={(option: any) => setIncoterm(option.label) }
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>Incoterm 2</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control onChange={(e: any) => setIncoterm2(e.target?.value)} size='sm' aria-label='Default select example' value={incoterm2} />
                  </Col>
                </Row>

                {plantSelect && roleFlag == 'salesAnper' && (
                  <>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('Plant')}</Form.Label>
                      </Col>
                      <Col md={8}>
                        <Select
                          key={tempID + fullPlant + plantSelected}
                          placeholder={t('pilih')}
                          defaultValue={
                            fullPlant[
                              fullPlant.findIndex((item: any) => item.label == plantSelected)
                            ]
                          }
                          onChange={(e: any) => {
                            separator2(e.value, setIDPlant, setNamaPlant)
                            const value = e.value.split(/,/g)
                            dispatch(
                              setOrderItem({
                                ...orderItem,
                                plant: value[0],
                                plant_desc: value[1],
                              })
                            )
                          }}
                          options={fullPlant}
                        />
                      </Col>
                    </Row>
                    { idSektor == 3 && <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('sub-order-gudang')} (EN)</Form.Label>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          value={plantNameEn}
                          style={{height: '40px'}}
                          onChange={(e: any) => {
                            setPlantNameEn(e.target.value)
                          }}
                        />
                      </Col>
                    </Row> }
                    <Row className='mb-3'>
                      <Col md={4}>
                        {i18next.language === 'en' ? (
                          <>
                            <Form.Label className='mt-3'>{t('storage location')}</Form.Label>
                          </>
                        ) : (
                          <>
                            <Form.Label className=''>{t('storage location')}</Form.Label>
                          </>
                        )}
                      </Col>
                      <Col md={8}>
                        <Select
                          key={fullSloc + idPlant + sloc + slocDesc}
                          placeholder={t('pilih')}
                          defaultValue={
                            sloc == null || sloc == 'null'
                              ? ''
                              : fullSloc[
                                  fullSloc.findIndex((item) => item.label == sloc + '-' + slocDesc)
                                ]
                          }
                          onChange={(e: any) => {
                            separator2(e.value, setSloc, setSlocDesc)
                            const value = e.value.split(/,/g)
                            dispatch(
                              setOrderItem({
                                ...orderItem,
                                sloc: value[0],
                                sloc_description: value[1],
                              })
                            )
                          }}
                          options={fullSloc}
                        />
                      </Col>
                    </Row>
                  </>
                )}

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('sub-order-jenis')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      aria-label='Default example'
                      value={productCode ? productCode + '-' + ptype : ''}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('Product Name')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      key={tempID}
                      aria-label='Default example'
                      size='sm'
                      value={product ? materialNum + '-' + product : ''}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('Product Specification')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <div>
                      <RichText
                        containerClassName='mt-4'
                        content={spekproduk}
                        onUpdate={({editor}) => {
                          setSpekProduk(editor.getHTML())
                          const product_spec = editor.getHTML()
                          dispatch(setOrderItem({...orderItem, product_spec}))
                        }}
                      >
                        &nbsp;
                      </RichText>
                    </div>
                  </Col>
                </Row>

                {/* <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('Spec-product')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default example'
                      as='textarea'
                      style={{height: '40px'}}
                      size='sm'
                      value={spekproduk}
                      onChange={(e: any) => {
                        const product_spec = e.target.value
                        setSpekProduk(product_spec)
                        dispatch(setOrderItem({...orderItem, product_spec}))
                      }}
                    />
                  </Col>
                </Row> */}

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>
                      { t('contract-price') }
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      key={leftoverquantum}
                      aria-label='Default select example'
                      disabled
                      size='sm'
                      value={'Rp ' + (new Intl.NumberFormat(
                        i18next.language === 'en' ? 'en' : 'id'
                      ).format(Number(orderItem?.price_contract))) + (
                        orderItem?.sector_id === 3
                          ? ' /MT'
                          : ' /Ton'
                      )}
                    />
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>
                      {tipeProduct == '8105'
                        ? t('sisakantong')
                        : t('CREATE_SO.ADD_SO_MODAL.QUANTUM_CONTRACT_LABEL')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      key={leftoverquantum}
                      aria-label='Default select example'
                      disabled
                      size='sm'
                      value={
                        tempID === ''
                          ? ''
                          : `${new Intl.NumberFormat(
                              i18next.language === 'en' ? 'en' : 'id'
                            ).format(Number(orderItem?.quantum_contract))} Ton (+/- ${
                              shippingToleranceContract ?? 0
                            }%)`
                      }
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>{t('CREATE_SO.ADD_SO_MODAL.KUANTUM_SO_RILIS_LABEL')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      key={leftoverquantum}
                      aria-label='Default select example'
                      disabled
                      size='sm'
                      value={productCode ? kuantumSORilis + ' Ton' : ''}
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>{t('sisaquantum')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      key={index}
                      aria-label='Default select example'
                      disabled
                      size='sm'
                      value={tempID == '' ? '' : new Intl.NumberFormat(
                        i18next.language === 'en' ? 'en' : 'id'
                      ).format(Number(sisaQuantum[index]?.quantum)) + ' Ton'}
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>
                      {tipeProduct == '8105' ? t('sack') : t('sub-order-kuantum') + ' SO'}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <InputGroup size='sm'>
                      <CurrencyInput
                        className='form-control form-control-sm'
                        id='kuantum'
                        placeholder={tipeProduct == '8105' ? t('sack') : t('sub-order-kuantum')}
                        decimalSeparator={language === 'en' ? '.' : ','}
                        groupSeparator={language === 'en' ? ',' : '.'}
                        onValueChange={(value: any) => {
                          setKuantum(value?.replace(/,/g, '.'))
                          dispatch(setOrderItem({...orderItem, quantity: value}))
                        }}
                        decimalsLimit={3}
                      />
                      <InputGroup.Text id='basic-addon2'>
                        {tipeProduct == '8105' ? unitProduct : 'Ton'}
                      </InputGroup.Text>
                    </InputGroup>
                    {/* <Form.Control
                              aria-label='Default select example'
                              onChange={(e: any) => setKuantum(e.target.value)}
                              type='number'
                              placeholder={t('sub-order-kuantum') + '/Ton'}
                            /> */}
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>
                      {t('CREATE_SO.ADD_SO_MODAL.TOLERANCE_QUANTUM_SO_LABEL')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <InputGroup size='sm'>
                      <CurrencyInput
                        className='form-control form-control-sm'
                        id='toleransi'
                        placeholder={t('CREATE_SO.ADD_SO_MODAL.TOLERANCE_QUANTUM_SO_LABEL')}
                        decimalSeparator={language === 'en' ? '.' : ','}
                        groupSeparator={language === 'en' ? ',' : '.'}
                        defaultValue={0}
                        onChange={(e: any) => {
                          const shipping_tolerance_so = e.target.value
                          dispatch(setOrderItem({...orderItem, shipping_tolerance_so}))
                        }}
                        decimalsLimit={3}
                      />
                      <InputGroup.Text
                        id='basic-addon2'
                        style={{paddingTop: '1px', paddingBottom: '1px'}}
                      >
                        <span style={{padding: '0 6.5px'}}>%</span>
                      </InputGroup.Text>
                    </InputGroup>
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('sub-order-catatan')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      placeholder={t('sub-order-catatan')}
                      type='text'
                      as='textarea'
                      onChange={(e: any) => {
                        const notes = e.target.value
                        setSoNotes(notes)
                        dispatch(setOrderItem({...orderItem, notes}))
                      }}
                    />
                  </Col>
                </Row>

                <div className='d-flex justify-content-end mt-5'>
                  <Button
                    variant='primary'
                    onClick={() => {
                      addSelectedDetail()
                    }}
                  >
                    {t('Save')}
                  </Button>
                </div>
                {/* </>
                    )} */}
              </Modal.Body>
            </Modal>

            <Modal
              show={showEdit}
              onHide={() => setShowEdit(false)}
              backdrop='static'
              keyboard={false}
              centered
              size='lg'
              scrollable
            >
              <Modal.Header closeButton>
                <Modal.Title>{t('Edit')} Item</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>ID Sub SO</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Select size='sm' aria-label='Default select example' disabled>
                      <option selected>{selectedItem.id}</option>
                    </Form.Select>
                  </Col>
                </Row>

                {isSalesOrSuperAdmin ? (
                  <>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('Route')}</Form.Label>
                      </Col>
                      <Col md={8}>
                        <Select
                          isDisabled={disableRouteByIncoterm(incoterm as TIncontermCode)}
                          key={tempID + fullRoute}
                          placeholder={t('pilih')}
                          defaultValue={
                            fullRoute[
                              fullRoute.findIndex(
                                (item: any) => item.label == route + '-' + routeDesc
                              )
                            ]
                          }
                          onChange={(e: any) => separator2(e.value, setRoute, setRouteDesc)}
                          options={fullRoute}
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )}

                {/* <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>Incoterm</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      aria-label='Default select example'
                      value={
                        selectedItem.incoterm1?.code +
                        (selectedItem.incoterm2 !== null
                          ? '-' + selectedItem.incoterm2
                          : '-' + selectedItem.incoterm2_id || '')
                      }
                      disabled
                    />
                  </Col>
                </Row> */}

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>Incoterm</Form.Label>
                  </Col>
                  <Col md={8}>
                    <ReactSelect
                      placeholder={t('pilih')}
                      defaultValue={fullIncoterm.filter((item: any) => item.value == selectedItem.incoterm1_id)}
                      options={fullIncoterm}
                      onChange={(option: any) => setIncoterm(option.label) }
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>Incoterm 2</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control defaultValue={selectedItem.incoterm2} onChange={(e: any) => setIncoterm2(e.target?.value)} size='sm' aria-label='Default select example' value={incoterm2} />
                  </Col>
                </Row>

                {roleFlag == 'salesAnper' && (
                  <>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('Plant')}</Form.Label>
                      </Col>
                      <Col md={8}>
                        <Select
                          key={tempID + fullPlant}
                          placeholder={t('pilih')}
                          defaultValue={
                            fullPlant[
                              fullPlant.findIndex(
                                (item: any) => item.label == idPlant + '-' + namaPlant
                              )
                            ]
                          }
                          onChange={(e: any) => separator2(e.value, setIDPlant, setNamaPlant)}
                          options={fullPlant}
                        />
                      </Col>
                    </Row>

                    { idSektor == 3 && <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('Plant')} (EN)</Form.Label>
                      </Col>
                      <Col md={8}>
                       <Form.Control
                          aria-label='Default select example'
                          value={plantNameEn}
                          style={{height: '40px'}}
                          onChange={(e: any) => {
                            setPlantNameEn(e.target.value)
                          }}
                        />
                      </Col>
                    </Row> }

                    <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('storage location')}</Form.Label>
                      </Col>
                      <Col md={8}>
                        <Select
                          key={fullSloc + idPlant}
                          placeholder={t('pilih')}
                          defaultValue={
                            slocPayload[index2] == null || slocPayload[index2] == 'null'
                              ? ''
                              : fullSloc[
                                  fullSloc.findIndex((item) => item.label == sloc + '-' + slocDesc)
                                ]
                          }
                          onChange={(e: any) => separator2(e.value, setSloc, setSlocDesc)}
                          options={fullSloc}
                        />
                      </Col>
                    </Row>
                  </>
                )}

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('sub-order-jenis')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      aria-label='Default example'
                      value={
                        selectedItem
                          ? selectedItem.product_type + '-' + selectedItem.product_type_desc
                          : ''
                      }
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('Product Name')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      aria-label='Default example'
                      value={
                        selectedItem
                          ? selectedItem?.material_number?.slice(-7) +
                            '-' +
                            selectedItem?.product_name
                          : ''
                      }
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('Spec-product')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <div>
                      <RichText
                        containerClassName='mt-4'
                        content={spekproduk}
                        onUpdate={({editor}) => {
                          setSpekProduk(editor.getHTML())
                          const product_spec = editor.getHTML()
                          dispatch(setOrderItem({...orderItem, product_spec}))
                        }}
                      >
                        &nbsp;
                      </RichText>
                    </div>
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label
                      className='mt-3'
                    >
                      { t('contract-price') }
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      key={selectedItem?.quantum_contract}
                      aria-label='Default select example'
                      disabled
                      value={
                        (
                          selectedItem?.sector_id === 3
                              ? 'USD '
                              : 'Rp '
                        ) + (
                        isNaN(selectedItem?.price_contract)
                          ? 0
                          : (i18next.language === 'en'
                              ? parseFloat(selectedItem?.price_contract).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : parseFloat(selectedItem?.price_contract).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }))) +
                            (selectedItem?.product_type == '8105'
                              ? ' EA'
                              : selectedItem?.sector_id === 3
                              ? ' /MT'
                              : ' /Ton')
                      }
                    />
                  </Col>
                </Row>
                
                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label
                      className='mt-3'
                      hidden={selectedItem?.quantum_contract <= 0 ? true : false}
                    >
                      {selectedItem?.product_type == '8105'
                        ? t('sack')
                        : t('CREATE_SO.ADD_SO_MODAL.QUANTUM_CONTRACT_LABEL')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      key={selectedItem?.quantum_contract}
                      aria-label='Default select example'
                      hidden={selectedItem?.quantum_contract == 0 ? true : false}
                      disabled
                      value={
                        isNaN(selectedItem?.quantum_contract)
                          ? 0
                          : (i18next.language === 'en'
                              ? parseFloat(selectedItem?.quantum_contract).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : parseFloat(selectedItem?.quantum_contract).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })) +
                            (selectedItem?.product_type == '8105'
                              ? ' EA'
                              : selectedItem?.sector_id === 3
                              ? ' MT'
                              : ' Ton') +
                            `(+/-${shippingToleranceContract}%)`
                      }
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>
                      {t('CREATE_SO.ADD_SO_MODAL.KUANTUM_SO_RILIS_LABEL')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      value={kuantumSORilis ? (parseFloat(kuantumSORilis).toLocaleString(i18next.language, {
                        maximumFractionDigits: 4,
                      })) + ' Ton' : '0 Ton'}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4} className='d-flex align-items-center'>
                    <Form.Label>{t('sisaquantum')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      key={index}
                      aria-label='Default select example'
                      disabled
                      size='sm'
                      value={(singleSisaQuantum ? singleSisaQuantum.toLocaleString(i18next.language, {
                        maximumFractionDigits: 4,
                      }) : 0) + ' Ton'}
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>
                      {selectedItem?.product_type == '8105'
                        ? t('sack')
                        : t('sub-order-kuantum') + ' SO'}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <InputGroup size='sm'>
                      <CurrencyInput
                        className='form-control form-control-sm'
                        id='kuantum'
                        placeholder={
                          selectedItem?.product_type == '8105' ? t('sack') : t('sub-order-kuantum')
                        }
                        defaultValue={kuantum || 0}
                        decimalSeparator={language === 'en' ? '.' : ','}
                        groupSeparator={language === 'en' ? ',' : '.'}
                        onValueChange={(value: any) => {
                          setKuantum(value?.replace(/,/g, '.'))
                          // console.log(value)
                        }}
                        decimalsLimit={3}
                      />
                      <InputGroup.Text id='basic-addon2'>
                        {selectedItem?.product_type == '8105'
                          ? selectedItem?.unit
                          : selectedItem?.sector_id === 3
                          ? ' MT'
                          : ' Ton'}
                      </InputGroup.Text>
                    </InputGroup>
                    {/* <Form.Control
                          aria-label='Default select example'
                          defaultValue={i18next.language === 'en' ? addedkuantum[index2]?.kuantum?.toLocaleString('en', { maximumFractionDigits: 4 }) : addedkuantum[index2]?.kuantum?.toLocaleString('id', { maximumFractionDigits: 4 })}
                          onChange={(e: any) => setKuantum(e.target.value)}
                        /> */}
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>
                      {t('CREATE_SO.ADD_SO_MODAL.TOLERANCE_QUANTUM_SO_LABEL')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                  <InputGroup>
                      <CurrencyInput
                        className='form-control form-control-sm'
                        defaultValue={shipping || '0'}
                        decimalSeparator={language === 'en' ? '.' : ','}
                        groupSeparator={language === 'en' ? ',' : '.'}
                        decimalsLimit={3}
                        onValueChange={(v: any) => {
                          const shipping_tolerance_so = parseFloat(v?.replace(/,/g, '.'))
                          dispatch(putOrderItem({...orderItem, shipping_tolerance_so}))
                          setShipping(shipping_tolerance_so)
                        }}
                      />
                      <InputGroup.Text>%</InputGroup.Text>
                    </InputGroup>
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('sub-order-catatan')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      size='sm'
                      placeholder={t('sub-order-catatan')}
                      type='text'
                      as='textarea'
                      defaultValue={soNotes ?? ''}
                      onChange={(e: any) => {
                        const notes = e.target.value
                        setSoNotes(notes)
                        dispatch(setOrderItem({...orderItem, notes}))
                      }}
                    />
                  </Col>
                </Row>

                <div className='d-flex justify-content-end mt-5'>
                  <Button variant='primary' onClick={() => editSelectedDetail(index2)}>
                    {t('Save')}
                  </Button>
                </div>
              </Modal.Body>
            </Modal>

            <Modal
              show={showEdit2}
              onHide={() => setShowEdit2(false)}
              backdrop='static'
              keyboard={false}
              centered
              size='lg'
              scrollable
            >
              <Modal.Header closeButton>
                <Modal.Title>{t('Edit')} Item</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {isSalesOrSuperAdmin ? (
                  <>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('Route')}</Form.Label>
                      </Col>
                      <Col md={8}>
                        <Select
                          isDisabled={disableRouteByIncoterm(incoterm as TIncontermCode)}
                          key={tempID + fullRoute}
                          placeholder={t('pilih')}
                          defaultValue={
                            fullRoute[
                              fullRoute.findIndex(
                                (item: any) => item.label == route + '-' + routeDesc
                              )
                            ]
                          }
                          onChange={(e: any) => separator2(e.value, setRoute, setRouteDesc)}
                          options={fullRoute}
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )}

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>Incoterm</Form.Label>
                  </Col>
                  <Col md={8}>
                    {/* <Form.Control
                      size='sm'
                      aria-label='Default select example'
                      value={
                        selectedItem.incoterm1_desc +
                        (selectedItem.incoterm2_id ? '-' + selectedItem.incoterm2_id : '')
                      }
                      disabled
                    /> */}
                    <ReactSelect
                      placeholder={t('pilih')}
                      defaultValue={fullIncoterm.filter((item: any) => item.value == selectedItem.incoterm1_id)}
                      options={fullIncoterm}
                      onChange={(option: any) => setIncoterm(option.label) }
                    />
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>Incoterm 2</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Control defaultValue={selectedItem.incoterm2_id} onChange={(e: any) => setIncoterm2(e.target?.value)} size='sm' aria-label='Default select example'/>
                  </Col>
                </Row>

                {roleFlag == 'salesAnper' && (
                  <>
                    <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('Plant')}</Form.Label>
                      </Col>
                      <Col md={8}>
                        <Select
                          key={tempID + fullPlant}
                          placeholder={t('pilih')}
                          defaultValue={
                            fullPlant[
                              fullPlant.findIndex(
                                (item: any) => item.label == idPlant + '-' + namaPlant
                              )
                            ]
                          }
                          onChange={(e: any) => separator2(e.value, setIDPlant, setNamaPlant)}
                          options={fullPlant}
                        />
                      </Col>
                    </Row>

                    <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('Plant')} (EN)</Form.Label>
                      </Col>
                      <Col md={8}>
                        <Form.Control
                          aria-label='Default select example'
                          value={plantNameEn}
                          style={{height: '40px'}}
                          onChange={(e: any) => {
                            setPlantNameEn(e.target.value)
                          }}
                        />
                      </Col>
                    </Row>

                    <Row className='mb-3'>
                      <Col md={4}>
                        <Form.Label className='mt-3'>{t('storage location')}</Form.Label>
                      </Col>
                      <Col md={8}>
                        <Select
                          key={fullSloc + idPlant}
                          placeholder={t('pilih')}
                          defaultValue={
                            slocPayload[index2] == null || slocPayload[index2] == 'null'
                              ? ''
                              : fullSloc[
                                  fullSloc.findIndex((item) => item.label == sloc + '-' + slocDesc)
                                ]
                          }
                          onChange={(e: any) => separator2(e.value, setSloc, setSlocDesc)}
                          options={fullSloc}
                        />
                      </Col>
                    </Row>
                  </>
                )}

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('sub-order-jenis')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Form.Select
                      size='sm'
                      aria-label='Default select example'
                      onChange={(e: any) => {
                        setFullProductName([])
                        separator2(e.target.value, setPtype, setPtype2)
                      }}
                    >
                      <option hidden value=','>
                        {t('Pilih-productType')}
                      </option>
                      {fullProductType.map((item: any) => {
                        return (
                          <>
                            {selectedItem.product_type_desc == item.material_group_desc ? (
                              <option
                                selected
                                value={item.material_group + ',' + item.material_group_desc}
                              >
                                {item.material_group}-{t(item.material_group_desc)}
                              </option>
                            ) : (
                              <option value={item.material_group + ',' + item.material_group_desc}>
                                {item.material_group}-{t(item.material_group_desc)}
                              </option>
                            )}
                          </>
                        )
                      })}
                    </Form.Select>
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('Product Name')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <Select
                      id='produk'
                      placeholder={t('pilih')}
                      key={ptype + fullProductName}
                      defaultValue={
                        fullProductName[
                          fullProductName.findIndex(
                            (item: any) => item.truevalue == parseInt(selectedItem.material_number)
                          )
                        ]
                      }
                      onChange={(e: any) => {
                        // setQuantum(0)
                        // fieldClearer(1)
                        // setSubprice(0)
                        setPunit(e?.unit)
                        separator3(e?.value, setPnumber, setPname)
                      }}
                      options={fullProductName}
                    />
                  </Col>
                </Row>

                {parseInt(pnumber) == 0 && (
                  <Row className='mb-4'>
                    <Col sm={4}>
                      <p className='fs-6'>
                        Custom Product Name<span className='text-danger'>*</span>
                      </p>
                    </Col>
                    <Col sm={8}>
                      <Form.Control
                        placeholder=' Custom Product Name'
                        size='sm'
                        aria-label='Default select example'
                        type='text'
                        id='custom'
                        onChange={(e: any) => setPname(e.target.value)}
                      />
                    </Col>
                  </Row>
                )}

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>{t('Spec-product')}</Form.Label>
                  </Col>
                  <Col md={8}>
                    <div>
                      <RichText
                        containerClassName='mt-4'
                        content={spekproduk}
                        onUpdate={({editor}) => {
                          setSpekProduk(editor.getHTML())
                          const product_spec = editor.getHTML()
                          dispatch(setOrderItem({...orderItem, product_spec}))
                        }}
                      >
                        &nbsp;
                      </RichText>
                    </div>
                    {/* <Form.Control
                      size='sm'
                      aria-label='Default example'
                      style={{height: '40px'}}
                      as='textarea'
                      defaultValue={spekproduk}
                      onChange={(e: any) => setSpekProduk(e.target.value)}
                    /> */}
                  </Col>
                </Row>

                <Row className='mb-3'>
                  <Col md={4}>
                    <Form.Label className='mt-3'>
                      {ptype == '8105' ? t('sack') : t('sub-order-kuantum')}
                    </Form.Label>
                  </Col>
                  <Col md={8}>
                    <InputGroup size='sm'>
                      <CurrencyInput
                        className='form-control form-control-sm'
                        id='kuantum'
                        placeholder={ptype == '8105' ? t('sack') : t('sub-order-kuantum')}
                        defaultValue={kuantum}
                        decimalSeparator={language === 'en' ? '.' : ','}
                        groupSeparator={language === 'en' ? ',' : '.'}
                        onValueChange={(value: any) => {
                          setKuantum(value?.replace(/,/g, '.'))
                        }}
                        decimalsLimit={3}
                      />
                      <InputGroup.Text id='basic-addon2'>
                        {ptype == '8105' ? punit : selectedItem?.sector_id === 3 ? ' MT' : ' Ton'}
                      </InputGroup.Text>
                    </InputGroup>
                  </Col>
                </Row>

                <div className='d-flex justify-content-end mt-5'>
                  <Button variant='primary' onClick={() => editSelectedDetailProduct(index2)}>
                    {t('Save')}
                  </Button>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>

        <Modal
          size='lg'
          show={showUpload2}
          onHide={() => {
            setShowUpload2(false)
            setIsFileBox(false)
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isFileBox
                ? (idSektor != 3 ? provinceDesc + ', ' + cityDesc + ' | ' : '') +
                  pname +
                  ' | ' +
                  fixedQuantum +
                  ' Ton'
                : ''}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6}>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-fileUnggah')}</h6>
                    </td>
                    <td className='w-75'>
                      <InputFile
                          setFileName={(_: string) => {}}
                          setFiles={setFiles}
                          isBase64={false}
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-keterangan')}</h6>
                    </td>
                    <td className='w-75'>
                      <Form.Control
                        type='text'
                        placeholder={t('order-keterangan')}
                        id='uploadketerangan'
                        onChange={(e: any) => setDescription(e.target.value)}
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3' hidden={isSalesOrSuperAdmin ? false : true}>
                  <tr>
                    <td>
                      <h6 className='me-11'>{t('Private')}</h6>
                    </td>
                    <td className='w-75 d-flex justify-content-start'>
                      <Form.Check
                        reverse
                        name='isPrivate'
                        type='checkbox'
                        className='mt-5 mb-2'
                        onClick={() => {
                          setIsPrivate(!isPrivate)
                        }}
                        id='isPrivate'
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3' hidden={isPrivate ? false : true}>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('Akses Role')}</h6>
                    </td>
                    <td className='w-75' style={{maxWidth: '274px'}}>
                      <MultiSelect
                        key={isPrivate.toString()}
                        options={fullRole?.map((item: any) => {
                          return {label: item.label, value: item.value}
                        })}
                        value={tempRole}
                        onChange={(e: any) => setTempRole(e)}
                        labelledBy='Select'
                      />
                    </td>
                  </tr>
                </table>
                <div className='d-flex justify-content-end'>
                  <Button
                    variant='primary'
                    className='w-100'
                    onClick={() => handleUpload()}
                    disabled={btnLoading}
                  >
                    {btnLoading ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      t('order-kirim')
                    )}
                  </Button>
                </div>
              </Col>
              <Col sm={6} className='mt-3'>
                {isexceed ? <span className='text-danger'>{t('File Exceed 2MB')}</span> : <></>}
              </Col>
            </Row>
            <div className='table-responsive mt-4 bdr'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead className='fw-bold border-bottom'>
                  <tr className=''>
                    <th className='text-center'>{t('order-noo')}</th>
                    <th className='text-center'>{t('order-keterangan')}</th>
                    <th className='text-center'>{t('order-tglUpload')}</th>
                    {/* <th className='text-center'>{t('User Code')}</th> */}
                    <th className='text-center'>{t('order-user')}</th>
                    <th className='text-center'>{t('Akses Role')}</th>
                    <th className='text-center'>{t('order-aksi')}</th>
                  </tr>
                </thead>
                {allFiles.map((data: any, _index: number) => (
                  <tbody key={data?.id ?? _index}>
                    <tr className=''>
                      <td className='text-center'>
                        <label>{_index + 1}</label>
                      </td>
                      <td className='text-center'>
                        <label>{data.description}</label>
                      </td>
                      <td className='text-center'>
                        <label>{dateformat(data.updated_at)}</label>
                      </td>
                      {/* <td className='text-center'>
                        <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                      </td> */}
                      <td className='text-center'>
                        {data.user?.customer_code == null ? (
                          <label>{data.user?.name}</label>
                        ) : (
                          <label>{data.user?.customer?.name}</label>
                        )}
                      </td>
                      <td className='text-center'>
                        {data.private ? (
                          data.roles.length > 0 ? (
                            <PopoverText
                              content={handleShowRoleName(data.roles)}
                              index={_index}
                              className='desc-slice'
                            />
                          ) : (
                            'Private'
                          )
                        ) : (
                          'Public'
                        )}
                      </td>
                      <td className='text-center'>
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('unduh')}
                          onClick={() =>
                            handleDownloadAttachment(data.file_path)
                          }
                        >
                          <KTSVG
                            path='/media/icons/duotune/arrow-down-square-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        {(hakAkses?.attachment_delete ||
                          CheckSameIDAttachment(data.user_role_flag)) && (
                          <button
                            onClick={() => deleteAttachment(data.id)}
                            className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('Hapus')}
                          >
                            <KTSVG
                              path='/media/icons/duotune/trash-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={showJadwal}
          onHide={() => setShowJadwal(false)}
          centered
          size='xl'
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
              {productName} | {fixedQuantum} {tipeProduct != '8105' ? 'Ton' : unitProduct}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            <AddRemoveJadwal id={orderSubID} is_amendment={'false'} tipeproduct={tipeProduct} unit={unitProduct}/>
          </Modal.Body>
        </Modal>

        <Modal show={showApprove} onHide={() => setShowApprove(false)} centered backdrop='static'>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <h3 className='text-center mb-5'>{t('are you sure to create SO')}</h3>
          </Modal.Body>
          <Modal.Footer>
            <Button className='btn btn-secondary' onClick={() => setShowApprove(false)}>
              {t('Tidak')}
            </Button>
            <Button className='btn btn-primary' onClick={create2} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Ya')}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showAddProduct}
          onHide={() => setShowAddProduct(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('tambah-produk')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {sektorID == '3' && (
              <>
                <Row>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('kontrak-produsen')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={salesorgname}
                        />
                      </Col>
                    </Row>

                    
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-incoterm1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        {/* <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={incotermIdDesc}
                        /> */}
                        <ReactSelect
                          placeholder={t('pilih')}
                          defaultValue={fullIncoterm.filter((item: any) => item.label == incotermIdDesc)}
                          options={fullIncoterm}
                          onChange={(option: any) => setIncoterm(option.label) }
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-provinsi')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='provinsi'
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            fieldClearer('province')
                            setFullCity2([])
                            separator2(e?.value, setProvince, setProvinceDesc)
                          }}
                          options={fullProvince2}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-jenis')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Select
                          size='sm'
                          id='jenis'
                          aria-label='Default select example'
                          onChange={(e: any) => {
                            fieldClearer('tipe')
                            separator2(e.target.value, setPtype, setPtype2)
                          }}
                        >
                          <option hidden value=','>
                            {t('Pilih-productType')}
                          </option>
                          {fullProductType.map((item: any, index: number) => {
                            return (
                              <option
                                key={index}
                                value={item.material_group + ',' + item.material_group_desc}
                              >
                                {t(item.material_group_desc)}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </Col>
                    </Row>
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6'>
                            Custom Product Name<span className='text-danger'>*</span>
                          </p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            placeholder=' Custom Product Name'
                            size='sm'
                            aria-label='Default select example'
                            type='text'
                            id='custom'
                            onChange={(e: any) => setPname(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {ptype == '8105' ? t('sack') : t('sub-order-kuantum')}
                          <span hidden={ptype == '8105' ? true : false} className='text-danger'>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            id='kuantum'
                            // key={pname}
                            placeholder={ptype == '8105' ? t('sack') : t('sub-order-kuantum')}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setQuantum(value?.replace(/,/g, '.'))
                            }}
                            decimalsLimit={3}
                          />
                          <InputGroup.Text id='basic-addon2'>
                            {ptype == '8105' ? punit : 'MT'}
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('Shipping Tolerance')}</p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup>
                          <Form.Control
                            key={pname + ptype}
                            placeholder={ptype == '8105' ? '' : t('Shipping Tolerance')}
                            size='sm'
                            disabled={ptype == '8105' ? true : false}
                            type='number'
                            onChange={(e: any) => setShipping(parseInt(e.target.value))}
                            id='shipping'
                          />
                          <InputGroup.Text
                            id='basic-addon2'
                            style={{paddingTop: '1px', paddingBottom: '1px'}}
                          >
                            <span className='px-1'>%</span>
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-payment1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          disabled
                          placeholder={t('sub-order-payment1')}
                          size='sm'
                          value={pay1Desc}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('keterangan')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          as='textarea'
                          placeholder={t('keterangan')}
                          id='keterangan'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setketerangan(e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('End Customer')}
                          <span className='text-danger' hidden={ptype == '8105' ? true : false}>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          as='textarea'
                          id='enduser'
                          placeholder={t('End Customer')}
                          // defaultValue={tempData.end_user_multiple ? handleShowValue(tempData.end_user) : tempData.end_user}
                          onChange={(e: any) => {
                            setEnduser(e.target.value)
                            setEnduserDesc(e.target.value)
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-sektor')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={t('Export')}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col sm={8}>
                        {/* <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={incotermId2Desc}
                        /> */}
                        <Form.Control defaultValue={incotermId2Desc} onChange={(e: any) => setIncoterm2(e.target?.value)} size='sm' aria-label='Default select example'/>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-kota')}</p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='kota'
                          isDisabled={false}
                          placeholder={t('pilih')}
                          key={province}
                          onChange={(e: any) => {
                            // fieldClearer(3)
                            separator2(e?.value, setCityProduct, setCityDesc)
                          }}
                          options={fullCity2}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-produk')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='produk'
                          placeholder={t('pilih')}
                          key={ptype + fullProductName}
                          defaultValue={
                            fullProductName[
                              fullProductName.findIndex(
                                (item: any) => item.truevalue == parseInt(pnumber)
                              )
                            ]
                          }
                          onChange={(e: any) => {
                            // fieldClearer(1)
                            // setQuantum(0)
                            // setSubprice(0)
                            setPunit(e?.unit)
                            separator3(e?.value, setPnumber, setPname)
                          }}
                          options={fullProductName}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-hargaP')}/{ptype == '8105' ? punit : 'MT'}
                          <span hidden={ptype == '8105' ? true : false} className='text-danger'>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <InputGroup.Text id='basic-addon2'>
                            <span className='px-2'>USD</span>
                          </InputGroup.Text>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            disabled={ptype == '8105' ? true : false}
                            id='hargap'
                            // key={pname}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setSubprice(value?.replace(/,/g, '.'))
                            }}
                            decimalsLimit={2}
                            placeholder={t('sub-order-hargaP')}
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          placeholder={t('sub-order-spek')}
                          as='textarea'
                          id='spek'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setPspec(e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          disabled
                          placeholder={t('sub-order-payment2')}
                          size='sm'
                          value={pay2Desc}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) != 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </>
            )}

            {sektorID == '1' && (
              <>
                <Row>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('kontrak-produsen')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={salesorgname}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-incoterm1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        {/* <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={incotermIdDesc}
                        /> */}
                        <ReactSelect
                          placeholder={t('pilih')}
                          defaultValue={fullIncoterm.filter((item: any) => item.label == incotermIdDesc)}
                          options={fullIncoterm}
                          onChange={(option: any) => setIncoterm(option.label) }
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-provinsi')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='provinsi'
                          placeholder={t('pilih')}
                          onChange={(e: any) => {
                            fieldClearer('province')
                            setFullCity2([])
                            separator2(e?.value, setProvince, setProvinceDesc)
                          }}
                          options={fullProvince2}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-jenis')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Select
                          size='sm'
                          id='jenis'
                          aria-label='Default select example'
                          onChange={(e: any) => {
                            fieldClearer('tipe')
                            separator2(e.target.value, setPtype, setPtype2)
                          }}
                        >
                          <option hidden value=','>
                            {t('Pilih-productType')}
                          </option>
                          {fullProductType.map((item: any, index: number) => {
                            return (
                              <option
                                key={index}
                                value={item.material_group + ',' + item.material_group_desc}
                              >
                                {t(item.material_group_desc)}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </Col>
                    </Row>
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6'>
                            Custom Product Name<span className='text-danger'>*</span>
                          </p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            placeholder=' Custom Product Name'
                            size='sm'
                            aria-label='Default select example'
                            type='text'
                            id='custom'
                            onChange={(e: any) => setPname(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {ptype == '8105' ? t('sack') : t('sub-order-kuantum')}
                          <span hidden={ptype == '8105' ? true : false} className='text-danger'>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            id='kuantum'
                            // key={pname}
                            placeholder={ptype == '8105' ? t('sack') : t('sub-order-kuantum')}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setQuantum(value?.replace(/,/g, '.'))
                            }}
                            decimalsLimit={3}
                          />
                          <InputGroup.Text id='basic-addon2'>
                            {ptype == '8105' ? punit : 'Ton'}
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('Shipping Tolerance')}</p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup>
                          <Form.Control
                            key={pname + ptype}
                            placeholder={ptype == '8105' ? '' : t('Shipping Tolerance')}
                            size='sm'
                            disabled={ptype == '8105' ? true : false}
                            type='number'
                            onChange={(e: any) => setShipping(parseInt(e.target.value))}
                            id='shipping'
                          />
                          <InputGroup.Text
                            id='basic-addon2'
                            style={{paddingTop: '1px', paddingBottom: '1px'}}
                          >
                            <span className='px-1'>%</span>
                          </InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-payment1')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          disabled
                          placeholder={t('sub-order-payment1')}
                          size='sm'
                          value={pay1Desc}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4} className='d-flex align-items-center'>
                        <p className='fs-6'>{t('keterangan')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          as='textarea'
                          placeholder={t('keterangan')}
                          id='keterangan'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setketerangan(e.target.value)}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) != 0 && (
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>
                            {t('segment')}
                            <span className='text-danger'>*</span>{' '}
                          </p>
                        </Col>
                        <Col md={8}>
                          <Form.Select
                            id='segment'
                            onChange={(e: any) => separator2(e.target.value, setSegment, setSegmentDesc)}
                            aria-label='Default select example'
                            size='sm'
                          >
                            <option hidden value=','>
                              {t('Pilih-segment')}
                            </option>
                            {fullSegment.map((item: any) => {
                              if (item.code == 'Z2' || item.code == 'Z3') {
                                return (
                                  <option value={item.code + ',' + item.name}>{item.name}</option>
                                )
                              } else {
                                return null
                              }
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                    )}
                    <Row className=''>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('End Customer')}
                          <span className='text-danger' hidden={ptype == '8105' ? true : false}>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        {isNoEnduser ? (
                          <>
                            <Form.Control
                              size='sm'
                              as='textarea'
                              id='enduser'
                              placeholder={t('End Customer')}
                              onChange={(e: any) => {
                                setEnduser(e.target.value)
                                setEnduserDesc(e.target.value)
                              }}
                            />
                          </>
                        ) : (
                          <MultiSelect
                            options={fullEndUser?.map((item: any) => {
                              return {label: t(item.name), value: item.name}
                            })}
                            value={arrayEnduser}
                            onChange={(e: any) => setEnduserArray(e)}
                            labelledBy='Select'
                          />
                          // <Form.Select
                          //   size='sm'
                          //   aria-label='Default select example'
                          //   id='enduser2'
                          //   onChange={(e: any) => {
                          //     separateValue4(
                          //       e.target.value,
                          //       setEnduser,
                          //       setEnduserDesc
                          //     )
                          //   }}
                          // >
                          //   <option selected value={0 + '~#~'}>
                          //     {t('pilih')} {t('End Customer')}
                          //   </option>
                          //   {fullEndUser.map((item: any) => {
                          //     return (
                          //       <option
                          //         value={item.end_user_code + '~#~' + item.name}
                          //       >
                          //         {t(item.name)}
                          //       </option>
                          //     )
                          //   })}
                          // </Form.Select>
                        )}
                      </Col>
                    </Row>

                    <Row className='mb-4'>
                      <Col sm={4}></Col>
                      <Col sm={8} className='d-flex align-items-center'>
                        <Form.Check
                          onClick={() => {
                            setIsNoEnduser(!isNoEnduser)
                          }}
                          defaultChecked={isNoEnduser}
                          name='noenduser'
                          disabled={disableCKBOX}
                          id='noenduser'
                          className='mt-5 mb-2'
                          type='checkbox'
                        />
                        {i18next.language == 'en' ? (
                          <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                        ) : (
                          <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                        )}
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-4'>
                          {t('sub-order-sektor')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={t('Domestik Korperasi')}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                      </Col>
                      <Col sm={8}>
                        {/* <Form.Control
                          size='sm'
                          aria-label='Default select example'
                          disabled
                          defaultValue={incotermId2Desc}
                        /> */}
                        <Form.Control defaultValue={incotermId2Desc} onChange={(e: any) => setIncoterm2(e.target?.value)} size='sm' aria-label='Default select example'/>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-kota')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='kota'
                          placeholder={t('pilih')}
                          key={province}
                          onChange={(e: any) => {
                            // fieldClearer(3)
                            separator2(e?.value, setCityProduct, setCityDesc)
                          }}
                          options={fullCity2}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-produk')}
                          <span className='text-danger'>*</span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <Select
                          id='produk'
                          placeholder={t('pilih')}
                          key={ptype + fullProductName}
                          defaultValue={
                            fullProductName[
                              fullProductName.findIndex(
                                (item: any) => item.truevalue == parseInt(pnumber)
                              )
                            ]
                          }
                          onChange={(e: any) => {
                            // setQuantum(0)
                            // fieldClearer(1)
                            // setSubprice(0)
                            setPunit(e?.unit)
                            separator3(e?.value, setPnumber, setPname)
                          }}
                          options={fullProductName}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>
                          {t('sub-order-hargaP')}/{ptype == '8105' ? punit : 'Ton'}
                          <span hidden={ptype == '8105' ? true : false} className='text-danger'>
                            *
                          </span>
                        </p>
                      </Col>
                      <Col sm={8}>
                        <InputGroup size='sm'>
                          <InputGroup.Text id='basic-addon2'>
                            <span className='px-1'>Rp</span>
                          </InputGroup.Text>
                          <CurrencyInput
                            className='form-control form-control-sm'
                            id='hargap'
                            // key={pname}
                            disabled={ptype == '8105' ? true : false}
                            defaultValue={subprice}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setSubprice(value?.replace(/,/g, '.'))
                            }}
                            decimalsLimit={-1}
                            placeholder={t('sub-order-hargaP')}
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('termasuk-ppn')}</p>
                      </Col>
                      <Col sm={8} className='d-flex justify-content-start'>
                        <Form.Check
                          reverse
                          name='ppn'
                          disabled={ptype == '8105' ? true : false}
                          className='mt-4 mb-2'
                          type='checkbox'
                          id='ckbox-ppn'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-payment2')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          disabled
                          placeholder={t('sub-order-payment2')}
                          size='sm'
                          value={pay2Desc}
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          placeholder={t('sub-order-spek')}
                          as='textarea'
                          id='spek'
                          size='sm'
                          style={{height: '40px'}}
                          onChange={(e: any) => setPspec(e.target.value)}
                        />
                      </Col>
                    </Row>
                    {parseInt(pnumber) != 0 && (
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            as='textarea'
                            placeholder={t('sub-order-catatan')}
                            id='note'
                            size='sm'
                            style={{height: '40px'}}
                            onChange={(e: any) => setNote(e.target.value)}
                          />
                        </Col>
                      </Row>
                    )}
                    {parseInt(pnumber) == 0 && (
                      <Row className='mb-4'>
                        <Col md={4}>
                          <p className='mt-3 fs-6'>
                            {t('segment')}
                            <span className='text-danger'>*</span>{' '}
                          </p>
                        </Col>
                        <Col md={8}>
                          <Form.Select
                            id='segment'
                            onChange={(e: any) => separator2(e.target.value, setSegment, setSegmentDesc)}
                            aria-label='Default select example'
                            size='sm'
                          >
                            <option hidden value=','>
                              {t('Pilih-segment')}
                            </option>
                            {fullSegment.map((item: any) => {
                              if (item.code == 'Z2' || item.code == 'Z3') {
                                return (
                                  <option value={item.code + ',' + item.name}>{item.name}</option>
                                )
                              } else {
                                return null
                              }
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </>
            )}
            <div className='d-flex justify-content-end mt-5'>
              <Button variant='primary' onClick={() => insertAddOrder()}>
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                {t('order-kirim')}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={showJadwal2}
          onHide={() => setShowJadwal2(false)}
          backdrop='static'
          keyboard={false}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {sektorID != '3' ? provinceName + ', ' + cityName + ' | ' : ''}
              {productName} | {fixedQuantum} {tipeProduct != '8105' ? 'Ton' : unitProduct}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            <div className='table-responsive bdr mt-1'>
              <table className='table-border w-100'>
                <thead>
                  <tr className='d-flex'>
                    {/* <th style={{ width: '60px' }} className="text-center">{t('order-aksi')}</th> */}
                    <th style={{width: '165.5px'}} className='text-center'>
                      {t('order-pengambilan')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-tanggal')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-minggu')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-bulan')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {t('order-tahun')}
                    </th>
                    <th style={{width: '185.5px'}} className='text-center'>
                      {tipeProduct != '8105' ? t('order-tonase') : t('sack')}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <div>
                    <tr className='d-flex'>
                      <td style={{width: '165.5px'}} className='text-center'>
                        <p className='mt-3'>{taking + 1}</p>
                      </td>
                      <td
                        style={{width: '185.5px'}}
                        className='text-center d-flex justify-content-center'
                      >
                        <Form.Select
                          aria-label='Default select example'
                          id='jadwaltanggal'
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          onChange={(e: any) => setTempTanggal(parseInt(e.target.value))}
                        >
                          <option selected value={0} disabled hidden>
                            {t('Pilih-Tanggal')}
                          </option>
                          {daysInMonth != 0 ? loopTanggal(daysInMonth) : ''}
                        </Form.Select>
                      </td>
                      <td
                        style={{width: '185.5px'}}
                        className='text-center d-flex justify-content-center'
                      >
                        <Form.Control
                          aria-label='Default select example'
                          id='jadwalminggu'
                          placeholder={t('order-minggu')}
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          defaultValue={
                            tempTanggal == 0 ? '' : t('Week') + Math.ceil(tempTanggal / 7)
                          }
                        />
                      </td>
                      <td
                        style={{width: '185.5px'}}
                        className='text-center d-flex justify-content-center'
                      >
                        <Form.Select
                          aria-label='Default select example'
                          id='jadwalbulan'
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          onChange={(e: any) => setTempBulan(parseInt(e.target.value))}
                        >
                          <option selected disabled>
                            {t('Pilih-Month')}
                          </option>
                          <option value='1'>{t('Januari')}</option>
                          <option value='2'>{t('Februari')}</option>
                          <option value='3'>{t('Maret')}</option>
                          <option value='4'>{t('April')}</option>
                          <option value='5'>{t('Mei')}</option>
                          <option value='6'>{t('Juni')}</option>
                          <option value='7'>{t('Juli')}</option>
                          <option value='8'>{t('Agustus')}</option>
                          <option value='9'>{t('September')}</option>
                          <option value='10'>{t('Oktober')}</option>
                          <option value='11'>{t('November')}</option>
                          <option value='12'>{t('Desember')}</option>
                        </Form.Select>
                      </td>
                      <td
                        style={{width: '185.5px'}}
                        className='text-center d-flex justify-content-center'
                      >
                        <Form.Select
                          aria-label='Default select example'
                          style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                          id='jadwaltahun'
                          onChange={(e: any) => setTempTahun(parseInt(e.target.value))}
                        >
                          <option selected disabled>
                            {t('Pilih-Year')}
                          </option>
                          {listYear.map((data: string, index: number) => {
                            return (
                              <option key={data ?? index} value={data}>
                                {data}
                              </option>
                            )
                          })}
                        </Form.Select>
                      </td>
                      <td
                        style={{width: '185.5px'}}
                        className='text-center d-flex justify-content-center'
                      >
                        <CurrencyInput
                          id='jadwalton'
                          className='form-control form-control-sm'
                          placeholder={tipeProduct != '8105' ? t('order-tonase') : t('sack')}
                          key={tempTahun}
                          style={{width: '90%'}}
                          decimalSeparator={language === 'en' ? '.' : ','}
                          groupSeparator={language === 'en' ? ',' : '.'}
                          onValueChange={(value: any) => {
                            setTempTon(parseFloat(value?.replace(/,/g, '.')))
                          }}
                          decimalsLimit={3}
                        />
                      </td>
                    </tr>
                  </div>
                </tbody>
                <div className='d-flex justify-content-end mt-5'>
                  <Button
                    variant='primary'
                    onClick={() => {
                      sendJadwal()
                    }}
                  >
                    {t('order-kirim')}
                  </Button>
                </div>
              </table>
            </div>
            <div
              className='table-responsive bdr mt-8'
              hidden={allJadwal?.length < 1 || allJadwal?.length == undefined ? true : false}
            >
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead className='border-bottom'>
                  <tr className='fw-bold d-flex'>
                    <th className='text-center' style={{width: '142.5px'}}>
                      {t('order-pengambilan')}
                    </th>
                    <th className='text-center' style={{width: '142.5px'}}>
                      {t('order-tanggal')}
                    </th>
                    <th className='text-center' style={{width: '142.5px'}}>
                      {t('order-minggu')}
                    </th>
                    <th className='text-center' style={{width: '142.5px'}}>
                      {t('order-bulan')}
                    </th>
                    <th className='text-center' style={{width: '142.5px'}}>
                      {t('order-tahun')}
                    </th>
                    <th className='text-center' style={{width: '142.5px'}}>
                      {tipeProduct != '8105' ? t('order-tonase') : t('sack')}
                    </th>
                    <th className='text-center' style={{width: '142.5px'}}>
                      {t('order-aksi')}
                    </th>
                  </tr>
                </thead>
                {allJadwal?.map((data, _index) => (
                  <tbody key={data?.date ?? _index}>
                    <tr className='d-flex'>
                      <td className='text-center' style={{width: '142.5px'}}>
                        <label className='mt-3'>{_index + 1}</label>
                      </td>
                      <td className='text-center' style={{width: '142.5px'}}>
                        <label className='mt-3'>{data.date}</label>
                      </td>
                      <td className='text-center' style={{width: '142.5px'}}>
                        <label className='mt-3'>
                          {t('Week')} {Math.ceil(data.date / 7)}
                        </label>
                      </td>
                      <td className='text-center' style={{width: '142.5px'}}>
                        <label className='mt-3'>{t(bulan[data.month - 1])}</label>
                      </td>
                      <td className='text-center' style={{width: '142.5px'}}>
                        <label className='mt-3'>{data.year}</label>
                      </td>
                      <td className='text-center' style={{width: '142.5px'}}>
                        {editedIndex == _index ? (
                          <CurrencyInput
                            id='ton'
                            placeholder={tipeProduct != '8105' ? t('order-tonase') : t('sack')}
                            className='form-control form-control-sm'
                            defaultValue={data.tonnage}
                            decimalSeparator={language === 'en' ? '.' : ','}
                            groupSeparator={language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setTempTon(parseFloat(value?.replace(/,/g, '.')))
                            }}
                            decimalsLimit={3}
                          />
                        ) : (
                          <label className='mt-3'>
                            {(i18next.language === 'en'
                              ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                              : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                              ' ' +
                              (tipeProduct != '8105' ? ' Ton' : ' EA')}
                          </label>
                        )}
                      </td>
                      <td style={{width: '142.5px'}} className='text-center'>
                        {editedIndex == _index ? (
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('Approve')}
                            onClick={() => rubahSchedule(_index, tempTon, data.tonnage)}
                          >
                            <KTSVG
                              path='/media/icons/duotune/check-square.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        ) : (
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('ubah')}
                            onClick={() => {
                              setEditedIndex(_index)
                              setTempTon(data.tonnage)
                            }}
                          >
                            <KTSVG
                              path='/media/icons/duotune/pencil-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}

                        <button
                          onClick={() => hapusSchedule(_index)}
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('Hapus')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/trash-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          size='lg'
          show={showUpload3}
          onHide={() => {
            setShowUpload3(false)
            setIsFileBox(false)
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isFileBox
                ? (idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : '') +
                  productName +
                  ' | ' +
                  fixedQuantum +
                  ' Ton'
                : ''}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6}>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-fileUnggah')}</h6>
                    </td>
                    <td className='w-75'>
                      <Form.Control
                        type='file'
                        accept='application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/png, image/jpeg'
                        id='upload2'
                        onChange={(e: any) => handleFile3(e)}
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3'>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('order-keterangan')}</h6>
                    </td>
                    <td className='w-75'>
                      <Form.Control
                        type='text'
                        id='uploadketerangan2'
                        placeholder={t('order-keterangan')}
                        onChange={(e: any) => setDescription(e.target.value)}
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3' hidden={isSalesOrSuperAdmin ? false : true}>
                  <tr>
                    <td>
                      <h6 className='me-11'>{t('Private')}</h6>
                    </td>
                    <td className='w-75 d-flex justify-content-start'>
                      <Form.Check
                        reverse
                        name='isPrivate'
                        type='checkbox'
                        className='mt-5 mb-2'
                        onClick={() => {
                          setIsPrivate(!isPrivate)
                        }}
                        id='isPrivate'
                      />
                    </td>
                  </tr>
                </table>
                <table className='mb-3' hidden={isPrivate ? false : true}>
                  <tr>
                    <td style={{width: '120px'}}>
                      <h6>{t('Akses Role')}</h6>
                    </td>
                    <td className='w-75' style={{maxWidth: '274px'}}>
                      <MultiSelect
                        key={isPrivate.toString()}
                        options={fullRole?.map((item: any) => {
                          return {label: item.label, value: item.value}
                        })}
                        value={tempRole}
                        onChange={(e: any) => setTempRole(e)}
                        labelledBy='Select'
                      />
                    </td>
                  </tr>
                </table>
                <div className='d-flex justify-content-end'>
                  {uploadType == 'header' ? (
                    <Button variant='primary' className='w-100' onClick={() => handleUpload2()}>
                      {t('order-kirim')}
                    </Button>
                  ) : (
                    <Button variant='primary' className='w-100' onClick={() => handleUpload3()}>
                      {t('order-kirim')}
                    </Button>
                  )}
                </div>
              </Col>
              <Col sm={6} className='mt-3'>
                {isexceed ? <span className='text-danger'>{t('File Exceed 2MB')}</span> : <></>}
              </Col>
              <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='fw-bold border-bottom'>
                    <tr className=''>
                      <th className='text-center'>{t('order-noo')}</th>
                      <th className='text-center'>{t('order-keterangan')}</th>
                      <th className='text-center'>{t('order-tglUpload')}</th>
                      {/* <th className='text-center'>{t('User Code')}</th> */}
                      <th className='text-center'>{t('order-user')}</th>
                      <th className='text-center'>{t('Akses Role')}</th>
                      <th className='text-center'>{t('order-aksi')}</th>
                    </tr>
                  </thead>
                  {uploadType == 'header' ? (
                    <>
                      {fileHeader
                        .slice(0)
                        .reverse()
                        .map((data: any, _index: number) => (
                          <tbody key={data?.id ?? _index}>
                            <tr className=''>
                              <td className='text-center'>
                                <label>{_index + 1}</label>
                              </td>
                              <td className='text-center'>
                                <label>{data.description}</label>
                              </td>
                              <td className='text-center'>
                                <label>{dateformat(getCurrentFormattedDate())}</label>
                              </td>
                              {/* <td className='text-center'>
                                <label>
                                  {localStorage.getItem('cust-code') !== 'null'
                                    ? localStorage.getItem('cust-code')
                                    : localStorage.getItem('user_code')}
                                </label>
                              </td> */}
                              <td className='text-center'>
                                <label>{localStorage.getItem('username')}</label>
                              </td>
                              <td className='text-center'>
                                {data.private ? (
                                  data.roles.length > 0 ? (
                                    <PopoverText
                                      content={handleShowRoleNameFromState(data.roles)}
                                      index={_index}
                                      className='desc-slice'
                                    />
                                  ) : (
                                    'Private'
                                  )
                                ) : (
                                  'Public'
                                )}
                              </td>
                              <td className='text-center'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('unduh')}
                                  onClick={() => handleDownloadBase64(data.file_r)}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrow-down-square-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                <button
                                  onClick={() =>
                                    handleDeleteUploadHeader(
                                      fileHeader.length - 1 - _index,
                                      fileHeader,
                                      setFileHeader,
                                      'header',
                                      tempData,
                                      setTempData
                                    )
                                  }
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('Hapus')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/trash-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                    </>
                  ) : (
                    <>
                      {orderItemFiles
                        .slice(0)
                        .reverse()
                        .map((data: any, _index: number) => (
                          <tbody key={data?.id ?? _index}>
                            <tr className=''>
                              <td className='text-center'>
                                <label>{_index + 1}</label>
                              </td>
                              <td className='text-center'>
                                <label>{data.description}</label>
                              </td>
                              <td className='text-center'>
                                <label>{dateformat(getCurrentFormattedDate())}</label>
                              </td>
                              {/* <td className='text-center'>
                                <label>
                                  {localStorage.getItem('cust-code') !== 'null'
                                    ? localStorage.getItem('cust-code')
                                    : localStorage.getItem('user_code')}
                                </label>
                              </td> */}
                              <td className='text-center'>
                                <label>{localStorage.getItem('username')}</label>
                              </td>
                              <td className='text-center'>
                                {data.private ? (
                                  data.roles.length > 0 ? (
                                    <PopoverText
                                      content={handleShowRoleNameFromState(data.roles)}
                                      index={_index}
                                      className='desc-slice'
                                    />
                                  ) : (
                                    'Private'
                                  )
                                ) : (
                                  'Public'
                                )}
                              </td>
                              <td className='text-center'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('unduh')}
                                  onClick={() => handleDownloadBase64(data.file_r)}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrow-down-square-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                <button
                                  onClick={() => {
                                    if (uploadType == 'so-item') {
                                      handleDeleteUploadHeader(
                                        orderItemFiles.length - 1 - _index,
                                        orderItemFiles,
                                        setOrderItemsFiles,
                                        'so-item',
                                        payloadAttachement,
                                        setPayloadAttachment
                                      )
                                    } else {
                                      handleDeleteUploadHeader(
                                        orderItemFiles.length - 1 - _index,
                                        orderItemFiles,
                                        setOrderItemsFiles,
                                        'order-item',
                                        tempData,
                                        setTempData
                                      )
                                    }
                                  }}
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('Hapus')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/trash-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                    </>
                  )}
                </table>
              </div>
            </Row>
          </Modal.Body>
        </Modal>

        <Modal
          show={showDetail}
          onHide={() => {
            setShowDetail(false)
          }}
          centered
          scrollable
          backdrop='static'
          size={'xl'}
        >
          <Modal.Header closeButton>
            <Modal.Title>Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>Sales Org</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail.produsen?.name}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail.incoterm1?.code}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4' hidden={tempDetail.sector_id == 3 ? true : false}>
                  <Col sm={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                  </Col>
                  <Col sm={8}>
                    <Form.Control
                      type='text'
                      size='sm'
                      value={tempDetail.province?.region_name}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail.product_type_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        (i18next.language === 'en'
                          ? quantumSO.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : quantumSO.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })) + (tempDetail?.sector_id === 3 ? ' MT' : ' Ton')
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col sm={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('Shipping Tolerance')}</p>
                  </Col>
                  <Col sm={8}>
                    <Form.Control
                      // placeholder={t('Shipping Tolerance')}
                      size='sm'
                      type='text'
                      id='shipping'
                      value={
                        !tempDetail.shipping_tolerance_contract ||
                        tempDetail.shipping_tolerance_contract == 0
                          ? tempDetail.shipping_tolerance == 0
                            ? ''
                            : tempDetail.shipping_tolerance + '%'
                          : tempDetail.shipping_tolerance_contract + '%'
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail.payment_type_1_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('keterangan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail.payment_note}
                      type='text'
                      as='textarea'
                      style={{height: '40px'}}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('End Customer')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        tempDetail.end_user_multiple
                          ? handleShowValue(tempDetail.end_user)
                          : tempDetail.end_user
                      }
                      as='textarea'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              </Col>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail.sector_id == 3 ? t('Export') : t('Domestic Korporasi')}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                  </Col>
                  <Col md={8}>
                    {tempDetail.incoterm2 == null ? (
                      <Form.Control
                        value={
                          tempDetail.incoterm2_id == null || tempDetail.incoterm2_id == '0'
                            ? ''
                            : tempDetail.incoterm2_id
                        }
                        type='text'
                        disabled
                        size='sm'
                      />
                    ) : (
                      <Form.Control
                        value={tempDetail.incoterm2?.code}
                        type='text'
                        disabled
                        size='sm'
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-4' hidden={tempDetail.sector_id == 3 ? true : false}>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      type='text'
                      value={tempDetail.city?.city_name}
                      size='sm'
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control value={tempDetail.product_name} type='text' disabled size='sm' />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='fs-6 mt-3'>
                      {t('Harga Pengajuan')}/{tempDetail.product_type == '8105' ? tempDetail.unit : 'Ton'}
                    </p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={
                        tempDetail.product_type == '8105'
                          ? ''
                          : i18next.language === 'en'
                          ? (tempDetail.sector_id == 3 ? 'USD' : 'Rp') +
                            parseFloat(
                              tempDetail.price_contract || tempDetail.fixed_price
                            ).toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : (tempDetail.sector_id == 3 ? 'USD' : 'Rp') +
                            parseFloat(
                              tempDetail.price_contract || tempDetail.fixed_price
                            ).toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })
                      }
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                  </Col>
                  <Col md={8}>
                    <FieldProductSpec data={tempDetail.product_spec} type='editor' />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail.payment_type_2_desc}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4' hidden={tempDetail.sector_id == 3 ? true : false}>
                  <Col md={4}>
                    <p className='fs-6 mt-3'>{t('segment')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={t(tempDetail.segment_name)}
                      type='text'
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      value={tempDetail.notes}
                      type='text'
                      as='textarea'
                      style={{height: '40px'}}
                      disabled
                      size='sm'
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    </>
  )
}

export {SOCreate}
